// import {
//   collection,
//   doc,
//   getDoc,
//   getDocs,
//   updateDoc,
//   addDoc,
//   query,
//   where,
//   orderBy,
//   limit,
//   startAfter,
//   Timestamp,
//   onSnapshot,
//   deleteDoc,
// } from "firebase/firestore";
// import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
// import { db, storage } from "./firebaseConfig";
// import jsPDF from "jspdf";

// // Get doctor dashboard statistics
// export const getDoctorStats = async (doctorId) => {
//   try {
//     // Get pending applications for review (not reviewed by any doctor)
//     const pendingQuery = query(
//       collection(db, "patientApplications"),
//       where("status", "in", ["submitted", "medical_review_pending"]),
//       where("workflow.medicalReview.status", "==", "pending")
//     );
//     const pendingSnapshot = await getDocs(pendingQuery);

//     // Get applications reviewed by this doctor
//     const reviewedQuery = query(
//       collection(db, "patientApplications"),
//       where("workflow.medicalVerification.verifiedBy", "==", doctorId)
//     );
//     const reviewedSnapshot = await getDocs(reviewedQuery);

//     // Get today's reviews
//     const today = new Date();
//     today.setHours(0, 0, 0, 0);
//     const todayTimestamp = Timestamp.fromDate(today);

//     let reviewedToday = 0;
//     let totalReviewTime = 0;
//     let approvedCount = 0;
//     let rejectedCount = 0;
//     let pendingInfoCount = 0;
//     let emergencyPending = 0;

//     // Count emergency cases in pending
//     pendingSnapshot.forEach((doc) => {
//       const data = doc.data();
//       if (data.emergency) {
//         emergencyPending++;
//       }
//     });

//     // Calculate stats from reviewed applications
//     reviewedSnapshot.forEach((doc) => {
//       const data = doc.data();
//       const reviewedAt = data.workflow?.medicalVerification?.verifiedAt;

//       if (reviewedAt && reviewedAt >= todayTimestamp) {
//         reviewedToday++;
//       }

//       if (data.workflow?.medicalVerification?.reviewTimeMinutes) {
//         totalReviewTime += data.workflow.medicalVerification.reviewTimeMinutes;
//       }

//       const status = data.workflow?.medicalVerification?.status;
//       if (status === "approved") approvedCount++;
//       else if (status === "rejected") rejectedCount++;
//       else if (status === "pending_info") pendingInfoCount++;
//     });

//     const averageReviewTime =
//       reviewedSnapshot.size > 0
//         ? Math.round(totalReviewTime / reviewedSnapshot.size)
//         : 0;

//     const approvalRate =
//       reviewedSnapshot.size > 0
//         ? Math.round((approvedCount / reviewedSnapshot.size) * 100)
//         : 0;

//     return {
//       success: true,
//       stats: {
//         pendingReview: pendingSnapshot.size,
//         reviewedToday,
//         totalReviewed: reviewedSnapshot.size,
//         averageReviewTime,
//         emergencyPending,
//         approvalRate,
//         approvedCount,
//         rejectedCount,
//         pendingInfoCount,
//       },
//     };
//   } catch (error) {
//     console.error("Error getting doctor stats:", error);
//     return {
//       success: false,
//       error: error.message,
//       stats: {
//         pendingReview: 0,
//         reviewedToday: 0,
//         totalReviewed: 0,
//         averageReviewTime: 0,
//         emergencyPending: 0,
//         approvalRate: 0,
//         approvedCount: 0,
//         rejectedCount: 0,
//         pendingInfoCount: 0,
//       },
//     };
//   }
// };
// export const approveApplicationForProcess = async (applicationId, doctorId, approvalData) => {
//   try {
//     const appQuery = query(
//       collection(db, "patientApplications"),
//       where("applicationId", "==", applicationId)
//     );
//     const appSnapshot = await getDocs(appQuery);

//     if (appSnapshot.empty) {
//       return { success: false, error: "Application not found" };
//     }

//     const appRef = doc(db, "patientApplications", appSnapshot.docs[0].id);

//     // Update application with early approval status
//     await updateDoc(appRef, {
//       status: "approved_for_process",
//       "workflow.medicalVerification.approvedForProcess": true,
//       "workflow.medicalVerification.approvedForProcessBy": doctorId,
//       "workflow.medicalVerification.approvedForProcessAt": new Date(),
//       "workflow.medicalVerification.approvalForProcessComments": approvalData.comments,
//       updatedAt: new Date(),
//     });

//     return {
//       success: true,
//       message: "Application approved for process successfully",
//     };
//   } catch (error) {
//     console.error("Error approving application for process:", error);
//     return {
//       success: false,
//       error: error.message,
//     };
//   }
// };
// const generateEnhancedKYPPDF = async (application, kypData) => {
//   try {
//     // Create a new jsPDF instance
//     const pdf = new jsPDF("p", "mm", "a4");
    
//     const currentDate = new Date().toLocaleDateString("en-IN", {
//       year: "numeric",
//       month: "long",
//       day: "numeric",
//     });

//     // Set font
//     pdf.setFont("helvetica");

//     // Header Section
//     pdf.setFontSize(20);
//     pdf.setTextColor(0, 51, 102); // Dark blue
//     pdf.text("KNOW YOUR POLICY (KYP)", 105, 20, { align: "center" });

//     // Case information table header
//     pdf.setFontSize(12);
//     pdf.setTextColor(0, 0, 0);
    
//     let currentY = 35;

//     // Create a professional table layout
//     const tableData = [
//       ["Case ID", "Policy No", "TPA Name", "Hospital Name", "Provisional Diagnosis"],
//       [
//         kypData.applicationDetails?.applicationId || "",
//         kypData.applicationDetails?.policyNumber || "",
//         kypData.applicationDetails?.tpaName || "Inhouse",
//         kypData.applicationDetails?.hospitalName || "",
//         kypData.applicationDetails?.diagnosis || ""
//       ],
//       ["Provisional Date of Admission", "", "", "", ""],
//       [kypData.applicationDetails?.admissionDate || "", "", "", "", ""]
//     ];

//     // Draw the main info table
//     const startX = 10;
//     const colWidth = 38;
//     const rowHeight = 8;

//     // Table headers
//     pdf.setFillColor(230, 230, 230);
//     pdf.rect(startX, currentY, colWidth * 5, rowHeight, 'F');
    
//     pdf.setFontSize(8);
//     pdf.setTextColor(0, 0, 0);
    
//     tableData[0].forEach((header, index) => {
//       pdf.text(header, startX + 2 + (index * colWidth), currentY + 5);
//     });

//     currentY += rowHeight;

//     // Table data
//     pdf.setFontSize(8);
//     tableData[1].forEach((data, index) => {
//       pdf.text(data, startX + 2 + (index * colWidth), currentY + 5);
//     });

//     currentY += rowHeight + 5;

//     // Second row of info
//     const secondRowData = [
//       ["First Inception Date", "Effective Date", "Expiry Date", "City", "Proposed Treatment type"],
//       [
//         application.policy?.inceptionDate || "N/A",
//         application.policy?.effectiveDate || "N/A", 
//         application.policy?.expiryDate || "N/A",
//         kypData.applicationDetails?.city || "",
//         kypData.applicationDetails?.treatmentType || ""
//       ],
//       ["Tentative Date of Discharge", "", "", "", ""],
//       [kypData.applicationDetails?.dischargeDate || "TBD", "", "", "", ""]
//     ];

//     // Draw second info section
//     pdf.setFillColor(230, 230, 230);
//     pdf.rect(startX, currentY, colWidth * 5, rowHeight, 'F');
    
//     secondRowData[0].forEach((header, index) => {
//       pdf.text(header, startX + 2 + (index * colWidth), currentY + 5);
//     });

//     currentY += rowHeight;

//     secondRowData[1].forEach((data, index) => {
//       pdf.text(data, startX + 2 + (index * colWidth), currentY + 5);
//     });

//     currentY += rowHeight + 5;

//     // Policy Type and Insurance Company section
//     const policyInfoData = [
//       ["Policy Type", "Insurance Company Name", "Is the policy Ported?", "Procedure Name"],
//       [
//         application.policy?.policyType || "Retail",
//         kypData.applicationDetails?.insuranceCompany || "",
//         "No",
//         kypData.applicationDetails?.procedureName || ""
//       ],
//       ["Corporate Name", "Intimation ID", "", ""],
//       [
//         application.policy?.corporateName || "Retail",
//         kypData.applicationDetails?.intimationId || "",
//         "", ""
//       ]
//     ];

//     // Draw policy info section
//     pdf.setFillColor(230, 230, 230);
//     pdf.rect(startX, currentY, colWidth * 4, rowHeight, 'F');
    
//     policyInfoData[0].forEach((header, index) => {
//       if (index < 4) pdf.text(header, startX + 2 + (index * colWidth), currentY + 5);
//     });

//     currentY += rowHeight;

//     policyInfoData[1].forEach((data, index) => {
//       if (index < 4) pdf.text(data, startX + 2 + (index * colWidth), currentY + 5);
//     });

//     currentY += rowHeight + 10;

//     // PRIMARY INSURED SECTION
//     pdf.setFontSize(10);
//     pdf.setTextColor(0, 51, 102);
//     pdf.text("PRIMARY INSURED NAME", startX, currentY);
//     pdf.text("Sum Insured(SI)", startX + 60, currentY);
//     pdf.text("Cumulative Bonus", startX + 100, currentY);
//     pdf.text("Topup SI", startX + 140, currentY);
//     pdf.text("EFFECTIVE COVERAGE", startX + 170, currentY);

//     currentY += 8;
//     pdf.setTextColor(0, 0, 0);
//     pdf.text(kypData.applicationDetails?.primaryInsuredName || application.patient?.name || "", startX, currentY);
//     pdf.text(`₹${(kypData.applicationDetails?.sumInsured || 0).toLocaleString("en-IN")}`, startX + 60, currentY);
//     pdf.text(`₹${(kypData.applicationDetails?.cumulativeBonus || 0).toLocaleString("en-IN")}`, startX + 100, currentY);
//     pdf.text(`₹${(kypData.applicationDetails?.topupSI || 0).toLocaleString("en-IN")}`, startX + 140, currentY);
//     pdf.text(`₹${(kypData.applicationDetails?.effectiveCoverage || 0).toLocaleString("en-IN")}`, startX + 170, currentY);

//     currentY += 15;

//     // INSURED DETAILS SECTION
//     const insuredDetailsData = [
//       ["INSURED NAME", "Pre Hospitalisation", "Post Hospitalisation", "Waiting Periods"],
//       ["", "", "", "30 Days"],
//       ["", "", "", "Specific"],
//       [application.patient?.name || "", "N/A", "N/A", "2 Years"],
//       ["", "", "", "PED"],
//       ["", "", "", "4 Years"]
//     ];

//     // Draw insured details
//     pdf.setFillColor(230, 230, 230);
//     pdf.rect(startX, currentY, colWidth * 4, rowHeight, 'F');
    
//     pdf.setFontSize(8);
//     pdf.setTextColor(0, 51, 102);
//     insuredDetailsData[0].forEach((header, index) => {
//       pdf.text(header, startX + 2 + (index * colWidth), currentY + 5);
//     });

//     currentY += rowHeight;

//     // Fill in the waiting periods data
//     pdf.setTextColor(0, 0, 0);
//     for (let i = 1; i < insuredDetailsData.length; i++) {
//       if (i === 3) { // Main insured row
//         pdf.text(insuredDetailsData[i][0], startX + 2, currentY + 5);
//         pdf.text(insuredDetailsData[i][1], startX + 2 + colWidth, currentY + 5);
//         pdf.text(insuredDetailsData[i][2], startX + 2 + (2 * colWidth), currentY + 5);
//         pdf.text(insuredDetailsData[i][3], startX + 2 + (3 * colWidth), currentY + 5);
//       } else {
//         pdf.text(insuredDetailsData[i][3], startX + 2 + (3 * colWidth), currentY + 5);
//       }
//       currentY += (rowHeight / 2);
//     }

//     currentY += 10;

//     // RELATIONSHIP AND BENEFITS SECTION
//     const benefitsData = [
//       ["RELATIONSHIP WITH PRIMARY", "Eligible Room", "ICU/ICCU", "Ambulance cover", "Ayush Treatment"],
//       [
//         kypData.applicationDetails?.relationshipWithPrimary || "Self",
//         kypData.roomEligibility || "Single Standard AC Room",
//         "As per actual",
//         "N/A",
//         "N/A"
//       ],
//       ["BENEFICIARY", "", "", "Hospital Daily Cash", ""],
//       ["", "", "", "N/A", ""]
//     ];

//     // Draw benefits section
//     pdf.setFillColor(230, 230, 230);
//     pdf.rect(startX, currentY, colWidth * 5, rowHeight, 'F');
    
//     pdf.setFontSize(8);
//     pdf.setTextColor(0, 51, 102);
//     benefitsData[0].forEach((header, index) => {
//       pdf.text(header, startX + 2 + (index * colWidth), currentY + 5);
//     });

//     currentY += rowHeight;

//     pdf.setTextColor(0, 0, 0);
//     benefitsData[1].forEach((data, index) => {
//       pdf.text(data, startX + 2 + (index * colWidth), currentY + 5);
//     });

//     currentY += rowHeight + 10;

//     // FINANCIAL DETAILS SECTION
//     const financialData = [
//       ["INSURED NAME", "HEALTH CHECK UP", "Co-Pay/deductible", "Sub-Limit", "Balance Sum Insured"],
//       [
//         application.patient?.name || "",
//         "N/A",
//         kypData.coPay || "10%",
//         kypData.subLimit || "No update",
//         `₹${(kypData.applicationDetails?.balanceSumInsured || 0).toLocaleString("en-IN")}`
//       ]
//     ];

//     // Draw financial section
//     pdf.setFillColor(230, 230, 230);
//     pdf.rect(startX, currentY, colWidth * 5, rowHeight, 'F');
    
//     pdf.setFontSize(8);
//     pdf.setTextColor(0, 51, 102);
//     financialData[0].forEach((header, index) => {
//       pdf.text(header, startX + 2 + (index * colWidth), currentY + 5);
//     });

//     currentY += rowHeight;

//     pdf.setTextColor(0, 0, 0);
//     financialData[1].forEach((data, index) => {
//       pdf.text(data, startX + 2 + (index * colWidth), currentY + 5);
//     });

//     currentY += rowHeight + 15;

//     // INITIAL REMARKS SECTION
//     pdf.setFontSize(10);
//     pdf.setTextColor(0, 51, 102);
//     pdf.text("Initial Remarks", startX, currentY);

//     currentY += 8;
//     pdf.setFontSize(9);
//     pdf.setTextColor(0, 0, 0);
    
//     const remarksText = `KYP authorised basis available information in the documents shared by the hospital. Submit bill, summary and all discharge documents at the time of discharge.

// ROOM ELIGIBILITY AS MENTIONED ABOVE. IF THE PATIENT/INSURED OCCUPIES ROOM BEYOND HIS/ENTITLED CATEGORY OR LIMIT, THEN, ALL THE ROOM ASSOCIATED CHARGES WILL BE PROPORTIONATELY RESTRICTED IN ACCORDANCE TO THE ROOM ELIGIBILITY.

// DISBURSEMENT APPROVED: ₹${(kypData.approvedDisbursementAmount || 0).toLocaleString("en-IN")} (${kypData.disbursementPercentage || 0}% of estimated cost)

// Medical Review Comments: ${kypData.clinicalNotes || "Standard medical protocols followed."}

// Waiting Periods: ${kypData.waitingPeriod || "30 Days"} general, ${kypData.specificWaiting || "2 Years"} specific diseases, ${kypData.pedWaiting || "4 Years"} PED

// This KYP is valid for ${kypData.validityPeriod || "15 days"} from date of issue.

// Generated by: Dr. ${kypData.doctorName || "Medical Review Specialist"}
// Registration No: ${kypData.registrationNo || "MED-001"}
// Date: ${currentDate}`;

//     const remarksLines = pdf.splitTextToSize(remarksText, 180);
//     pdf.text(remarksLines, startX, currentY);

//     currentY += remarksLines.length * 4 + 10;

//     // Footer
//     pdf.setFontSize(8);
//     pdf.setTextColor(100, 100, 100);
//     pdf.text(
//       "This is a digitally generated KYP letter by SamHealth Medical Review System.",
//       105,
//       280,
//       { align: "center" }
//     );
//     pdf.text(
//       `Generated on: ${currentDate} | Verification Code: KYP-${Date.now().toString().slice(-8)}`,
//       105,
//       285,
//       { align: "center" }
//     );

//     // Return the PDF as blob
//     return pdf.output("blob");
//   } catch (error) {
//     console.error("Error generating enhanced KYP PDF:", error);
//     // Fallback to text-based content if PDF generation fails
//     const kypContent = generateEnhancedKYPContent(application, kypData);
//     return new Blob([kypContent], { type: "text/plain" });
//   }
// };
// // Get applications pending doctor review (not reviewed by any doctor)
// export const getDoctorApplications = async (
//   filters = {},
//   page = 1,
//   pageSize = 10
// ) => {
//   try {
//     let q = collection(db, "patientApplications");

//     // Base filter - only pending medical verification and not under review
//     q = query(
//       q,
//       where("workflow.medicalVerification.status", "==", "pending"),
//       where("status", "in", ["submitted", "medical_review_pending", "under_medical_review"])
//     );

//     // Apply status filter
//     if (filters.status && filters.status !== "") {
//       q = query(q, where("status", "==", filters.status));
//     }

//     // Apply priority filter
//     if (filters.priority && filters.priority !== "") {
//       q = query(q, where("priority", "==", filters.priority));
//     }

//     // Apply emergency filter
//     if (filters.emergency !== "" && filters.emergency !== undefined) {
//       const isEmergency = filters.emergency === "true";
//       q = query(q, where("emergency", "==", isEmergency));
//     }

//     // Apply treatment type filter
//     if (filters.treatmentType && filters.treatmentType !== "") {
//       q = query(q, where("medical.treatmentType", "==", filters.treatmentType));
//     }

//     // Apply insurance company filter
//     if (filters.insuranceCompany && filters.insuranceCompany !== "") {
//       q = query(
//         q,
//         where("policy.insuranceCompany", "==", filters.insuranceCompany)
//       );
//     }

//     // Apply hospital filter
//     if (filters.hospitalName && filters.hospitalName !== "") {
//       q = query(q, where("hospitalName", "==", filters.hospitalName));
//     }

//     // Order by priority and submission date (emergency first)
//     q = query(q, orderBy("emergency", "desc"), orderBy("submittedAt", "desc"));

//     const querySnapshot = await getDocs(q);
//     let applications = [];

//     querySnapshot.forEach((doc) => {
//       const data = doc.data();

//       // Exclude applications currently under review by other doctors
//       // if (data.workflow?.medicalReview?.status !== "in_progress") {
//         applications.push({
//           id: doc.id,
//           ...data,
//         });
//       // }
//     });

//     // Client-side filtering for search term
//     if (filters.searchTerm && filters.searchTerm.trim() !== "") {
//       const searchTerm = filters.searchTerm.toLowerCase();
//       applications = applications.filter(
//         (app) =>
//           app.applicationId?.toLowerCase().includes(searchTerm) ||
//           app.patient?.name?.toLowerCase().includes(searchTerm) ||
//           app.medical?.diagnosis?.toLowerCase().includes(searchTerm) ||
//           app.hospitalName?.toLowerCase().includes(searchTerm) ||
//           app.medical?.doctor?.name?.toLowerCase().includes(searchTerm)
//       );
//     }

//     // Client-side date filtering
//     if (filters.dateFrom && filters.dateFrom !== "") {
//       const fromDate = new Date(filters.dateFrom);
//       applications = applications.filter((app) => {
//         const submittedDate = app.submittedAt?.toDate
//           ? app.submittedAt.toDate()
//           : new Date(app.submittedAt);
//         return submittedDate >= fromDate;
//       });
//     }

//     if (filters.dateTo && filters.dateTo !== "") {
//       const toDate = new Date(filters.dateTo);
//       toDate.setHours(23, 59, 59, 999);
//       applications = applications.filter((app) => {
//         const submittedDate = app.submittedAt?.toDate
//           ? app.submittedAt.toDate()
//           : new Date(app.submittedAt);
//         return submittedDate <= toDate;
//       });
//     }

//     // Apply amount range filters
//     if (filters.minAmount && filters.minAmount !== "") {
//       const minAmount = parseFloat(filters.minAmount);
//       applications = applications.filter(
//         (app) => (app.medical?.estimatedCost || 0) >= minAmount
//       );
//     }

//     if (filters.maxAmount && filters.maxAmount !== "") {
//       const maxAmount = parseFloat(filters.maxAmount);
//       applications = applications.filter(
//         (app) => (app.medical?.estimatedCost || 0) <= maxAmount
//       );
//     }

//     // Pagination
//     const total = applications.length;
//     const startIndex = (page - 1) * pageSize;
//     const paginatedApplications = applications.slice(
//       startIndex,
//       startIndex + pageSize
//     );

//     return {
//       success: true,
//       applications: paginatedApplications,
//       total,
//       page,
//       pageSize,
//       totalPages: Math.ceil(total / pageSize),
//     };
//   } catch (error) {
//     console.error("Error getting doctor applications:", error);
//     return {
//       success: false,
//       error: error.message,
//       applications: [],
//       total: 0,
//     };
//   }
// };


// export const getAllApplicationsAdmin = async (
//   filters = {},
//   page = 1,
//   pageSize = 10
// ) => {
//   try {
//     let q = collection(db, "patientApplications");

//     // Base filter - only pending medical verification and not under review
//     q = query(
//       q
//     );

//     // Apply status filter
//     if (filters.status && filters.status !== "") {
//       q = query(q, where("status", "==", filters.status));
//     }

//     // Apply priority filter
//     if (filters.priority && filters.priority !== "") {
//       q = query(q, where("priority", "==", filters.priority));
//     }

//     // Apply emergency filter
//     if (filters.emergency !== "" && filters.emergency !== undefined) {
//       const isEmergency = filters.emergency === "true";
//       q = query(q, where("emergency", "==", isEmergency));
//     }

//     // Apply treatment type filter
//     if (filters.treatmentType && filters.treatmentType !== "") {
//       q = query(q, where("medical.treatmentType", "==", filters.treatmentType));
//     }

//     // Apply insurance company filter
//     if (filters.insuranceCompany && filters.insuranceCompany !== "") {
//       q = query(
//         q,
//         where("policy.insuranceCompany", "==", filters.insuranceCompany)
//       );
//     }

//     // Apply hospital filter
//     if (filters.hospitalName && filters.hospitalName !== "") {
//       q = query(q, where("hospitalName", "==", filters.hospitalName));
//     }

//     // Order by priority and submission date (emergency first)
//     q = query(q, orderBy("emergency", "desc"), orderBy("submittedAt", "desc"));

//     const querySnapshot = await getDocs(q);
//     let applications = [];

//     querySnapshot.forEach((doc) => {
//       const data = doc.data();

//       // Exclude applications currently under review by other doctors
//       // if (data.workflow?.medicalReview?.status !== "in_progress") {
//         applications.push({
//           id: doc.id,
//           ...data,
//         });
//       // }
//     });

//     // Client-side filtering for search term
//     if (filters.searchTerm && filters.searchTerm.trim() !== "") {
//       const searchTerm = filters.searchTerm.toLowerCase();
//       applications = applications.filter(
//         (app) =>
//           app.applicationId?.toLowerCase().includes(searchTerm) ||
//           app.patient?.name?.toLowerCase().includes(searchTerm) ||
//           app.medical?.diagnosis?.toLowerCase().includes(searchTerm) ||
//           app.hospitalName?.toLowerCase().includes(searchTerm) ||
//           app.medical?.doctor?.name?.toLowerCase().includes(searchTerm)
//       );
//     }

//     // Client-side date filtering
//     if (filters.dateFrom && filters.dateFrom !== "") {
//       const fromDate = new Date(filters.dateFrom);
//       applications = applications.filter((app) => {
//         const submittedDate = app.submittedAt?.toDate
//           ? app.submittedAt.toDate()
//           : new Date(app.submittedAt);
//         return submittedDate >= fromDate;
//       });
//     }

//     if (filters.dateTo && filters.dateTo !== "") {
//       const toDate = new Date(filters.dateTo);
//       toDate.setHours(23, 59, 59, 999);
//       applications = applications.filter((app) => {
//         const submittedDate = app.submittedAt?.toDate
//           ? app.submittedAt.toDate()
//           : new Date(app.submittedAt);
//         return submittedDate <= toDate;
//       });
//     }

//     // Apply amount range filters
//     if (filters.minAmount && filters.minAmount !== "") {
//       const minAmount = parseFloat(filters.minAmount);
//       applications = applications.filter(
//         (app) => (app.medical?.estimatedCost || 0) >= minAmount
//       );
//     }

//     if (filters.maxAmount && filters.maxAmount !== "") {
//       const maxAmount = parseFloat(filters.maxAmount);
//       applications = applications.filter(
//         (app) => (app.medical?.estimatedCost || 0) <= maxAmount
//       );
//     }

//     // Pagination
//     const total = applications.length;
//     const startIndex = (page - 1) * pageSize;
//     const paginatedApplications = applications.slice(
//       startIndex,
//       startIndex + pageSize
//     );

//     return {
//       success: true,
//       applications: paginatedApplications,
//       total,
//       page,
//       pageSize,
//       totalPages: Math.ceil(total / pageSize),
//     };
//   } catch (error) {
//     console.error("Error getting doctor applications:", error);
//     return {
//       success: false,
//       error: error.message,
//       applications: [],
//       total: 0,
//     };
//   }
// };

// // Get applications reviewed by specific doctor
// export const getDoctorReviewedApplications = async (
//   doctorId,
//   filters = {},
//   page = 1,
//   pageSize = 10
// ) => {
//   try {
//     let q = collection(db, "patientApplications");

//     // Base filter - only applications reviewed by this doctor
//     q = query(
//       q,
//       where("workflow.medicalVerification.verifiedBy", "==", doctorId)
//     );

//     // Apply status filter if provided
//     if (filters.status && filters.status !== "") {
//       q = query(
//         q,
//         where("workflow.medicalVerification.status", "==", filters.status)
//       );
//     }

//     // Order by review date (newest first)
//     q = query(q, orderBy("workflow.medicalVerification.verifiedAt", "desc"));

//     const querySnapshot = await getDocs(q);
//     let applications = [];

//     querySnapshot.forEach((doc) => {
//       applications.push({
//         id: doc.id,
//         ...doc.data(),
//       });
//     });

//     // Client-side filtering for search term
//     if (filters.searchTerm && filters.searchTerm.trim() !== "") {
//       const searchTerm = filters.searchTerm.toLowerCase();
//       applications = applications.filter(
//         (app) =>
//           app.applicationId?.toLowerCase().includes(searchTerm) ||
//           app.patient?.name?.toLowerCase().includes(searchTerm) ||
//           app.medical?.diagnosis?.toLowerCase().includes(searchTerm) ||
//           app.hospitalName?.toLowerCase().includes(searchTerm)
//       );
//     }

//     // Date range filtering for review date
//     if (filters.dateFrom && filters.dateFrom !== "") {
//       const fromDate = new Date(filters.dateFrom);
//       applications = applications.filter((app) => {
//         const reviewDate =
//           app.workflow?.medicalVerification?.verifiedAt?.toDate();
//         return reviewDate && reviewDate >= fromDate;
//       });
//     }

//     if (filters.dateTo && filters.dateTo !== "") {
//       const toDate = new Date(filters.dateTo);
//       toDate.setHours(23, 59, 59, 999);
//       applications = applications.filter((app) => {
//         const reviewDate =
//           app.workflow?.medicalVerification?.verifiedAt?.toDate();
//         return reviewDate && reviewDate <= toDate;
//       });
//     }

//     // Pagination
//     const total = applications.length;
//     const startIndex = (page - 1) * pageSize;
//     const paginatedApplications = applications.slice(
//       startIndex,
//       startIndex + pageSize
//     );

//     return {
//       success: true,
//       applications: paginatedApplications,
//       total,
//       page,
//       pageSize,
//       totalPages: Math.ceil(total / pageSize),
//     };
//   } catch (error) {
//     console.error("Error getting reviewed applications:", error);
//     return {
//       success: false,
//       error: error.message,
//       applications: [],
//       total: 0,
//     };
//   }
// };

// // Get single application for review
// export const getPatientApplication = async (applicationId) => {
//   try {
//     const q = query(
//       collection(db, "patientApplications"),
//       where("applicationId", "==", applicationId)
//     );
//     const querySnapshot = await getDocs(q);

//     if (querySnapshot.empty) {
//       return { success: false, error: "Application not found" };
//     }

//     const applicationDoc = querySnapshot.docs[0];
//     const application = {
//       id: applicationDoc.id,
//       ...applicationDoc.data(),
//     };

//     return {
//       success: true,
//       application,
//     };
//   } catch (error) {
//     console.error("Error getting application:", error);
//     return {
//       success: false,
//       error: error.message,
//     };
//   }
// };

// // Start application review - Begin timer and lock application
// export const startApplicationReview = async (applicationId, doctorId) => {
//   try {
//     // Get application
//     const appQuery = query(
//       collection(db, "patientApplications"),
//       where("applicationId", "==", applicationId)
//     );
//     const appSnapshot = await getDocs(appQuery);

//     if (appSnapshot.empty) {
//       return { success: false, error: "Application not found" };
//     }

//     const appDoc = appSnapshot.docs[0];
//     const appData = appDoc.data();

//     // Check if already under review by another doctor
//     if (
//       appData.workflow?.medicalReview?.status === "in_progress" &&
//       appData.workflow?.medicalReview?.reviewerId !== doctorId
//     ) {
//       return {
//         success: false,
//         error: "Application is already under review by another doctor",
//       };
//     }

//     // Start review
//     const reviewStartTime = new Date();
//     const appRef = doc(db, "patientApplications", appDoc.id);

//     await updateDoc(appRef, {
//       "workflow.medicalReview.status": "in_progress",
//       "workflow.medicalReview.reviewerId": doctorId,
//       "workflow.medicalReview.reviewStartTime": reviewStartTime,
//       "workflow.medicalReview.lastActivityTime": reviewStartTime,
//       status: "under_medical_review",
//       updatedAt: new Date(),
//     });

//     // Set up auto-timeout (15 minutes)
//     setTimeout(async () => {
//       try {
//         const currentDoc = await getDoc(appRef);
//         if (!currentDoc.exists()) return;

//         const currentData = currentDoc.data();

//         // Check if still in progress and no recent activity
//         if (
//           currentData.workflow?.medicalReview?.status === "in_progress" &&
//           currentData.workflow?.medicalReview?.reviewerId === doctorId
//         ) {
//           const lastActivity =
//             currentData.workflow?.medicalReview?.lastActivityTime?.toDate();
//           const now = new Date();
//           const timeDiff = now - lastActivity;

//           // If more than 15 minutes of inactivity, reset
//           if (timeDiff > 15 * 60 * 1000) {
//             await updateDoc(appRef, {
//               "workflow.medicalReview.status": "pending",
//               "workflow.medicalReview.reviewerId": null,
//               "workflow.medicalReview.reviewStartTime": null,
//               "workflow.medicalReview.lastActivityTime": null,
//               status: "medical_review_pending",
//               updatedAt: new Date(),
//             });
//           }
//         }
//       } catch (error) {
//         console.error("Error in auto-timeout:", error);
//       }
//     }, 15 * 60 * 1000); // 15 minutes

//     return {
//       success: true,
//       message: "Review started successfully",
//     };
//   } catch (error) {
//     console.error("Error starting review:", error);
//     return {
//       success: false,
//       error: error.message,
//     };
//   }
// };

// // Update review activity to prevent timeout
// export const updateReviewActivity = async (applicationId, doctorId) => {
//   try {
//     const appQuery = query(
//       collection(db, "patientApplications"),
//       where("applicationId", "==", applicationId)
//     );
//     const appSnapshot = await getDocs(appQuery);

//     if (appSnapshot.empty) {
//       return { success: false, error: "Application not found" };
//     }

//     const appRef = doc(db, "patientApplications", appSnapshot.docs[0].id);

//     await updateDoc(appRef, {
//       "workflow.medicalReview.lastActivityTime": new Date(),
//     });

//     return { success: true };
//   } catch (error) {
//     console.error("Error updating review activity:", error);
//     return { success: false, error: error.message };
//   }
// };

// // Pause application review
// export const pauseApplicationReview = async (applicationId, doctorId) => {
//   try {
//     const appQuery = query(
//       collection(db, "patientApplications"),
//       where("applicationId", "==", applicationId)
//     );
//     const appSnapshot = await getDocs(appQuery);

//     if (appSnapshot.empty) {
//       return { success: false, error: "Application not found" };
//     }

//     const appRef = doc(db, "patientApplications", appSnapshot.docs[0].id);

//     await updateDoc(appRef, {
//       "workflow.medicalReview.status": "pending",
//       "workflow.medicalReview.reviewerId": null,
//       "workflow.medicalReview.reviewStartTime": null,
//       "workflow.medicalReview.lastActivityTime": null,
//       status: "medical_review_pending",
//       updatedAt: new Date(),
//     });

//     return {
//       success: true,
//       message: "Review paused successfully",
//     };
//   } catch (error) {
//     console.error("Error pausing review:", error);
//     return {
//       success: false,
//       error: error.message,
//     };
//   }
// };

// // Complete medical review
// export const completeMedicalReview = async (
//   applicationId,
//   doctorId,
//   reviewData
// ) => {
//   try {
//     const appQuery = query(
//       collection(db, "patientApplications"),
//       where("applicationId", "==", applicationId)
//     );
//     const appSnapshot = await getDocs(appQuery);

//     if (appSnapshot.empty) {
//       return { success: false, error: "Application not found" };
//     }

//     const appDoc = appSnapshot.docs[0];
//     const appData = appDoc.data();
//     const appRef = doc(db, "patientApplications", appDoc.id);

//     // Calculate review time
//     const reviewStartTime =
//       appData.workflow?.medicalReview?.reviewStartTime?.toDate();
//     const reviewEndTime = new Date();
//     const reviewTimeMinutes = reviewStartTime
//       ? Math.round((reviewEndTime - reviewStartTime) / (1000 * 60))
//       : 0;

//     // Update application with review results
//     const updateData = {
//       "workflow.medicalVerification.status": reviewData.status, // approved, rejected, pending_info
//       "workflow.medicalVerification.verifiedBy": doctorId,
//       "workflow.medicalVerification.verifiedAt": new Date(),
//       "workflow.medicalVerification.comments": reviewData.comments || "",
//       "workflow.medicalVerification.reviewTimeMinutes": reviewTimeMinutes,
//       "workflow.medicalReview.status": "completed",
//       "workflow.medicalReview.reviewerId": null,
//       "workflow.medicalReview.reviewStartTime": null,
//       "workflow.medicalReview.lastActivityTime": null,
//       updatedAt: new Date(),
//     };

//     // Update main status based on review result
//     if (reviewData.status === "approved") {
//       updateData.status = "medical_approved";
//     } else if (reviewData.status === "rejected") {
//       updateData.status = "medical_rejected";
//     } else if (reviewData.status === "pending_info") {
//       updateData.status = "pending_documents";
//     }

//     // Add KYP data if provided (with disbursement amount)
//     if (reviewData.kypData) {
//       updateData["workflow.medicalVerification.kypData"] = reviewData.kypData;
//       updateData["workflow.medicalVerification.approvedDisbursementAmount"] =
//         reviewData.kypData.approvedDisbursementAmount || 0;
//     }

//     // Add discharge review data if provided (with uploaded files)
//     if (reviewData.dischargeReview) {
//       updateData["workflow.medicalVerification.dischargeReview"] =
//         reviewData.dischargeReview;
//       updateData[
//         "workflow.medicalVerification.dischargeReviewCompleted"
//       ] = true;
//       updateData["workflow.medicalVerification.finalApprovedAmount"] =
//         reviewData.dischargeReview.totals?.totalEligible || 0;
//     }

//     await updateDoc(appRef, updateData);

//     return {
//       success: true,
//       message: "Medical review completed successfully",
//     };
//   } catch (error) {
//     console.error("Error completing medical review:", error);
//     return {
//       success: false,
//       error: error.message,
//     };
//   }
// };

// // Create clarification request (Discussion/Chat functionality)
// export const createClarificationRequest = async (
//   applicationId,
//   doctorId,
//   questions
// ) => {
//   try {
//     const clarificationData = {
//       applicationId,
//       requestedBy: doctorId,
//       requestedAt: new Date(),
//       status: "pending", // pending, answered, resolved
//       type: "medical_clarification",
//       questions: questions.map((q, index) => ({
//         id: `q_${Date.now()}_${index}`,
//         question: q.question,
//         required: q.required || false,
//         answerType: q.answerType || "text", // text, file, both
//         description: q.description || "",
//         answer: null,
//         answerFiles: [],
//         answeredAt: null,
//         answeredBy: null,
//       })),
//     };

//     // Add to clarifications collection
//     const clarificationRef = await addDoc(
//       collection(db, "clarifications"),
//       clarificationData
//     );

//     // Update application status
//     const appQuery = query(
//       collection(db, "patientApplications"),
//       where("applicationId", "==", applicationId)
//     );
//     const appSnapshot = await getDocs(appQuery);

//     if (!appSnapshot.empty) {
//       const appRef = doc(db, "patientApplications", appSnapshot.docs[0].id);
//       await updateDoc(appRef, {
//         status: "pending_clarification",
//         "workflow.medicalVerification.status": "pending_info",
//         "workflow.medicalVerification.clarificationRequestId":
//           clarificationRef.id,
//         updatedAt: new Date(),
//       });
//     }

//     return {
//       success: true,
//       clarificationId: clarificationRef.id,
//       message: "Clarification request sent successfully",
//     };
//   } catch (error) {
//     console.error("Error creating clarification request:", error);
//     return {
//       success: false,
//       error: error.message,
//     };
//   }
// };

// // Get clarification requests for application
// export const getClarificationRequests = async (applicationId) => {
//   try {
//     const q = query(
//       collection(db, "clarifications"),
//       where("applicationId", "==", applicationId),
//       orderBy("requestedAt", "desc")
//     );

//     const querySnapshot = await getDocs(q);
//     const clarifications = [];

//     querySnapshot.forEach((doc) => {
//       clarifications.push({
//         id: doc.id,
//         ...doc.data(),
//       });
//     });

//     return {
//       success: true,
//       clarifications,
//     };
//   } catch (error) {
//     console.error("Error getting clarification requests:", error);
//     return {
//       success: false,
//       error: error.message,
//       clarifications: [],
//     };
//   }
// };

// // Enhanced Generate KYP Letter with PDF generation and disbursement approval
// export const generateKYPLetter = async (applicationId, doctorId, kypData) => {
//   try {
//     // Get application data
//     const appQuery = query(
//       collection(db, "patientApplications"),
//       where("applicationId", "==", applicationId)
//     );
//     const appSnapshot = await getDocs(appQuery);

//     if (appSnapshot.empty) {
//       return { success: false, error: "Application not found" };
//     }

//     const application = appSnapshot.docs[0].data();
//     const sanitizeValue = (value, defaultValue = '') => {
//       if (value === undefined || value === null) {
//         return defaultValue;
//       }
//       return value;
//     };

//     // Helper function to sanitize object recursively
//     const sanitizeObject = (obj) => {
//       if (obj === null || obj === undefined) {
//         return {};
//       }
      
//       const sanitized = {};
//       for (const [key, value] of Object.entries(obj)) {
//         if (value === undefined || value === null) {
//           sanitized[key] = '';
//         } else if (typeof value === 'object' && !Array.isArray(value) && !(value instanceof Date)) {
//           sanitized[key] = sanitizeObject(value);
//         } else if (Array.isArray(value)) {
//           sanitized[key] = value.map(item => 
//             typeof item === 'object' ? sanitizeObject(item) : sanitizeValue(item)
//           );
//         } else {
//           sanitized[key] = value;
//         }
//       }
//       return sanitized;
//     };

//     // Sanitize kypData to remove undefined values
//     const sanitizedKypData = sanitizeObject(kypData);
//     const safeKypData = {
//       ...sanitizedKypData,
//       applicationDetails: {
//         applicationId: sanitizeValue(
//           kypData.applicationDetails?.applicationId,
//           applicationId
//         ),
//         patientName: sanitizeValue(
//           kypData.applicationDetails?.patientName,
//           application.patient?.name || ""
//         ),
//         diagnosis: sanitizeValue(
//           kypData.applicationDetails?.diagnosis,
//           application.medical?.diagnosis || ""
//         ),
//         hospitalName: sanitizeValue(
//           kypData.applicationDetails?.hospitalName,
//           application.hospitalName ||
//             application.hospital?.name ||
//             "Hospital Name Not Available"
//         ),
//         insuranceCompany: sanitizeValue(
//           kypData.applicationDetails?.insuranceCompany,
//           application.policy?.insuranceCompany || ""
//         ),
//         policyNumber: sanitizeValue(
//           kypData.applicationDetails?.policyNumber,
//           application.policy?.number || ""
//         ),
//         estimatedCost:
//           kypData.applicationDetails?.estimatedCost ||
//           application.medical?.estimatedCost ||
//           0,
//       },
//       approvedDisbursementAmount: kypData.approvedDisbursementAmount || 0,
//       disbursementPercentage: kypData.disbursementPercentage || 0,
//       disbursementNotes: sanitizeValue(kypData.disbursementNotes),
//       doctorName: sanitizeValue(
//         kypData.doctorName,
//         "Dr. Medical Review Specialist"
//       ),
//       registrationNo: sanitizeValue(kypData.registrationNo, "SH-DOC-001"),
//       clinicalNotes: sanitizeValue(kypData.clinicalNotes),
//       recommendation: sanitizeValue(
//         kypData.recommendation,
//         "Medically necessary and appropriate"
//       ),
//       preExistingConditions: sanitizeValue(
//         kypData.preExistingConditions,
//         "None declared"
//       ),
//       validityPeriod: sanitizeValue(kypData.validityPeriod, "90 days"),
//       medicalHistoryVerified: Boolean(kypData.medicalHistoryVerified),
//       documentsAuthentic: Boolean(kypData.documentsAuthentic),
//       treatmentAppropriate: Boolean(kypData.treatmentAppropriate),
//       disbursementCalculation: sanitizeObject(
//         kypData.disbursementCalculation || {
//           totalEstimatedCost: application.medical?.estimatedCost || 0,
//           approvedPercentage: kypData.disbursementPercentage || 0,
//           approvedAmount: kypData.approvedDisbursementAmount || 0,
//           disbursementNotes: sanitizeValue(kypData.disbursementNotes),
//         }
//       ),
//     };

//     // Generate PDF using jsPDF
//     const fileName = `KYP_${applicationId}_${Date.now()}.pdf`;
//     const pdfBlob = await generateKYPPDF(application, safeKypData);

//     // Upload to Firebase Storage
//     const storageRef = ref(storage, `kyp-letters/${applicationId}/${fileName}`);
//     const snapshot = await uploadBytes(storageRef, pdfBlob);
//     const downloadURL = await getDownloadURL(snapshot.ref);

//     // Save enhanced KYP record
//     const kypRecord = {
//       applicationId,
//       generatedBy: doctorId,
//       generatedAt: new Date(),
//       fileName,
//       url: downloadURL,
//       contentType: "application/pdf",
//       kypData: safeKypData,
//       disbursementApproval: {
//         approvedAmount: safeKypData.approvedDisbursementAmount || 0,
//         disbursementPercentage: safeKypData.disbursementPercentage || 0,
//         disbursementNotes: safeKypData.disbursementNotes || "",
//         estimatedCost: application.medical?.estimatedCost || 0,
//       },
//       version: 1,
//       status: "generated",
//       type: "kyp_with_disbursement",
//     };
//     console.log("KYP Record:", kypRecord);
//     await addDoc(collection(db, "kypLetters"), kypRecord);

//     // Update application with KYP and disbursement data
//     const appRef = doc(db, "patientApplications", appSnapshot.docs[0].id);
//     await updateDoc(appRef, {
//       "workflow.medicalVerification.kypGenerated": true,
//       "workflow.medicalVerification.kypUrl": downloadURL,
//       "workflow.medicalVerification.kypData": safeKypData,
//       "workflow.medicalVerification.approvedDisbursementAmount":
//         safeKypData.approvedDisbursementAmount || 0,
//       "workflow.medicalVerification.disbursementApproved": true,
//       updatedAt: new Date(),
//     });

//     return {
//       success: true,
//       kypUrl: downloadURL,
//       fileName,
//       approvedDisbursementAmount: safeKypData.approvedDisbursementAmount || 0,
//     };
//   } catch (error) {
//     console.error("Error generating KYP letter:", error);
//     return {
//       success: false,
//       error: error.message,
//     };
//   }
// };

// // Function to generate actual PDF using jsPDF
// const generateKYPPDF = async (application, kypData) => {
//   // Note: You'll need to install jsPDF: npm install jspdf
//   // For now, I'll show you how to structure it. You'll need to import jsPDF at the top:
//   // import jsPDF from 'jspdf';

//   try {
//     // Create a new jsPDF instance
//     const pdf = new jsPDF("p", "mm", "a4");

//     const currentDate = new Date().toLocaleDateString("en-IN", {
//       year: "numeric",
//       month: "long",
//       day: "numeric",
//     });

//     const disbursementAmount = kypData.approvedDisbursementAmount || 0;
//     const estimatedCost = application.medical?.estimatedCost || 0;
//     const disbursementPercentage = kypData.disbursementPercentage || 0;

//     // Set font
//     pdf.setFont("helvetica");

//     // Header
//     pdf.setFontSize(18);
//     pdf.setTextColor(0, 102, 153); // Teal color
//     pdf.text("KNOW YOUR PATIENT (KYP)", 105, 25, { align: "center" });
//     pdf.text("VERIFICATION & DISBURSEMENT APPROVAL LETTER", 105, 35, {
//       align: "center",
//     });

//     // Add a line under header
//     pdf.setDrawColor(0, 102, 153);
//     pdf.line(20, 40, 190, 40);

//     let currentY = 50;

//     // Document details
//     pdf.setFontSize(10);
//     pdf.setTextColor(0, 0, 0);
//     pdf.text(`Date: ${currentDate}`, 20, currentY);
//     pdf.text(`Application ID: ${application.applicationId}`, 20, currentY + 5);
//     pdf.text(
//       `Reference No: KYP-${application.applicationId}-${Date.now()}`,
//       20,
//       currentY + 10
//     );

//     currentY += 25;

//     // Patient Information Section
//     pdf.setFontSize(14);
//     pdf.setTextColor(0, 102, 153);
//     pdf.text("PATIENT VERIFICATION DETAILS", 20, currentY);
//     currentY += 10;

//     pdf.setFontSize(10);
//     pdf.setTextColor(0, 0, 0);
//     pdf.text("Patient Information:", 20, currentY);
//     currentY += 5;
//     pdf.text(`• Name: ${application.patient?.name}`, 25, currentY);
//     currentY += 4;
//     pdf.text(`• Age: ${application.patient?.age} years`, 25, currentY);
//     currentY += 4;
//     pdf.text(`• Gender: ${application.patient?.gender}`, 25, currentY);
//     currentY += 4;
//     pdf.text(`• Contact: ${application.patient?.phone}`, 25, currentY);
//     currentY += 4;
//     pdf.text(
//       `• Aadhar: ****-****-${application.patient?.kyc?.aadharNumber?.slice(
//         -4
//       )}`,
//       25,
//       currentY
//     );

//     currentY += 10;

//     // Medical Information
//     pdf.text("Medical Information Verified:", 20, currentY);
//     currentY += 5;
//     pdf.text(
//       `• Primary Diagnosis: ${application.medical?.diagnosis}`,
//       25,
//       currentY
//     );
//     currentY += 4;
//     pdf.text(
//       `• Treatment Type: ${application.medical?.treatmentType?.toUpperCase()}`,
//       25,
//       currentY
//     );
//     currentY += 4;
//     pdf.text(
//       `• Consulting Doctor: ${application.medical?.doctor?.name}`,
//       25,
//       currentY
//     );
//     currentY += 4;
//     pdf.text(
//       `• Estimated Treatment Cost: ₹${estimatedCost?.toLocaleString("en-IN")}`,
//       25,
//       currentY
//     );

//     currentY += 10;

//     // Hospital Information
//     pdf.text("Hospital Information:", 20, currentY);
//     currentY += 5;
//     pdf.text(`• Hospital Name: ${application.hospitalName}`, 25, currentY);

//     currentY += 10;

//     // Insurance Policy Details
//     pdf.text("Insurance Policy Details:", 20, currentY);
//     currentY += 5;
//     pdf.text(`• Policy Number: ${application.policy?.number}`, 25, currentY);
//     currentY += 4;
//     pdf.text(
//       `• Insurance Company: ${application.policy?.insuranceCompany}`,
//       25,
//       currentY
//     );
//     currentY += 4;
//     pdf.text(
//       `• Coverage Amount: ₹${application.policy?.coverageAmount?.toLocaleString(
//         "en-IN"
//       )}`,
//       25,
//       currentY
//     );

//     currentY += 15;

//     // Verification Summary
//     pdf.setFontSize(14);
//     pdf.setTextColor(0, 102, 153);
//     pdf.text("VERIFICATION SUMMARY", 20, currentY);
//     currentY += 10;

//     pdf.setFontSize(10);
//     pdf.setTextColor(0, 0, 0);
//     pdf.text(
//       `Medical History Verification: ${
//         kypData?.medicalHistoryVerified ? "VERIFIED ✓" : "PENDING"
//       }`,
//       20,
//       currentY
//     );
//     currentY += 5;
//     pdf.text(
//       `Document Authenticity: ${
//         kypData?.documentsAuthentic ? "VERIFIED ✓" : "NEEDS REVIEW"
//       }`,
//       20,
//       currentY
//     );
//     currentY += 5;
//     pdf.text(
//       `Treatment Plan Appropriateness: ${
//         kypData?.treatmentAppropriate ? "APPROVED ✓" : "UNDER REVIEW"
//       }`,
//       20,
//       currentY
//     );
//     currentY += 5;
//     pdf.text(
//       `Pre-existing Conditions: ${
//         kypData?.preExistingConditions || "None declared"
//       }`,
//       20,
//       currentY
//     );

//     currentY += 15;

//     // Disbursement Approval Section (Highlighted)
//     pdf.setFillColor(240, 249, 255); // Light blue background
//     pdf.rect(15, currentY - 5, 180, 35, "F");

//     pdf.setFontSize(14);
//     pdf.setTextColor(0, 102, 153);
//     pdf.text("DISBURSEMENT APPROVAL SUMMARY", 20, currentY);
//     currentY += 10;

//     pdf.setFontSize(12);
//     pdf.setTextColor(0, 0, 0);
//     pdf.text(
//       `Total Estimated Cost: ₹${estimatedCost?.toLocaleString("en-IN")}`,
//       20,
//       currentY
//     );
//     currentY += 6;
//     pdf.text(
//       `Approved Disbursement Percentage: ${disbursementPercentage}%`,
//       20,
//       currentY
//     );
//     currentY += 6;

//     // Highlight the approved amount
//     pdf.setFontSize(14);
//     pdf.setTextColor(0, 153, 0); // Green color for approved amount
//     pdf.text(
//       `APPROVED DISBURSEMENT AMOUNT: ₹${disbursementAmount?.toLocaleString(
//         "en-IN"
//       )}`,
//       20,
//       currentY
//     );
//     currentY += 8;

//     pdf.setFontSize(10);
//     pdf.setTextColor(0, 0, 0);
//     pdf.text(
//       `Remaining Amount (Post-treatment): ₹${(
//         estimatedCost - disbursementAmount
//       )?.toLocaleString("en-IN")}`,
//       20,
//       currentY
//     );

//     currentY += 15;

//     // Medical Recommendation
//     pdf.setFontSize(12);
//     pdf.setTextColor(0, 102, 153);
//     pdf.text("MEDICAL RECOMMENDATION:", 20, currentY);
//     currentY += 8;

//     pdf.setFontSize(10);
//     pdf.setTextColor(0, 0, 0);
//     const recommendation =
//       kypData?.recommendation ||
//       "Medically necessary and appropriate for the patient's condition.";
//     const recommendationLines = pdf.splitTextToSize(recommendation, 170);
//     pdf.text(recommendationLines, 20, currentY);
//     currentY += recommendationLines.length * 4 + 5;

//     // Clinical Notes
//     if (kypData?.clinicalNotes) {
//       pdf.text("Clinical Notes:", 20, currentY);
//       currentY += 5;
//       const clinicalNotesLines = pdf.splitTextToSize(
//         kypData.clinicalNotes,
//         170
//       );
//       pdf.text(clinicalNotesLines, 20, currentY);
//       currentY += clinicalNotesLines.length * 4 + 10;
//     }

//     // Verification Statement
//     pdf.setFontSize(12);
//     pdf.setTextColor(0, 102, 153);
//     pdf.text("VERIFICATION & DISBURSEMENT STATEMENT:", 20, currentY);
//     currentY += 8;

//     pdf.setFontSize(9);
//     pdf.setTextColor(0, 0, 0);
//     const statements = [
//       "1. The patient identity has been verified against submitted documents",
//       "2. The medical condition and proposed treatment are genuine and medically necessary",
//       "3. All submitted medical documents have been reviewed and found authentic",
//       "4. The treatment costs are reasonable and justified for the medical condition",
//       "5. The claim is eligible for processing under the insurance policy terms",
//       `6. The disbursement amount of ₹${disbursementAmount?.toLocaleString(
//         "en-IN"
//       )} is approved for immediate release`,
//       "7. The remaining amount will be processed upon treatment completion and discharge summary review",
//     ];

//     statements.forEach((statement) => {
//       pdf.text(statement, 20, currentY);
//       currentY += 4;
//     });

//     currentY += 10;

//     // Validity and Instructions
//     pdf.setFontSize(10);
//     pdf.text(
//       `Validity Period: ${
//         kypData?.validityPeriod || "90 days"
//       } from date of issue`,
//       20,
//       currentY
//     );
//     currentY += 5;
//     pdf.text(
//       "Next Review Required: Upon treatment completion or significant medical changes",
//       20,
//       currentY
//     );

//     currentY += 10;

//     // Doctor Signature Section
//     pdf.setFontSize(12);
//     pdf.setTextColor(0, 102, 153);
//     pdf.text("VERIFIED AND APPROVED BY:", 20, currentY);
//     currentY += 8;

//     pdf.setFontSize(10);
//     pdf.setTextColor(0, 0, 0);
//     pdf.text(
//       `Dr. ${kypData?.doctorName || "Medical Review Specialist"}`,
//       20,
//       currentY
//     );
//     currentY += 4;
//     pdf.text("Medical Review Department", 20, currentY);
//     currentY += 4;
//     pdf.text("SamHealth Insurance Processing", 20, currentY);
//     currentY += 4;
//     pdf.text(
//       `Medical Registration No: ${kypData?.registrationNo || "SH-DOC-001"}`,
//       20,
//       currentY
//     );
//     currentY += 4;
//     pdf.text(`Digital Signature: KYP-${Date.now()}`, 20, currentY);

//     currentY += 10;

//     // Verification Code
//     pdf.setFontSize(12);
//     pdf.setTextColor(0, 102, 153);
//     pdf.text(
//       `VERIFICATION & DISBURSEMENT CODE: KYP-${
//         application.applicationId
//       }-${Date.now().toString().slice(-6)}`,
//       20,
//       currentY
//     );

//     // Footer
//     pdf.setFontSize(8);
//     pdf.setTextColor(100, 100, 100);
//     pdf.text(
//       "This is a digitally generated document by SamHealth Medical Review System.",
//       105,
//       285,
//       { align: "center" }
//     );
//     pdf.text(
//       "For verification, please contact: medical.review@samriddhihealthcare.com",
//       105,
//       290,
//       { align: "center" }
//     );

//     // Return the PDF as blob
//     return pdf.output("blob");
//   } catch (error) {
//     console.error("Error generating PDF:", error);
//     // Fallback to text-based PDF if jsPDF is not available
//     const kypContent = generateEnhancedKYPContent(application, kypData);
//     return new Blob([kypContent], { type: "application/pdf" });
//   }
// };

// // Enhanced Process discharge review with file uploads
// export const processDischargeReview = async (
//   applicationId,
//   doctorId,
//   dischargeData
// ) => {
//   try {
//     // Validate discharge items
//     if (!dischargeData.items || dischargeData.items.length === 0) {
//       return { success: false, error: "No discharge items provided" };
//     }

//     // Calculate totals
//     let totalBilled = 0;
//     let totalEligible = 0;

//     const processedItems = dischargeData.items.map((item) => {
//       const billedAmount = parseFloat(item.billedAmount) || 0;
//       const eligibleAmount = parseFloat(item.eligibleAmount) || 0;

//       if (item.approved) {
//         totalBilled += billedAmount;
//         totalEligible += eligibleAmount;
//       }

//       return {
//         ...item,
//         billedAmount,
//         eligibleAmount,
//         variance: billedAmount - eligibleAmount,
//         variancePercentage:
//           billedAmount > 0
//             ? (((billedAmount - eligibleAmount) / billedAmount) * 100).toFixed(
//                 2
//               )
//             : 0,
//       };
//     });

//     const dischargeReview = {
//       items: processedItems,
//       totals: {
//         totalBilled,
//         totalEligible,
//         totalVariance: totalBilled - totalEligible,
//         eligibilityPercentage:
//           totalBilled > 0
//             ? ((totalEligible / totalBilled) * 100).toFixed(2)
//             : 0,
//         finalApprovedAmount: totalEligible,
//       },
//       doctorComments: dischargeData.comments || "",
//       reviewedBy: doctorId,
//       reviewedAt: new Date(),
//       recommendation: dischargeData.recommendation || "approve", // approve, reject, modify
//       modificationReason: dischargeData.modificationReason || "",
//       uploadedFiles: dischargeData.uploadedFiles || [], // Include uploaded files
//     };

//     // Update application with enhanced discharge review
//     const appQuery = query(
//       collection(db, "patientApplications"),
//       where("applicationId", "==", applicationId)
//     );
//     const appSnapshot = await getDocs(appQuery);

//     if (appSnapshot.empty) {
//       return { success: false, error: "Application not found" };
//     }

//     const appRef = doc(db, "patientApplications", appSnapshot.docs[0].id);
//     await updateDoc(appRef, {
//       "workflow.medicalVerification.dischargeReview": dischargeReview,
//       "workflow.medicalVerification.dischargeReviewCompleted": true,
//       "workflow.medicalVerification.finalApprovedAmount": totalEligible,
//       "workflow.medicalVerification.dischargeFiles":
//         dischargeData.uploadedFiles || [],
//       updatedAt: new Date(),
//     });

//     return {
//       success: true,
//       dischargeReview,
//       message: "Discharge review completed successfully",
//     };
//   } catch (error) {
//     console.error("Error processing discharge review:", error);
//     return {
//       success: false,
//       error: error.message,
//     };
//   }
// };

// // Submit for final approval
// export const submitForFinalApproval = async (
//   applicationId,
//   doctorId,
//   finalData
// ) => {
//   try {
//     const appQuery = query(
//       collection(db, "patientApplications"),
//       where("applicationId", "==", applicationId)
//     );
//     const appSnapshot = await getDocs(appQuery);

//     if (appSnapshot.empty) {
//       return { success: false, error: "Application not found" };
//     }

//     const appRef = doc(db, "patientApplications", appSnapshot.docs[0].id);

//     await updateDoc(appRef, {
//       "workflow.medicalVerification.status": "approved",
//       "workflow.medicalVerification.finalComments": finalData.comments || "",
//       "workflow.medicalVerification.recommendedAmount":
//         finalData.recommendedAmount || 0,
//       "workflow.medicalVerification.submittedForFinalApproval": true,
//       "workflow.medicalVerification.submittedAt": new Date(),
//       status: "pending_final_approval",
//       updatedAt: new Date(),
//     });

//     return {
//       success: true,
//       message: "Application submitted for final approval",
//     };
//   } catch (error) {
//     console.error("Error submitting for final approval:", error);
//     return {
//       success: false,
//       error: error.message,
//     };
//   }
// };

// // Upload document during review
// export const uploadReviewDocument = async (
//   applicationId,
//   file,
//   documentType,
//   uploadedBy
// ) => {
//   try {
//     const fileName = `${documentType}_${Date.now()}_${file.name}`;
//     const storageRef = ref(
//       storage,
//       `review-documents/${applicationId}/${fileName}`
//     );

//     const snapshot = await uploadBytes(storageRef, file);
//     const downloadURL = await getDownloadURL(snapshot.ref);

//     const documentData = {
//       url: downloadURL,
//       fileName: file.name,
//       originalName: file.name,
//       size: file.size,
//       type: documentType,
//       uploadedAt: new Date(),
//       uploadedBy: uploadedBy,
//       description: "", // Will be updated by user
//     };

//     return {
//       success: true,
//       document: documentData,
//     };
//   } catch (error) {
//     console.error("Error uploading review document:", error);
//     return {
//       success: false,
//       error: error.message,
//     };
//   }
// };

// // Get discharge summary data
// export const getDischargeSummary = async (applicationId) => {
//   try {
//     const q = query(
//       collection(db, "dischargeSummaries"),
//       where("applicationId", "==", applicationId)
//     );

//     const querySnapshot = await getDocs(q);

//     if (querySnapshot.empty) {
//       return {
//         success: true,
//         dischargeSummary: null,
//       };
//     }

//     const dischargeSummary = querySnapshot.docs[0].data();

//     return {
//       success: true,
//       dischargeSummary: {
//         id: querySnapshot.docs[0].id,
//         ...dischargeSummary,
//       },
//     };
//   } catch (error) {
//     console.error("Error getting discharge summary:", error);
//     return {
//       success: false,
//       error: error.message,
//       dischargeSummary: null,
//     };
//   }
// };

// // Add discharge items during review
// export const addDischargeItem = async (applicationId, doctorId, itemData) => {
//   try {
//     const dischargeItem = {
//       applicationId,
//       addedBy: doctorId,
//       addedAt: new Date(),
//       ...itemData,
//       id: Date.now().toString(),
//     };

//     // Add to discharge items collection
//     await addDoc(collection(db, "dischargeItems"), dischargeItem);

//     return {
//       success: true,
//       item: dischargeItem,
//       message: "Discharge item added successfully",
//     };
//   } catch (error) {
//     console.error("Error adding discharge item:", error);
//     return {
//       success: false,
//       error: error.message,
//     };
//   }
// };

// // Get discharge items for application
// export const getDischargeItems = async (applicationId) => {
//   try {
//     const q = query(
//       collection(db, "dischargeItems"),
//       where("applicationId", "==", applicationId),
//       orderBy("addedAt", "asc")
//     );

//     const querySnapshot = await getDocs(q);
//     const items = [];

//     querySnapshot.forEach((doc) => {
//       items.push({
//         id: doc.id,
//         ...doc.data(),
//       });
//     });

//     return {
//       success: true,
//       items,
//     };
//   } catch (error) {
//     console.error("Error getting discharge items:", error);
//     return {
//       success: false,
//       error: error.message,
//       items: [],
//     };
//   }
// };

// // Update discharge item
// export const updateDischargeItem = async (itemId, updateData) => {
//   try {
//     const itemRef = doc(db, "dischargeItems", itemId);
//     await updateDoc(itemRef, {
//       ...updateData,
//       updatedAt: new Date(),
//     });

//     return {
//       success: true,
//       message: "Discharge item updated successfully",
//     };
//   } catch (error) {
//     console.error("Error updating discharge item:", error);
//     return {
//       success: false,
//       error: error.message,
//     };
//   }
// };

// // Delete discharge item
// export const deleteDischargeItem = async (itemId) => {
//   try {
//     await deleteDoc(doc(db, "dischargeItems", itemId));

//     return {
//       success: true,
//       message: "Discharge item deleted successfully",
//     };
//   } catch (error) {
//     console.error("Error deleting discharge item:", error);
//     return {
//       success: false,
//       error: error.message,
//     };
//   }
// };

// // Get doctor performance metrics
// export const getDoctorPerformanceMetrics = async (
//   doctorId,
//   dateRange = null
// ) => {
//   try {
//     let q = collection(db, "patientApplications");
//     q = query(
//       q,
//       where("workflow.medicalVerification.verifiedBy", "==", doctorId)
//     );

//     if (dateRange && dateRange.start && dateRange.end) {
//       q = query(
//         q,
//         where(
//           "workflow.medicalVerification.verifiedAt",
//           ">=",
//           Timestamp.fromDate(new Date(dateRange.start))
//         ),
//         where(
//           "workflow.medicalVerification.verifiedAt",
//           "<=",
//           Timestamp.fromDate(new Date(dateRange.end))
//         )
//       );
//     }

//     const querySnapshot = await getDocs(q);

//     const metrics = {
//       totalReviewed: 0,
//       approved: 0,
//       rejected: 0,
//       pendingInfo: 0,
//       averageReviewTime: 0,
//       totalReviewTime: 0,
//       emergencyReviews: 0,
//       complexCases: 0,
//       feedbackScore: 0,
//       totalAmountProcessed: 0,
//       avgDailyReviews: 0,
//     };

//     let totalReviewTime = 0;
//     let totalAmount = 0;
//     const reviewDates = new Set();

//     querySnapshot.forEach((doc) => {
//       const data = doc.data();
//       metrics.totalReviewed++;

//       const reviewStatus = data.workflow?.medicalVerification?.status;
//       switch (reviewStatus) {
//         case "approved":
//           metrics.approved++;
//           break;
//         case "rejected":
//           metrics.rejected++;
//           break;
//         case "pending_info":
//           metrics.pendingInfo++;
//           break;
//       }

//       if (data.emergency) {
//         metrics.emergencyReviews++;
//       }

//       if (
//         data.priority === "urgent" ||
//         data.medical?.treatmentType === "surgical"
//       ) {
//         metrics.complexCases++;
//       }

//       const reviewTime = data.workflow?.medicalVerification?.reviewTimeMinutes;
//       if (reviewTime) {
//         totalReviewTime += reviewTime;
//       }

//       const amount =
//         data.workflow?.medicalVerification?.finalApprovedAmount ||
//         data.medical?.estimatedCost ||
//         0;
//       totalAmount += amount;

//       // Track unique review dates
//       const reviewDate =
//         data.workflow?.medicalVerification?.verifiedAt?.toDate();
//       if (reviewDate) {
//         reviewDates.add(reviewDate.toDateString());
//       }
//     });

//     metrics.averageReviewTime =
//       metrics.totalReviewed > 0
//         ? Math.round(totalReviewTime / metrics.totalReviewed)
//         : 0;
//     metrics.totalReviewTime = totalReviewTime;
//     metrics.totalAmountProcessed = totalAmount;

//     // Calculate approval rate as feedback score
//     metrics.feedbackScore =
//       metrics.totalReviewed > 0
//         ? Math.round((metrics.approved / metrics.totalReviewed) * 100)
//         : 0;

//     // Calculate average daily reviews
//     metrics.avgDailyReviews =
//       reviewDates.size > 0
//         ? Math.round(metrics.totalReviewed / reviewDates.size)
//         : 0;

//     return {
//       success: true,
//       metrics,
//     };
//   } catch (error) {
//     console.error("Error getting doctor performance metrics:", error);
//     return {
//       success: false,
//       error: error.message,
//       metrics: null,
//     };
//   }
// };

// // Real-time listener for application updates during review
// export const subscribeToApplicationUpdates = (applicationId, callback) => {
//   const q = query(
//     collection(db, "patientApplications"),
//     where("applicationId", "==", applicationId)
//   );

//   return onSnapshot(q, (snapshot) => {
//     if (!snapshot.empty) {
//       const application = {
//         id: snapshot.docs[0].id,
//         ...snapshot.docs[0].data(),
//       };
//       callback(application);
//     }
//   });
// };

// // Get discussion/chat messages for clarification
// export const getClarificationMessages = async (clarificationId) => {
//   try {
//     const q = query(
//       collection(db, "clarificationMessages"),
//       where("clarificationId", "==", clarificationId),
//       orderBy("createdAt", "asc")
//     );

//     const querySnapshot = await getDocs(q);
//     const messages = [];

//     querySnapshot.forEach((doc) => {
//       messages.push({
//         id: doc.id,
//         ...doc.data(),
//       });
//     });

//     return {
//       success: true,
//       messages,
//     };
//   } catch (error) {
//     console.error("Error getting clarification messages:", error);
//     return {
//       success: false,
//       error: error.message,
//       messages: [],
//     };
//   }
// };

// // Send message in clarification discussion
// export const sendClarificationMessage = async (
//   clarificationId,
//   senderId,
//   messageData
// ) => {
//   try {
//     const message = {
//       clarificationId,
//       senderId,
//       senderRole: messageData.senderRole || "doctor",
//       content: messageData.content,
//       messageType: messageData.messageType || "text", // text, file, form_response
//       attachments: messageData.attachments || [],
//       createdAt: new Date(),
//       readBy: [senderId],
//     };

//     // Add message to collection
//     const messageRef = await addDoc(
//       collection(db, "clarificationMessages"),
//       message
//     );

//     // Update clarification last activity
//     const clarificationRef = doc(db, "clarifications", clarificationId);
//     await updateDoc(clarificationRef, {
//       lastMessageAt: new Date(),
//       lastMessageBy: senderId,
//     });

//     return {
//       success: true,
//       messageId: messageRef.id,
//       message: "Message sent successfully",
//     };
//   } catch (error) {
//     console.error("Error sending clarification message:", error);
//     return {
//       success: false,
//       error: error.message,
//     };
//   }
// };

// // Answer clarification question
// export const answerClarificationQuestion = async (
//   clarificationId,
//   questionId,
//   answerData,
//   answeredBy
// ) => {
//   try {
//     const clarificationRef = doc(db, "clarifications", clarificationId);
//     const clarificationDoc = await getDoc(clarificationRef);

//     if (!clarificationDoc.exists()) {
//       return { success: false, error: "Clarification not found" };
//     }

//     const clarificationData = clarificationDoc.data();
//     const updatedQuestions = clarificationData.questions.map((q) => {
//       if (q.id === questionId) {
//         return {
//           ...q,
//           answer: answerData.answer,
//           answerFiles: answerData.files || [],
//           answeredAt: new Date(),
//           answeredBy: answeredBy,
//         };
//       }
//       return q;
//     });

//     // Check if all required questions are answered
//     const allRequiredAnswered = updatedQuestions
//       .filter((q) => q.required)
//       .every((q) => q.answer || q.answerFiles?.length > 0);

//     const updateData = {
//       questions: updatedQuestions,
//       updatedAt: new Date(),
//     };

//     if (allRequiredAnswered) {
//       updateData.status = "answered";
//       updateData.answeredAt = new Date();
//     }

//     await updateDoc(clarificationRef, updateData);

//     return {
//       success: true,
//       message: "Question answered successfully",
//     };
//   } catch (error) {
//     console.error("Error answering clarification question:", error);
//     return {
//       success: false,
//       error: error.message,
//     };
//   }
// };

// // Get list of hospitals for filter
// export const getHospitalsForFilter = async () => {
//   try {
//     const q = query(
//       collection(db, "hospitals"),
//       where("status", "==", "approved")
//     );

//     const querySnapshot = await getDocs(q);
//     const hospitals = [];

//     querySnapshot.forEach((doc) => {
//       const data = doc.data();
//       hospitals.push({
//         id: doc.id,
//         name: data.hospitalName || data.name,
//         city: data.address?.city || "",
//       });
//     });

//     return {
//       success: true,
//       hospitals,
//     };
//   } catch (error) {
//     console.error("Error getting hospitals:", error);
//     return {
//       success: false,
//       error: error.message,
//       hospitals: [],
//     };
//   }
// };
// export const submitQuestionAnswer = async (applicationId, answerData) => {
//   try {
//     const { 
//       questionId, 
//       messageId, 
//       answerText, 
//       attachments, 
//       respondentId, 
//       respondentName, 
//       respondentRole, 
//       timestamp 
//     } = answerData;

//     // Get all discussions for this application
//     const discussionsResult = await getApplicationDiscussions(applicationId);
//     if (!discussionsResult.success) {
//       throw new Error('Failed to load discussions');
//     }

//     // Find the message with the question
//     let targetDiscussion = null;
//     let targetMessage = null;

//     for (const discussion of discussionsResult.discussions) {
//       const message = discussion.messages?.find(msg => msg.id === messageId);
//       if (message) {
//         targetDiscussion = discussion;
//         targetMessage = message;
//         break;
//       }
//     }

//     if (!targetMessage || !targetDiscussion) {
//       throw new Error('Message not found');
//     }

//     // Update the specific question with the new answer
//     const updatedQuestions = targetMessage.qnaQuestions.map(question => {
//       if (question.id === questionId) {
//         const newAnswer = {
//           answerText,
//           attachments: attachments || [],
//           respondentId,
//           respondentName,
//           respondentRole,
//           timestamp
//         };
        
//         // Add to existing answers or create new answers array
//         const existingAnswers = question.answers || [];
        
//         // Check if user already answered and update, or add new answer
//         const existingAnswerIndex = existingAnswers.findIndex(
//           answer => answer.respondentId === respondentId
//         );
        
//         if (existingAnswerIndex >= 0) {
//           existingAnswers[existingAnswerIndex] = newAnswer;
//         } else {
//           existingAnswers.push(newAnswer);
//         }
        
//         return {
//           ...question,
//           answers: existingAnswers
//         };
//       }
//       return question;
//     });

//     // Update the message with new questions
//     const updatedMessages = targetDiscussion.messages.map(message => {
//       if (message.id === messageId) {
//         return {
//           ...message,
//           qnaQuestions: updatedQuestions
//         };
//       }
//       return message;
//     });

//     // Update the discussion in Firestore
//     const discussionRef = doc(db, 'hospitalApplications', applicationId, 'discussions', targetDiscussion.id);
//     await updateDoc(discussionRef, {
//       messages: updatedMessages,
//       lastUpdated: timestamp
//     });

//     // Also update the main application document to trigger real-time updates
//     const appRef = doc(db, 'hospitalApplications', applicationId);
//     await updateDoc(appRef, {
//       lastActivity: timestamp,
//       'workflow.lastUpdate': timestamp
//     });

//     return { success: true };
//   } catch (error) {
//     console.error('Error submitting question answer:', error);
//     return { success: false, error: error.message };
//   }
// };
// // Get insurance companies for filter
// export const getInsuranceCompaniesForFilter = async () => {
//   try {
//     // Get unique insurance companies from applications
//     const q = query(collection(db, "patientApplications"));
//     const querySnapshot = await getDocs(q);
//     const companies = new Set();

//     querySnapshot.forEach((doc) => {
//       const data = doc.data();
//       if (data.policy?.insuranceCompany) {
//         companies.add(data.policy.insuranceCompany);
//       }
//     });

//     return {
//       success: true,
//       companies: Array.from(companies).sort(),
//     };
//   } catch (error) {
//     console.error("Error getting insurance companies:", error);
//     return {
//       success: false,
//       error: error.message,
//       companies: [
//         "HDFC ERGO",
//         "ICICI Lombard",
//         "Bajaj Allianz",
//         "Star Health",
//         "Care Health",
//         "Niva Bupa",
//         "Aditya Birla",
//         "Future Generali",
//         "Cholamandalam",
//         "Oriental Insurance",
//       ],
//     };
//   }
// };

// // Enhanced Helper function to generate KYP content with disbursement information
// const generateEnhancedKYPContent = (application, kypData) => {
//   const currentDate = new Date().toLocaleDateString("en-IN", {
//     year: "numeric",
//     month: "long",
//     day: "numeric",
//   });

//   const disbursementAmount = kypData.approvedDisbursementAmount || 0;
//   const estimatedCost = application.medical?.estimatedCost || 0;
//   const disbursementPercentage = kypData.disbursementPercentage || 0;

//   return `
// KNOW YOUR PATIENT (KYP) VERIFICATION & DISBURSEMENT APPROVAL LETTER

// Date: ${currentDate}
// Application ID: ${application.applicationId}
// Reference No: KYP-${application.applicationId}-${Date.now()}

// To Whom It May Concern,

// This is to certify that we have conducted a comprehensive medical review and verification of the patient and the submitted medical documents for the health insurance claim, along with disbursement approval.

// PATIENT VERIFICATION DETAILS:

// Patient Information:
// - Name: ${application.patient?.name}
// - Age: ${application.patient?.age} years
// - Gender: ${application.patient?.gender}
// - Contact: ${application.patient?.phone}
// - Aadhar: ****-****-${application.patient?.kyc?.aadharNumber?.slice(-4)}

// Medical Information Verified:
// - Primary Diagnosis: ${application.medical?.diagnosis}
// - Treatment Type: ${application.medical?.treatmentType?.toUpperCase()}
// - Consulting Doctor: ${application.medical?.doctor?.name}
// - Designation: ${
//     application.medical?.doctor?.designation || "Medical Practitioner"
//   }
// - Admission Date: ${application.medical?.admissionDate}
// - Estimated Treatment Cost: ₹${estimatedCost?.toLocaleString("en-IN")}

// Hospital Information:
// - Hospital Name: ${application.hospitalName}
// - Location: ${application.hospitalDetails?.address?.city || "Not specified"}

// Insurance Policy Details:
// - Policy Number: ${application.policy?.number}
// - Insurance Company: ${application.policy?.insuranceCompany}
// - Coverage Amount: ₹${application.policy?.coverageAmount?.toLocaleString(
//     "en-IN"
//   )}

// VERIFICATION SUMMARY:

// Medical History Verification: ${
//     kypData?.medicalHistoryVerified ? "VERIFIED ✓" : "PENDING"
//   }
// Document Authenticity: ${
//     kypData?.documentsAuthentic ? "VERIFIED ✓" : "NEEDS REVIEW"
//   }
// Treatment Plan Appropriateness: ${
//     kypData?.treatmentAppropriate ? "APPROVED ✓" : "UNDER REVIEW"
//   }
// Pre-existing Conditions: ${kypData?.preExistingConditions || "None declared"}

// DISBURSEMENT APPROVAL SUMMARY:

// Total Estimated Cost: ₹${estimatedCost?.toLocaleString("en-IN")}
// Approved Disbursement Percentage: ${disbursementPercentage}%
// APPROVED DISBURSEMENT AMOUNT: ₹${disbursementAmount?.toLocaleString("en-IN")}
// Remaining Amount (Post-treatment): ₹${(
//     estimatedCost - disbursementAmount
//   )?.toLocaleString("en-IN")}

// Disbursement Notes: ${
//     kypData?.disbursementNotes ||
//     "Standard disbursement approval based on medical necessity and policy terms."
//   }

// MEDICAL RECOMMENDATION:

// Based on our comprehensive medical review, the treatment plan is assessed as:
// ${
//   kypData?.recommendation ||
//   "Medically necessary and appropriate for the patient's condition."
// }

// Clinical Notes:
// ${
//   kypData?.clinicalNotes ||
//   "Standard medical protocols followed. Treatment aligns with patient's medical condition and insurance coverage terms."
// }

// VERIFICATION & DISBURSEMENT STATEMENT:

// I hereby certify that:
// 1. The patient identity has been verified against submitted documents
// 2. The medical condition and proposed treatment are genuine and medically necessary
// 3. All submitted medical documents have been reviewed and found authentic
// 4. The treatment costs are reasonable and justified for the medical condition
// 5. The claim is eligible for processing under the insurance policy terms
// 6. The disbursement amount of ₹${disbursementAmount?.toLocaleString(
//     "en-IN"
//   )} is approved for immediate release
// 7. The remaining amount will be processed upon treatment completion and discharge summary review

// This KYP letter with disbursement approval is issued based on thorough medical evidence review and professional medical judgment.

// Validity Period: ${kypData?.validityPeriod || "90 days"} from date of issue
// Next Review Required: Upon treatment completion or significant medical changes

// DISBURSEMENT INSTRUCTIONS:
// - Approved Amount: ₹${disbursementAmount?.toLocaleString("en-IN")}
// - Release Conditions: Upon hospital request and patient admission confirmation
// - Remaining Amount: Subject to discharge summary review and final approval
// - Payment Mode: Direct transfer to hospital account as per policy terms

// VERIFIED AND APPROVED BY:
// Dr. ${kypData?.doctorName || "Medical Review Specialist"}
// Medical Review Department
// SamHealth Insurance Processing
// Medical Registration No: ${kypData?.registrationNo || "SH-DOC-001"}
// Digital Signature: KYP-${Date.now()}

// VERIFICATION & DISBURSEMENT CODE: KYP-${application.applicationId}-${Date.now()
//     .toString()
//     .slice(-6)}

// ---
// IMPORTANT NOTES:
// - This letter is valid only for the specific application mentioned above
// - Disbursement is subject to hospital compliance with policy terms
// - Any changes in medical condition should be immediately reported
// - This verification is based on documents provided at the time of review
// - For any queries, please contact our medical review department
// - Final settlement subject to discharge summary review and approval

// This is a digitally generated document by SamHealth Medical Review System.
// For verification, please contact: medical.review@samriddhihealthcare.com
// ---
//   `.trim();
// };

// // Enhanced Get application discussions for unified chat interface with QnA support
// export const getApplicationDiscussions = async (applicationId) => {
//   try {
//     // Get discussions
//     const discussionsQuery = query(
//       collection(db, "discussions"),
//       where("applicationId", "==", applicationId),
//       orderBy("createdAt", "desc")
//     );

//     const discussionsSnapshot = await getDocs(discussionsQuery);
//     const discussions = [];

//     // For each discussion, get its messages
//     for (const discussionDoc of discussionsSnapshot.docs) {
//       const discussionData = discussionDoc.data();

//       // Get messages for this discussion
//       const messagesQuery = query(
//         collection(db, "discussionMessages"),
//         where("discussionId", "==", discussionDoc.id),
//         orderBy("createdAt", "asc")
//       );

//       const messagesSnapshot = await getDocs(messagesQuery);
//       const messages = [];

//       messagesSnapshot.forEach((messageDoc) => {
//         messages.push({
//           id: messageDoc.id,
//           ...messageDoc.data(),
//         });
//       });

//       discussions.push({
//         id: discussionDoc.id,
//         ...discussionData,
//         messages: messages,
//       });
//     }

//     return {
//       success: true,
//       discussions,
//     };
//   } catch (error) {
//     console.error("Error getting application discussions:", error);
//     return {
//       success: false,
//       error: error.message,
//       discussions: [],
//     };
//   }
// };

// // Enhanced Send discussion message with QnA support
// export const sendDiscussionMessage = async (applicationId, messageData) => {
//   try {
//     // Create discussion if this is a new conversation
//     let discussionId = messageData.discussionId;

//     if (!discussionId) {
//       // Create new discussion
//       const discussionData = {
//         applicationId,
//         subject:
//           messageData.subject ||
//           getSubjectForMessageType(messageData.messageType),
//         description:
//           messageData.description ||
//           getDescriptionForMessageType(messageData.messageType),
//         createdBy: messageData.sender,
//         createdAt: new Date(),
//         participantRoles: ["Doctor", "Hospital"],
//         status: "active",
//         messageCount: 0,
//         messageType: messageData.messageType || "text",
//       };

//       const discussionRef = await addDoc(
//         collection(db, "discussions"),
//         discussionData
//       );
//       discussionId = discussionRef.id;
//     }

//     // Add message to discussion
//     const message = {
//       discussionId,
//       applicationId,
//       message: messageData.message,
//       sender: messageData.sender,
//       senderName: messageData.senderName,
//       senderRole: messageData.senderRole,
//       messageType: messageData.messageType || "text",
//       qnaQuestions: messageData.qnaQuestions || null, // Support for Q&A questions
//       attachments: messageData.attachments || [],
//       replyTo: messageData.replyTo || null,
//       readBy: messageData.readBy || [messageData.sender],
//       createdAt: new Date(),
//     };

//     const messageRef = await addDoc(
//       collection(db, "discussionMessages"),
//       message
//     );

//     // Update discussion with latest message info
//     const discussionRef = doc(db, "discussions", discussionId);
//     const currentDiscussion = await getDoc(discussionRef);
//     const currentMessageCount = currentDiscussion.exists()
//       ? currentDiscussion.data().messageCount || 0
//       : 0;

//     await updateDoc(discussionRef, {
//       lastMessage: messageData.message,
//       lastMessageAt: new Date(),
//       lastMessageBy: messageData.sender,
//       messageCount: currentMessageCount + 1,
//     });

//     // If this is a clarification request or QnA, update application status
//     if (
//       messageData.messageType === "clarification_request" ||
//       messageData.messageType === "qna"
//     ) {
//       const appQuery = query(
//         collection(db, "patientApplications"),
//         where("applicationId", "==", applicationId)
//       );
//       const appSnapshot = await getDocs(appQuery);

//       if (!appSnapshot.empty) {
//         const appRef = doc(db, "patientApplications", appSnapshot.docs[0].id);
//         await updateDoc(appRef, {
//           status: "pending_clarification",
//           "workflow.medicalVerification.status": "pending_info",
//           "workflow.medicalVerification.clarificationRequestId": messageRef.id,
//           updatedAt: new Date(),
//         });
//       }
//     }

//     return {
//       success: true,
//       messageId: messageRef.id,
//       discussionId: discussionId,
//     };
//   } catch (error) {
//     console.error("Error sending discussion message:", error);
//     return {
//       success: false,
//       error: error.message,
//     };
//   }
// };

// // Enhanced Mark messages as read
// export const markMessagesAsRead = async (applicationId, userId) => {
//   try {
//     // Get all discussions for this application
//     const discussionsQuery = query(
//       collection(db, "discussions"),
//       where("applicationId", "==", applicationId)
//     );
//     const discussionsSnapshot = await getDocs(discussionsQuery);

//     // For each discussion, get messages and mark as read
//     const updatePromises = [];

//     for (const discussionDoc of discussionsSnapshot.docs) {
//       const messagesQuery = query(
//         collection(db, "discussionMessages"),
//         where("discussionId", "==", discussionDoc.id),
//         where("sender", "!=", userId) // Only mark messages not sent by current user
//       );

//       const messagesSnapshot = await getDocs(messagesQuery);

//       messagesSnapshot.forEach((messageDoc) => {
//         const messageData = messageDoc.data();
//         if (!messageData.readBy?.includes(userId)) {
//           const updatedReadBy = [...(messageData.readBy || []), userId];
//           updatePromises.push(
//             updateDoc(doc(db, "discussionMessages", messageDoc.id), {
//               readBy: updatedReadBy,
//             })
//           );
//         }
//       });
//     }

//     await Promise.all(updatePromises);

//     return {
//       success: true,
//       message: "Messages marked as read",
//     };
//   } catch (error) {
//     console.error("Error marking messages as read:", error);
//     return {
//       success: false,
//       error: error.message,
//     };
//   }
// };

// // Enhanced Upload document for discussion
// export const uploadDiscussionDocument = async (
//   applicationId,
//   file,
//   metadata
// ) => {
//   try {
//     const fileName = `discussion_${Date.now()}_${file.name}`;
//     const storageRef = ref(
//       storage,
//       `discussion-documents/${applicationId}/${fileName}`
//     );

//     const snapshot = await uploadBytes(storageRef, file);
//     const downloadURL = await getDownloadURL(snapshot.ref);

//     const documentData = {
//       url: downloadURL,
//       fileName: file.name,
//       originalName: file.name,
//       size: file.size,
//       type: file.type,
//       applicationId: applicationId,
//       discussionId: metadata.discussionId,
//       messageId: metadata.messageId,
//       uploadedAt: new Date(),
//       uploadedBy: metadata.uploadedBy,
//       uploaderName: metadata.uploaderName,
//       description: metadata.description || "",
//     };

//     // Save document record
//     const docRef = await addDoc(
//       collection(db, "discussionDocuments"),
//       documentData
//     );

//     return {
//       success: true,
//       document: { ...documentData, id: docRef.id },
//     };
//   } catch (error) {
//     console.error("Error uploading discussion document:", error);
//     return {
//       success: false,
//       error: error.message,
//     };
//   }
// };

// // Helper functions for message types
// const getSubjectForMessageType = (messageType) => {
//   switch (messageType) {
//     case "qna":
//       return "Q&A Form - Medical Clarification";
//     case "clarification_request":
//       return "Medical Clarification Request";
//     case "file":
//       return "Document Submission";
//     default:
//       return "Medical Discussion";
//   }
// };

// const getDescriptionForMessageType = (messageType) => {
//   switch (messageType) {
//     case "qna":
//       return "Doctor has sent a Q&A form requiring responses";
//     case "clarification_request":
//       return "Doctor has requested clarification on medical documents";
//     case "file":
//       return "Document has been shared for review";
//     default:
//       return "Discussion regarding medical review";
//   }
// };








import {
  collection,
  doc,
  getDoc,
  getDocs,
  updateDoc,
  addDoc,
  query,
  where,
  orderBy,
  limit,
  startAfter,
  Timestamp,
  onSnapshot,
  deleteDoc,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db, storage } from "./firebaseConfig";
import { pdf } from '@react-pdf/renderer';
import React from 'react';
import ComprehensiveKYPDocument from '../components/pdf/ComprehensiveKYPDocument';
import { getApplication, getApplicationDocRef } from './applicationService';
import { createNotification, sendEmail } from './notificationService';
import { 
  sendDoctorApprovalPushNotification, 
  sendQueryRaisedPushNotification 
} from './pushNotificationService';
import { updateRoleBucket } from './bucketFilterService';

// Reassign a challenged KYP to Policy or Finance team for review
export const reassignKYPForReview = async (
  applicationId,
  doctorId,
  { target, comment = '', doctorName = '' }
) => {
  try {
  const allowedTargets = ['policy', 'finance', 'both', 'doctor'];
    if (!allowedTargets.includes(target)) {
      return { success: false, error: 'Invalid target team' };
    }

    // Locate application by applicationId
    const appQuery = query(
      collection(db, 'patientApplications'),
      where('applicationId', '==', applicationId)
    );
    const appSnapshot = await getDocs(appQuery);
    if (appSnapshot.empty) {
      return { success: false, error: 'Application not found' };
    }
    const appRef = doc(db, 'patientApplications', appSnapshot.docs[0].id);

    const now = new Date();
  const targetsArray = target === 'both' ? ['policy', 'finance'] : [target];
    const updatePayload = {
      'workflow.medicalVerification.kypReassignment': {
        target, // 'policy' | 'finance' | 'both'
        targets: targetsArray,
        comment: comment || '',
        by: doctorId,
        byName: doctorName || null,
        at: now,
        status: 'pending',
      },
      updatedAt: now,
    };


  // End the doctor's review session: pause/complete, clear reviewerId, stop timer
  updatePayload['workflow.medicalReview.status'] = 'paused';
  updatePayload['workflow.medicalReview.reviewerId'] = null;
  updatePayload['workflow.medicalReview.reviewStartTime'] = null;
  updatePayload['workflow.medicalReview.lastActivityTime'] = null;
  // Optionally, set a pausedAt timestamp for audit
  updatePayload['workflow.medicalReview.pausedAt'] = now;

  await updateDoc(appRef, updatePayload);

    // Build notifications for target departments
    try {
      const appData = appSnapshot.docs[0].data();
      const patientName = appData?.patient?.name || 'Patient';
      const appIdStr = appData?.applicationId || applicationId;
      const commonMessage = `Doctor ${doctorName || doctorId} reassigned KYP after hospital challenge for ${patientName} (ID: ${appIdStr}).`;

      const notifPromises = targetsArray.map((tgt) => {
        const isPolicy = tgt === 'policy';
        const isFinance = tgt === 'finance';
        const isDoctor = tgt === 'doctor';
        const actionUrl = isPolicy
          ? `/policy/details/${appIdStr}`
          : isFinance
            ? `/dashboard/financial/review/${appIdStr}`
            : `/doctor/review/${appIdStr}`;
        const title = isPolicy
          ? 'KYP Challenged: Reassigned to Policy'
          : isFinance
            ? 'KYP Challenged: Reassigned to Finance'
            : 'KYP Challenged: Reassigned to Doctor';
        // For doctor, send to medical department to surface in doctor workflows
        const recipientId = isDoctor ? 'medical' : tgt;
        return createNotification({
          recipientId, // department
          recipientType: 'department',
          type: 'application',
          subType: 'kyp_reassigned',
          title,
          message: `${commonMessage} ${comment ? `Note: ${comment}` : ''}`.trim(),
          applicationId: appIdStr,
          actionUrl,
          priority: 'high',
          metadata: {
            patientName,
            hospitalName: appData?.hospitalName || '',
            reassignedBy: doctorName || doctorId,
            targets: targetsArray,
          },
        });
      });
      await Promise.allSettled(notifPromises);
    } catch (notifyErr) {
      console.warn('Notification creation failed for KYP reassignment:', notifyErr);
    }

    return { success: true };
  } catch (error) {
    console.error('Error reassigning KYP for review:', error);
    return { success: false, error: error.message };
  }
};

// Doctor response to hospital KYP challenge
export const respondToKYPChallenge = async (
  applicationId,
  doctorId,
  { decision, comment = '', doctorName = '' }
) => {
  try {
    const allowed = ['accept_revision', 'not_accept'];
    if (!allowed.includes(decision)) {
      return { success: false, error: 'Invalid decision' };
    }

    // Find application
    const appQuery = query(
      collection(db, 'patientApplications'),
      where('applicationId', '==', applicationId)
    );
    const appSnapshot = await getDocs(appQuery);
    if (appSnapshot.empty) {
      return { success: false, error: 'Application not found' };
    }
    const appRef = doc(db, 'patientApplications', appSnapshot.docs[0].id);

    // Update nested acknowledgement with doctor response
    const baseUpdate = {
      'workflow.medicalVerification.kypHospitalAcknowledgement.doctorResponse': {
        decision,
        comment: comment || '',
        by: doctorId,
        byName: doctorName || null,
        at: new Date(),
      },
      updatedAt: new Date(),
    };
    // If doctor accepts to revise, clear any previous KYP approval to reopen buttons
    if (decision === 'accept_revision') {
      baseUpdate['workflow.medicalVerification.kypApproval'] = null;
      // Also reset hospital acknowledgement to pending so hospital UI reflects revision in progress
      baseUpdate['workflow.medicalVerification.kypHospitalAcknowledgement.status'] = 'pending';
      // Clear previous challenge comment to avoid confusing messages on hospital side
      baseUpdate['workflow.medicalVerification.kypHospitalAcknowledgement.comment'] = '';
      baseUpdate['workflow.medicalVerification.kypHospitalAcknowledgement.revisionAcceptedAt'] = new Date();
      baseUpdate['workflow.medicalVerification.kypHospitalAcknowledgement.revisionAcceptedBy'] = doctorId;
      baseUpdate['workflow.medicalVerification.kypHospitalAcknowledgement.revisionAcceptedByName'] = doctorName || null;
    }
    await updateDoc(appRef, baseUpdate);

    // Update bucket filter based on doctor's decision
    if (decision === 'accept_revision') {
      // Doctor accepts revision -> back to KYP pending for revision
      await updateRoleBucket(appSnapshot.docs[0].id, 'doctor', 'kyp_pending');
      await updateRoleBucket(appSnapshot.docs[0].id, 'hospital', 'pending');
    } else if (decision === 'not_accept') {
      // Doctor does not accept hospital challenge -> rejected
      await updateRoleBucket(appSnapshot.docs[0].id, 'doctor', 'rejected');
      await updateRoleBucket(appSnapshot.docs[0].id, 'hospital', 'rejected');
    }

    return { success: true };
  } catch (error) {
    console.error('Error responding to KYP challenge:', error);
    return { success: false, error: error.message };
  }
};

// Explicitly reset KYP approval to allow a new revision/approval cycle
export const resetKYPApproval = async (applicationId, { by, byName } = {}) => {
  try {
    const appQuery = query(
      collection(db, 'patientApplications'),
      where('applicationId', '==', applicationId)
    );
    const appSnapshot = await getDocs(appQuery);
    if (appSnapshot.empty) {
      return { success: false, error: 'Application not found' };
    }
    const appRef = doc(db, 'patientApplications', appSnapshot.docs[0].id);
    await updateDoc(appRef, {
      'workflow.medicalVerification.kypApproval': null,
      updatedAt: new Date(),
    });
    return { success: true };
  } catch (error) {
    console.error('Error resetting KYP approval:', error);
    return { success: false, error: error.message };
  }
};

// Set doctor approval/rejection for the generated KYP
export const setKYPApproval = async (applicationId, doctorId, { status, reason = '', doctorName = '', approvedAt = null, rejectedAt = null }) => {
  try {
    if (!['approved', 'rejected'].includes(status)) {
      return { success: false, error: 'Invalid status' };
    }

    // Find application
    const appQuery = query(
      collection(db, 'patientApplications'),
      where('applicationId', '==', applicationId)
    );
    const appSnapshot = await getDocs(appQuery);
    if (appSnapshot.empty) {
      return { success: false, error: 'Application not found' };
    }
    const appDoc = appSnapshot.docs[0];
    const appData = appDoc.data();
    const appRef = doc(db, 'patientApplications', appDoc.id);

    const baseApproval = {
      status, // 'approved' | 'rejected'
      reason: reason || '',
      by: doctorId,
      byName: doctorName || null,
      at: new Date(),
      ...(approvedAt ? { approvedAt } : {}),
      ...(rejectedAt ? { rejectedAt } : {}),
    };

    await updateDoc(appRef, {
      'workflow.medicalVerification.kypApproval': baseApproval,
      // If hospital had previously challenged the KYP, reset their acknowledgement
      // back to pending so they can re-review the revised KYP
      ...(status === 'approved'
        ? {
            'workflow.medicalVerification.kypHospitalAcknowledgement.status': 'pending',
            // Clear any previous challenge comment to avoid confusing messages with revised KYP
            'workflow.medicalVerification.kypHospitalAcknowledgement.comment': '',
            'workflow.medicalVerification.kypHospitalAcknowledgement.revisedAt': new Date(),
            'workflow.medicalVerification.kypHospitalAcknowledgement.revisedBy': doctorId,
            'workflow.medicalVerification.kypHospitalAcknowledgement.revisedByName': doctorName || null,
          }
        : {}),
      updatedAt: new Date()
    });

    // If approved, notify hospital users to review the revised KYP
    if (status === 'approved') {
      try {
        const patientName = appData?.patient?.name || 'Patient';
        const appIdStr = appData?.applicationId || applicationId;
        const hospitalId = appData?.hospitalId || null;

        // Prefer notifying all hospital users tied to this hospital so it shows in their notification center
        if (hospitalId) {
          const usersQuery = query(
            collection(db, 'users'),
            where('role', '==', 'Hospital'),
            where('hospitalId', '==', hospitalId)
          );
          const usersSnap = await getDocs(usersQuery);

          const notifPromises = usersSnap.docs.map((u) =>
            createNotification({
              recipientId: u.id,
              recipientType: 'user',
              type: 'application',
              subType: 'kyp_revision_completed',
              title: 'Revised KYP Approved',
              message: `Doctor ${doctorName || doctorId} approved the revised KYP for ${patientName} (ID: ${appIdStr}).`,
              applicationId: appIdStr,
              actionUrl: `/hospital/application/${appIdStr}`,
              priority: 'high',
              metadata: {
                patientName,
                hospitalId,
                approvedBy: doctorName || doctorId,
              },
            })
          );
          await Promise.allSettled(notifPromises);
        }

        // As a fallback, also drop a hospital-level notification if hospitalId exists
        if (hospitalId) {
          await createNotification({
            recipientId: hospitalId,
            recipientType: 'hospital',
            type: 'application',
            subType: 'kyp_revision_completed',
            title: 'Revised KYP Approved',
            message: `Doctor ${doctorName || doctorId} approved the revised KYP for ${patientName} (ID: ${appIdStr}).`,
            applicationId: appIdStr,
            actionUrl: `/hospital/application/${appIdStr}`,
            priority: 'high',
            metadata: { patientName, approvedBy: doctorName || doctorId },
          });
        }
      } catch (notifyErr) {
        console.warn('Failed to notify hospital on KYP approval:', notifyErr);
      }
    }

    return { success: true };
  } catch (error) {
    console.error('Error setting KYP approval:', error);
    return { success: false, error: error.message };
  }
};

// Get doctor dashboard statistics
export const getDoctorStats = async (doctorId) => {
  try {
    // OPTIMIZED: Use aggregation queries and limits instead of fetching all documents
    
    // Get count of pending applications (limit to reasonable number for stats)
    const pendingQuery = query(
      collection(db, "patientApplications"),
      where("status", "in", [
        "submitted", 
        "medical_review_pending", 
        "under_medical_review",
        "medical_review_paused",
        "approved_for_process"
      ]),
      where("workflow.medicalReview.status", "in", ["pending", "in_progress", "paused"]),
      limit(1000) // Limit for performance - adjust based on your needs
    );
    const pendingSnapshot = await getDocs(pendingQuery);

    // Get only recent reviewed applications for stats (last 100 for efficiency)
    const reviewedQuery = query(
      collection(db, "patientApplications"),
      where("workflow.medicalVerification.verifiedBy", "==", doctorId),
      orderBy("workflow.medicalVerification.verifiedAt", "desc"),
      limit(100) // Only need recent reviews for meaningful stats
    );
    const reviewedSnapshot = await getDocs(reviewedQuery);

    // Get today's reviews
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const todayTimestamp = Timestamp.fromDate(today);

    let reviewedToday = 0;
    let totalReviewTime = 0;
    let approvedCount = 0;
    let rejectedCount = 0;
    let pendingInfoCount = 0;
    let emergencyPending = 0;
    let approvedForProcessCount = 0;

    // Count emergency cases in pending (only from limited set)
    pendingSnapshot.forEach((doc) => {
      const data = doc.data();
      if (data.emergency) {
        emergencyPending++;
      }
      if (data.workflow?.medicalVerification?.approvedForProcess) {
        approvedForProcessCount++;
      }
    });

    // Calculate stats from reviewed applications (from limited recent set)
    reviewedSnapshot.forEach((doc) => {
      const data = doc.data();
      const reviewedAt = data.workflow?.medicalVerification?.verifiedAt;

      if (reviewedAt && reviewedAt >= todayTimestamp) {
        reviewedToday++;
      }

      if (data.workflow?.medicalVerification?.reviewTimeMinutes) {
        totalReviewTime += data.workflow.medicalVerification.reviewTimeMinutes;
      }

      const status = data.workflow?.medicalVerification?.status;
      if (status === "approved") approvedCount++;
      else if (status === "rejected") rejectedCount++;
      else if (status === "pending_info") pendingInfoCount++;
    });

    const averageReviewTime =
      reviewedSnapshot.size > 0
        ? Math.round(totalReviewTime / reviewedSnapshot.size)
        : 0;

    const approvalRate =
      reviewedSnapshot.size > 0
        ? Math.round((approvedCount / reviewedSnapshot.size) * 100)
        : 0;

    return {
      success: true,
      stats: {
        pendingReview: pendingSnapshot.size,
        reviewedToday,
        totalReviewed: reviewedSnapshot.size, // This is now based on recent 100, not all time
        averageReviewTime,
        emergencyPending,
        approvalRate,
        approvedCount,
        rejectedCount,
        pendingInfoCount,
        approvedForProcessCount,
      },
    };
  } catch (error) {
    console.error("Error getting doctor stats:", error);
    return {
      success: false,
      error: error.message,
      stats: {
        pendingReview: 0,
        reviewedToday: 0,
        totalReviewed: 0,
        averageReviewTime: 0,
        emergencyPending: 0,
        approvalRate: 0,
        approvedCount: 0,
        rejectedCount: 0,
        pendingInfoCount: 0,
        approvedForProcessCount: 0,
      },
    };
  }
};

// Helper to derive Doctor dashboard lifecycle stage (Granular V2 - 2025-09-28)
// Ordered precedence (first match wins):
// 1. query_raised                       -> Active unresolved queries (application on hold / dispute)
// 2. rejected_challenge                 -> A previously challenged KYP/FAL now rejected
// 3. rejected                           -> Medical / KYP / FAL rejection (no prior challenge state captured)
// 4. kyp_query_reply_received           -> Query reply received (status under_review) while still pre-KYP acceptance
// 5. discharge_query_reply_received     -> Query reply received during discharge phase (before FAL acceptance)
// 6. scrutiny_query_reply_received      -> Query reply received during scrutiny (after FAL acceptance but before closure)
// 7. kyp_challenged                     -> Hospital challenged KYP
// 8. fal_challenged                     -> Hospital challenged FAL (any sanction challenged)
// 9. kyp_pending                        -> Policy ready but KYP not yet generated / approved / accepted
// 10. kyp_approved                      -> KYP accepted, no discharge start, no FAL generated
// 11. discharge_pending                 -> Discharge initiated / docs uploaded, FAL not yet accepted
// 12. discharge_approved                -> FAL generated but not yet accepted by hospital
// 13. fal_approved (legacy)             -> FAL accepted (all sanctions accepted)
// 14. scrutiny_pending                  -> Post FAL acceptance, docs in scrutiny (pre dispatch / no disbursal / no recovery)
// 15. scrutiny_approved                 -> Scrutiny explicitly approved / cleared (heuristic)
// 16. new                               -> Fallback initial bucket
// 17. (catch-all)                       -> new
// NOTE: Many of these phases are heuristic until explicit workflow flags exist.
// If data attributes are absent the stage will gracefully fall back to broader classifications.
const deriveStageForDoctor = (application) => {
  const w = application?.workflow || {};
  const mv = w.medicalVerification || {};
  const pv = w.policyVerification || {};
  const ds = w.dischargeSettlement || {};
  const dispatch = w.dispatch || w.dispatches || {};
  const sanctions = w?.sanctions;
  const disb = w.disbursal || {};
  const recovery = w.recovery || {};

  // KYP flags
  const kypAckStatus = mv?.kypHospitalAcknowledgement?.status || mv?.kypAck || mv?.kypStatus;
  const kypApprovalStatus = mv?.kypApproval?.status; // explicit doctor-side KYP approval state
  const kypAccepted = ['accepted', 'approved'].includes(kypAckStatus) || kypApprovalStatus === 'approved';
  const kypChallenged = kypAckStatus === 'challenged';
  const kypRejected = (kypAckStatus === 'rejected') || (kypApprovalStatus === 'rejected');

  // FAL flags
  const falAck = ds?.hospitalAcknowledgement?.status;
  const anyFalChallenged = Array.isArray(sanctions) && sanctions.some(s => s?.hospitalAcknowledgement?.status === 'challenged');
  const anyFalRejected = Array.isArray(sanctions) && sanctions.some(s => s?.hospitalAcknowledgement?.status === 'rejected');
  const allFalAccepted = (Array.isArray(sanctions) && sanctions.length > 0 && sanctions.every(s => s?.hospitalAcknowledgement?.status === 'accepted')) || falAck === 'accepted';
  const falGenerated = !!ds?.finalApprovalLetterUrl;

  // Discharge / document flags
  const hasUploadedDischargeDocs = Array.isArray(ds?.uploadedDocuments)
    ? ds.uploadedDocuments.length > 0
    : (Array.isArray(ds?.documents) && ds.documents.length > 0);
  const dischargeStarted = application?.dischargeInitiated || ds?.status;
  const hasDispatch = !!dispatch?.status || (Array.isArray(dispatch) && dispatch.length > 0);

  // Query status heuristics
  const unresolvedQueryCount = application?.queryStatus?.queryCount || 0;
  const hasUnresolvedQueries = unresolvedQueryCount > 0 || application?.status === 'dispute_pending';
  // Query reply received if disputes have a hospital reply awaiting doctor's review/acceptance
  const queryReplyReceived = !!(application?.queryReplies && application.queryReplies.hasHospitalReply);
  const diagnosisApprovalPending = !!(application?.queryReplies && application.queryReplies.hasAcceptedReply && (mv?.status === 'pending'));

  // Rejection grouping (broadened to capture generic and legacy flags)
  const medicalRejected = application?.status === 'medical_rejected' || application?.status === 'rejected';
  const falRejected = anyFalRejected || falAck === 'rejected' || application?.status === 'fal_rejected';
  const isRejected = medicalRejected || kypRejected || falRejected;

  // 1. Query Raised
  if (hasUnresolvedQueries) return 'query_raised';

  // 2. Rejected Challenge (a rejection after a challenge state)
  if (isRejected && (kypChallenged || anyFalChallenged)) return 'rejected_challenge';

  // 3. Rejected (generic)
  if (isRejected) return 'rejected';

  // Context phase helpers for categorising query reply buckets
  const inKypPhase = !kypAccepted && !kypChallenged && !kypRejected;
  const inDischargePhase = (kypAccepted && (dischargeStarted || hasUploadedDischargeDocs) && !allFalAccepted && !falRejected);
  const inScrutinyPhase = allFalAccepted && !disb?.status && !recovery?.pendingTasks;

  // 4/5/6. Query reply received contextual buckets
  if (diagnosisApprovalPending) {
    return 'diagnosis_approval_pending';
  }

  if (queryReplyReceived) {
    if (inKypPhase) return 'kyp_query_reply_received';
    if (inDischargePhase) return 'discharge_query_reply_received';
    if (inScrutinyPhase) return 'scrutiny_query_reply_received';
  }

  // 7. KYP Challenged
  if (kypChallenged) return 'kyp_challenged';

  // 8. FAL Challenged
  if (anyFalChallenged || falAck === 'challenged') return 'fal_challenged';

  // 9. KYP Pending (tighten to avoid misclassifying rejected/queried cases)
  const policyReady = !!(pv?.status === 'completed' || pv?.coverageBreakdown || pv?.policyDetails);
  const kypGeneratedOrApproved = (mv?.kypGenerated || kypApprovalStatus === 'approved' || kypAccepted);
  const blockedByHoldOrRejection = isRejected || application?.status === 'dispute_pending';
  if (policyReady && !kypGeneratedOrApproved && !blockedByHoldOrRejection) return 'kyp_pending';

  // 10. KYP Approved
  if (kypAccepted && !dischargeStarted && !hasUploadedDischargeDocs && !falGenerated) return 'kyp_approved';

  // 11. Discharge Pending
  if ((dischargeStarted || hasUploadedDischargeDocs) && !falGenerated && !allFalAccepted) return 'discharge_pending';

  // 12. Discharge Approved (FAL generated but not yet accepted)
  if (falGenerated && !allFalAccepted) return 'discharge_approved';

  // 13. FAL Approved (legacy key kept for compatibility)
  if (allFalAccepted) {
    // Potentially differentiate between scrutiny pending & approved below
    // Scrutiny phases follow after FAL acceptance
    // We'll fall through for scrutiny states rather than early return if post-acceptance signals found
  }

  // 14. Scrutiny Pending (after FAL accepted but before any dispatch completion / disbursal / recovery)
  if (allFalAccepted && !hasDispatch && !disb?.status) return 'scrutiny_pending';

  // 15. Scrutiny Approved (heuristic: dispatch started but no disbursal yet OR explicit ds.scrutiny.status === 'approved')
  const scrutinyApprovedSignal = ds?.scrutiny?.status === 'approved' || hasDispatch;
  if (allFalAccepted && scrutinyApprovedSignal && !disb?.status) return 'scrutiny_approved';

  // If FAL accepted and none of the scrutiny buckets matched, treat as fal_approved
  if (allFalAccepted) return 'fal_approved';

  // 16/17. Default new
  return 'new';
};

// Helper to derive application stage for Finance dashboard bifurcation
// Updated Stages (UI tabs):
// 'new'                - diagnosis approved / enters finance pipeline after medical approval
// 'financialApproved'  - finance verification completed / approved
// 'falAccepted'        - hospital accepted Final Approval Letter
// 'enachCompleted'     - eNach mandate completed
// 'scrutiny'           - documents uploaded for dispatch (pre-dispatch scrutiny of discharge/dispatch docs)
// 'pod'                - Proof of Dispatch stage (courier / physical docs acknowledgement)
// 'disbursement'       - disbursement workflow active
// 'claimFollowUps'     - post disbursement claim follow-up tasks pending
// 'query'              - disputes / clarification pending
// (legacy mapping preserved for backward compatibility: 'discharge', 'dispatch')
const deriveStageForFinance = (application) => {
  const w = application?.workflow || {};
  const mv = w.medicalVerification || {};
  const ds = w.dischargeSettlement || {};
  const dispatch = w.dispatch || w.dispatches || {};
  const disb = w.disbursal || {};
  const fin = w.financialVerification || {};
  const enach = w.enach || w.eNach || {}; // tolerate naming variants
  const recovery = w.recovery || {}; // claim follow-ups
  const podInfo = w.proofOfDispatch || w.pod || {}; // POD tracking

  // 1. Query: active disputes / finance clarification

  if (application?.status === 'dispute_pending' || application?.status === 'pending_financial_clarification') {
    return 'query';
  }

  // 2. Claim Follow-ups: recovery tracking tasks after disbursement
  if (recovery && (recovery.pendingTasks || recovery.followUpsPending || recovery.status === 'follow_up')) {
    return 'claimFollowUps';
  }

  // 3. Disbursement: active disbursement workflow
  if (disb && (disb.status || disb.finalAmount || disb.letterGenerated)) {
    return 'disbursement';
  }

  // 4. POD (Proof of Dispatch): after dispatch initiated and POD recorded/awaited
  if (podInfo && (podInfo.status || podInfo.trackingNumber || podInfo.acknowledgedAt)) {
    return 'pod';
  }

  // 5. eNach Completed
  if (enach && (enach.status === 'completed' || enach.completedAt)) {
    return 'enachCompleted';
  }

  // 6. FAL Accepted (hospital accepted) - treat as accepted if any sanction or main ack is accepted
  const allFalAccepted = !!(
    (ds?.finalApprovalLetterUrl || ds?.finalApprovalLetterId) && (
      ds?.hospitalAcknowledgement?.status === 'accepted' ||
      (Array.isArray(w?.sanctions) && w.sanctions.some(s => s?.hospitalAcknowledgement?.status === 'accepted'))
    )
  );
  if (allFalAccepted) {
    return 'falAccepted';
  }

  // 7. Scrutiny (documents uploaded awaiting dispatch) OR legacy 'dispatch' stage before POD
  const hasDispatch = !!dispatch?.status || (Array.isArray(dispatch) && dispatch.length > 0);
  const hasUploadedDocs = Array.isArray(ds?.uploadedDocuments)
    ? ds.uploadedDocuments.length > 0
    : (Array.isArray(ds?.documents) && ds.documents.length > 0);
  if (hasUploadedDocs && !hasDispatch) {
    return 'scrutiny';
  }
  if (hasDispatch) {
    return 'dispatch'; // legacy fallback if needed
  }

  // 8. Financial Approved (finance verification done & approved) before discharge docs
  if (fin?.status === 'approved' || fin?.approvedAt) {
    return 'financialApproved';
  }

  // 9. New application (entered finance after medical/diagnosis approved) - default
  return 'new';
};

// Approve application for process (early approval)
export const approveApplicationForProcess = async (applicationId, doctorId, approvalData) => {
  try {
    // First check if application can proceed (no unresolved queries)
    const canProceed = await canApplicationProceed(applicationId, 'medical');
    
    if (!canProceed.success) {
      return {
        success: false,
        error: "Error validating application status",
        details: canProceed.error
      };
    }

    if (!canProceed.canProceed) {
      return {
        success: false,
        error: "Cannot approve application - there are unresolved queries that must be addressed first",
        reason: canProceed.reason,
        unresolvedQueries: canProceed.unresolvedQueries,
        queryCount: canProceed.queryCount
      };
    }

    const appQuery = query(
      collection(db, "patientApplications"),
      where("applicationId", "==", applicationId)
    );
    const appSnapshot = await getDocs(appQuery);

    if (appSnapshot.empty) {
      return { success: false, error: "Application not found" };
    }

    const appRef = doc(db, "patientApplications", appSnapshot.docs[0].id);
    const appData = appSnapshot.docs[0].data();

    // Update application with early approval status
    await updateDoc(appRef, {
      status: "approved_for_process",
      "workflow.medicalVerification.approvedForProcess": true,
      "workflow.medicalVerification.approvedForProcessBy": doctorId,
      "workflow.medicalVerification.approvedForProcessAt": new Date(),
      "workflow.medicalVerification.approvalForProcessComments": approvalData.comments,
      updatedAt: new Date(),
    });

    // Fire-and-forget email: Diagnosis approved (early approval)
    (async () => {
      try {
        const subject = `Diagnosis Approved (Early): ${applicationId}`;
        const html = `<!DOCTYPE html><html><body style="font-family:Arial,Helvetica,sans-serif;line-height:1.5;color:#0f172a;">
          <h2 style="color:#0f766e;margin:0 0 12px;">Diagnosis Approved for Processing</h2>
          <p style="margin:0 0 8px;">Application <strong>${applicationId}</strong> has been marked as <em>Approved for Process</em> by the medical team.</p>
          <p style="margin:8px 0 0;font-size:12px;color:#64748b;">This is an automated notification.</p>
        </body></html>`;
        await sendEmail({ to: 'cssg@samhealth.co.in', subject, html });

        // Send push notification
        const patientName = appData?.patient?.name || 'Patient';
        await sendDoctorApprovalPushNotification(applicationId, patientName);
      } catch (e) {
        console.warn('Non-blocking email failed (approveApplicationForProcess):', e?.message || e);
      }
    })();

    return {
      success: true,
      message: "Application approved for process successfully",
    };
  } catch (error) {
    console.error("Error approving application for process:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// OLD VERSION - DEPRECATED - Kept for reference/rollback
// This version uses client-side filtering with deriveStageForDoctor()
// Replaced with query-side filtering implementation below
/*
export const getDoctorApplications_OLD = async (
  filters = {},
  page = 1,
  pageSize = 10,
  getAllApplications = false
) => {
  try {
    // Step 1: Build base query for fetching all applications (for stage counts)
    let baseQuery = collection(db, "patientApplications");

    if (!getAllApplications) {
      // Base filter for pending applications
      baseQuery = query(
        baseQuery,
        where("workflow.medicalVerification.status", "==", "pending"),
        where("status", "in", [
          "submitted", 
          "medical_review_pending", 
          "under_medical_review",
          "medical_review_paused",
          "approved_for_process",
          "policy_approved",
          "under_review"
        ])
      );
    }

    // Apply common filters to base query
    if (filters.status && filters.status !== "") {
      baseQuery = query(baseQuery, where("status", "==", filters.status));
    }
    if (filters.priority && filters.priority !== "") {
      baseQuery = query(baseQuery, where("priority", "==", filters.priority));
    }
    if (filters.emergency !== "" && filters.emergency !== undefined) {
      const isEmergency = filters.emergency === "true";
      baseQuery = query(baseQuery, where("emergency", "==", isEmergency));
    }
    if (filters.treatmentType && filters.treatmentType !== "") {
      baseQuery = query(baseQuery, where("medical.treatmentType", "==", filters.treatmentType));
    }
    if (filters.insuranceCompany && filters.insuranceCompany !== "") {
      baseQuery = query(baseQuery, where("policy.insuranceCompany", "==", filters.insuranceCompany));
    }
    if (filters.hospitalName && filters.hospitalName !== "") {
      baseQuery = query(baseQuery, where("hospitalName", "==", filters.hospitalName));
    }

    // Apply ordering
    if (!getAllApplications) {
      baseQuery = query(baseQuery, orderBy("emergency", "desc"), orderBy("submittedAt", "desc"));
    } else {
      baseQuery = query(baseQuery, orderBy("submittedAt", "desc"));
    }

    // Step 2: Fetch all applications for building stage counts
    const allSnapshot = await getDocs(baseQuery);
    let allApplications = [];

    allSnapshot.forEach((doc) => {
      const data = doc.data();
      allApplications.push({
        id: doc.id,
        ...data,
      });
    });

    // Step 3: Enrich all applications with query status
    try {
      const enriched = await Promise.all(allApplications.map(async (app) => {
        let queryStatus = null;
        let queryReplies = { hasHospitalReply: false, replyCount: 0 };
        try {
          queryStatus = await checkApplicationQueryStatus(app.applicationId);
        } catch (_) {}
        try {
          const { getApplicationDisputes } = await import('./disputeService');
          const disputesRes = await getApplicationDisputes(app.applicationId);
          if (disputesRes?.success && Array.isArray(disputesRes.disputes)) {
            const doctorId = filters?._doctorId ? String(filters._doctorId) : null;
            const relevant = disputesRes.disputes.filter((d) => {
              const raisedBy = d?.raisedBy || {};
              const raisedByDoctor = (doctorId && String(raisedBy.userId || '') === doctorId) || (String((raisedBy.department || '').toLowerCase()) === 'medical');
              if (!raisedByDoctor) return false;
              const hasResolverResponse = !!d?.resolverResponse;
              const hasHospitalCommunication = Array.isArray(d?.communications) && d.communications.some((c) => (c?.fromDepartment || '').toLowerCase() === 'hospital');
              const status = (d?.status || '').toLowerCase();
              const isActiveReply = ['raised','acknowledged','under_review','resolved'].includes(status) && status !== 'accepted';
              return (hasResolverResponse || hasHospitalCommunication) && isActiveReply;
            });
            const accepted = (disputesRes.disputes || []).filter((d) => {
              const raisedBy = d?.raisedBy || {};
              const raisedByDoctor = (doctorId && String(raisedBy.userId || '') === doctorId) || (String((raisedBy.department || '').toLowerCase()) === 'medical');
              if (!raisedByDoctor) return false;
              const status = (d?.status || '').toLowerCase();
              const flagAccepted = d?.accepted === true;
              const commAccepted = Array.isArray(d?.communications) && d.communications.some((c) => (c?.type || '').toLowerCase() === 'accepted');
              return flagAccepted || status === 'accepted' || commAccepted;
            });
            queryReplies = { hasHospitalReply: relevant.length > 0, replyCount: relevant.length, hasAcceptedReply: accepted.length > 0 };
          }
        } catch (_) {}
        return { ...app, queryStatus, queryReplies };
      }));
      allApplications = enriched;
    } catch (_) {}

    // Step 4: Build stage counts from all applications
    const stageCountsSeed = {
      all: 0,
      query_raised: 0,
      rejected_challenge: 0,
      rejected: 0,
      kyp_query_reply_received: 0,
      discharge_query_reply_received: 0,
      scrutiny_query_reply_received: 0,
      diagnosis_approval_pending: 0,
      kyp_challenged: 0,
      fal_challenged: 0,
      kyp_pending: 0,
      kyp_approved: 0,
      discharge_pending: 0,
      discharge_approved: 0,
      fal_approved: 0,
      scrutiny_pending: 0,
      scrutiny_approved: 0,
      new: 0
    };
    
    let stageCounts = allApplications.reduce((acc, app) => {
      const stage = deriveStageForDoctor(app);
      if (acc[stage] === undefined) acc[stage] = 0;
      acc[stage] += 1;
      acc.all += 1;
      return acc;
    }, stageCountsSeed);

    // Override stage counts with doctor-specific filtering where needed
    if (filters && filters._doctorId) {
      const doctorIdForBadge = String(filters._doctorId);
      
      // Query Raised - only doctor's own queries
      const doctorQueryRaisedCount = allApplications.reduce((count, app) => {
        const stage = deriveStageForDoctor(app);
        if (stage !== 'query_raised') return count;
        const qs = app?.queryStatus;
        if (!qs || !qs.hasUnresolvedQueries || !Array.isArray(qs.unresolvedQueries)) return count;
        const hasDoctorRaised = qs.unresolvedQueries.some((d) => String((d?.raisedBy || {}).userId || '') === doctorIdForBadge);
        return hasDoctorRaised ? count + 1 : count;
      }, 0);
      
      // KYP Query Reply Received - only with hospital replies
      const doctorKypReplyCount = allApplications.reduce((count, app) => {
        const stage = deriveStageForDoctor(app);
        if (stage !== 'kyp_query_reply_received') return count;
        const replies = app?.queryReplies;
        return replies && replies.hasHospitalReply ? count + 1 : count;
      }, 0);

      // Diagnosis Approval Pending - only with accepted replies
      const doctorDiagPending = allApplications.reduce((count, app) => {
        const stage = deriveStageForDoctor(app);
        if (stage !== 'diagnosis_approval_pending') return count;
        const replies = app?.queryReplies;
        return replies && replies.hasAcceptedReply ? count + 1 : count;
      }, 0);

      // New - exclude diagnosis-approved applications
      const newCount = allApplications.reduce((count, app) => {
        const stage = deriveStageForDoctor(app);
        if (stage !== 'new') return count;
        const mv = app?.workflow?.medicalVerification || {};
        const diagnosisApproved = mv.status === 'approved' || mv.approvedForProcess === true || app?.status === 'approved_for_process';
        return diagnosisApproved ? count : count + 1;
      }, 0);

      stageCounts = { 
        ...stageCounts, 
        query_raised: doctorQueryRaisedCount,
        kyp_query_reply_received: doctorKypReplyCount,
        diagnosis_approval_pending: doctorDiagPending,
        new: newCount
      };
    }

    // Step 5: Filter applications by stage if specified
    let filteredApplications = allApplications;

    if (filters && typeof filters._stage === 'string' && filters._stage !== '' && filters._stage !== 'all') {
      filteredApplications = allApplications.filter((app) => {
        const stage = deriveStageForDoctor(app);
        if (stage !== filters._stage) return false;

        // Additional refinements for specific buckets
        if (filters._stage === 'new') {
          const mv = app?.workflow?.medicalVerification || {};
          const diagnosisApproved = mv.status === 'approved' || mv.approvedForProcess === true || app?.status === 'approved_for_process';
          return !diagnosisApproved;
        }

        if (filters._stage === 'query_raised' && filters._doctorId) {
          const doctorId = String(filters._doctorId);
          const qs = app?.queryStatus;
          if (!qs || !qs.hasUnresolvedQueries || !Array.isArray(qs.unresolvedQueries)) return false;
          return qs.unresolvedQueries.some((d) => String((d?.raisedBy || {}).userId || '') === doctorId);
        }

        if (filters._stage === 'kyp_query_reply_received') {
          return app?.queryReplies && app.queryReplies.hasHospitalReply;
        }

        if (filters._stage === 'diagnosis_approval_pending') {
          return app?.queryReplies && app.queryReplies.hasAcceptedReply;
        }

        return true;
      });
    }

    // Step 6: Apply client-side filters (search, date range, amount range)
    if (filters.searchTerm && filters.searchTerm.trim() !== "") {
      const searchTerm = filters.searchTerm.toLowerCase();
      filteredApplications = filteredApplications.filter(
        (app) =>
          app.applicationId?.toLowerCase().includes(searchTerm) ||
          app.patient?.name?.toLowerCase().includes(searchTerm) ||
          app.medical?.diagnosis?.toLowerCase().includes(searchTerm) ||
          app.hospitalName?.toLowerCase().includes(searchTerm) ||
          app.medical?.doctor?.name?.toLowerCase().includes(searchTerm)
      );
    }

    if (filters.dateFrom && filters.dateFrom !== "") {
      const fromDate = new Date(filters.dateFrom);
      filteredApplications = filteredApplications.filter((app) => {
        const submittedDate = app.submittedAt?.toDate
          ? app.submittedAt.toDate()
          : new Date(app.submittedAt);
        return submittedDate >= fromDate;
      });
    }

    if (filters.dateTo && filters.dateTo !== "") {
      const toDate = new Date(filters.dateTo);
      toDate.setHours(23, 59, 59, 999);
      filteredApplications = filteredApplications.filter((app) => {
        const submittedDate = app.submittedAt?.toDate
          ? app.submittedAt.toDate()
          : new Date(app.submittedAt);
        return submittedDate <= toDate;
      });
    }

    if (filters.minAmount && filters.minAmount !== "") {
      const minAmount = parseFloat(filters.minAmount);
      filteredApplications = filteredApplications.filter(
        (app) => (app.medical?.estimatedCost || 0) >= minAmount
      );
    }

    if (filters.maxAmount && filters.maxAmount !== "") {
      const maxAmount = parseFloat(filters.maxAmount);
      filteredApplications = filteredApplications.filter(
        (app) => (app.medical?.estimatedCost || 0) <= maxAmount
      );
    }

    // Step 7: Sort filtered applications
    filteredApplications.sort((a, b) => {
      if (!getAllApplications) {
        const aApproved = a.workflow?.medicalVerification?.approvedForProcess || false;
        const bApproved = b.workflow?.medicalVerification?.approvedForProcess || false;
        
        if (aApproved && !bApproved) return -1;
        if (!aApproved && bApproved) return 1;
        
        if (a.emergency && !b.emergency) return -1;
        if (!a.emergency && b.emergency) return 1;
      }
      
      const aDate = a.submittedAt?.toDate ? a.submittedAt.toDate() : new Date(a.submittedAt);
      const bDate = b.submittedAt?.toDate ? b.submittedAt.toDate() : new Date(b.submittedAt);
      return bDate - aDate;
    });

    // Step 8: Apply pagination
    const total = filteredApplications.length;
    let effectivePage = page;
    let effectivePageSize = pageSize;
    let paginatedApplications = filteredApplications;
    let totalPages = Math.ceil(total / pageSize);

    if (filters && filters._fetchAll === true) {
      effectivePage = 1;
      effectivePageSize = total;
      totalPages = 1;
    } else {
      const startIndex = (page - 1) * pageSize;
      paginatedApplications = filteredApplications.slice(
        startIndex,
        startIndex + pageSize
      );
    }

    return {
      success: true,
      applications: paginatedApplications,
      total,
      page: effectivePage,
      pageSize: effectivePageSize,
      totalPages,
      stageCounts,
    };
  } catch (error) {
    console.error("Error getting doctor applications:", error);
    return {
      success: false,
      error: error.message,
      applications: [],
      total: 0,
    };
  }
};
*/
// END OLD VERSION

/**
 * Build Firestore query for specific doctor bucket/stage with query-side filtering
 * @param {string} stage - Bucket stage (new, kyp_pending, discharge_pending, etc.)
 * @param {object} filters - Additional filters (doctorId, status, priority, etc.)
 * @returns {Query} Firestore query
 */
const buildDoctorBucketQuery = (stage, filters = {}) => {
  let constraints = [];

  // Base constraints for pending applications (unless fetching all)
  if (!filters._getAllApplications) {
    constraints.push(
      where("workflow.medicalVerification.status", "==", "pending")
    );
    constraints.push(
      where("status", "in", [
        "submitted",
        "medical_review_pending",
        "under_medical_review",
        "medical_review_paused",
        "approved_for_process",
        "policy_approved",
        "under_review"
      ])
    );
  }

  // Bucket-specific constraints
  switch (stage) {
    case "query_raised":
      constraints = []; // Clear base constraints
      constraints.push(
        where("status", "in", ["dispute_pending", "medical_review_paused"])
      );
      break;

    case "rejected_challenge":
      constraints = []; // Clear base constraints
      constraints.push(
        where("status", "in", ["medical_rejected", "rejected", "fal_rejected"])
      );
      // Note: Also checking challenged status requires post-query filtering
      break;

    case "rejected":
      constraints = []; // Clear base constraints
      constraints.push(
        where("status", "in", ["medical_rejected", "rejected", "fal_rejected"])
      );
      break;

    case "kyp_challenged":
      constraints = []; // Clear base constraints
      constraints.push(
        where("workflow.medicalVerification.kypHospitalAcknowledgement.status", "==", "challenged")
      );
      break;

    case "fal_challenged":
      constraints = []; // Clear base constraints
      constraints.push(
        where("workflow.dischargeSettlement.hospitalAcknowledgement.status", "==", "challenged")
      );
      break;

    case "kyp_pending":
      constraints.push(
        where("workflow.policyVerification.status", "==", "completed")
      );
      break;

    case "kyp_approved":
      constraints = []; // Clear base constraints
      constraints.push(
        where("workflow.medicalVerification.kypHospitalAcknowledgement.status", "==", "accepted")
      );
      constraints.push(
        where("dischargeInitiated", "==", false)
      );
      break;

    case "discharge_pending":
      constraints = []; // Clear base constraints
      constraints.push(
        where("dischargeInitiated", "==", true)
      );
      break;

    case "fal_approved":
    case "scrutiny_pending":
    case "scrutiny_approved":
      constraints = []; // Clear base constraints
      constraints.push(
        where("workflow.dischargeSettlement.hospitalAcknowledgement.status", "==", "accepted")
      );
      break;

    case "new":
      // Keep base constraints, just exclude diagnosis-approved
      break;

    case "all":
      // No additional stage-specific constraints
      break;

    default:
      // Default to base constraints for unknown stages
      break;
  }

  // Apply additional filters
  if (filters.status && filters.status !== "" && stage !== "query_raised" && stage !== "rejected" && stage !== "rejected_challenge") {
    constraints.push(where("status", "==", filters.status));
  }
  if (filters.priority && filters.priority !== "") {
    constraints.push(where("priority", "==", filters.priority));
  }
  if (filters.emergency !== "" && filters.emergency !== undefined) {
    const isEmergency = filters.emergency === "true";
    constraints.push(where("emergency", "==", isEmergency));
  }
  if (filters.treatmentType && filters.treatmentType !== "") {
    constraints.push(where("medical.treatmentType", "==", filters.treatmentType));
  }
  if (filters.insuranceCompany && filters.insuranceCompany !== "") {
    constraints.push(where("policy.insuranceCompany", "==", filters.insuranceCompany));
  }
  if (filters.hospitalName && filters.hospitalName !== "") {
    constraints.push(where("hospitalName", "==", filters.hospitalName));
  }

  // Apply ordering
  if (!filters._getAllApplications) {
    constraints.push(orderBy("emergency", "desc"));
    constraints.push(orderBy("submittedAt", "desc"));
  } else {
    constraints.push(orderBy("submittedAt", "desc"));
  }

  return constraints;
};

/**
 * Get doctor applications with improved query-side filtering
 * This version reduces client-side filtering by building better Firestore queries
 */
export const getDoctorApplications = async (
  filters = {},
  page = 1,
  pageSize = 10,
  getAllApplications = false
) => {
  try {
    const stage = filters._stage || "all";
    const doctorId = filters._doctorId;

    // Build query constraints for specific bucket
    const constraints = buildDoctorBucketQuery(stage, {
      ...filters,
      _getAllApplications: getAllApplications,
    });

    // Add server-side limit for true pagination
    const queryConstraints = [...constraints];
    
    // For server-side pagination, fetch one extra to know if there are more pages
    if (!filters._fetchAll && !getAllApplications) {
      queryConstraints.push(limit(pageSize + 1));
    }

    // Build and execute query with server-side limit
    let mainQuery = query(collection(db, "patientApplications"), ...queryConstraints);

    // Execute query
    const snapshot = await getDocs(mainQuery);
    let allApplications = [];

    snapshot.forEach((doc) => {
      const data = doc.data();
      allApplications.push({
        id: doc.id,
        ...data,
      });
    });

    // Determine if we have more pages (server-side check)
    const hasMore = !filters._fetchAll && !getAllApplications && allApplications.length > pageSize;
    
    // If we fetched extra for pagination check, trim it
    if (hasMore) {
      allApplications = allApplications.slice(0, pageSize);
    }

    // OPTIMIZED: Only enrich applications that will be displayed (not ALL applications)
    // This is the critical performance improvement - we only process the page we're showing
    const enrichedApplications = await Promise.all(allApplications.map(async (app) => {
      let queryStatus = null;
      let queryReplies = { hasHospitalReply: false, replyCount: 0 };
      
      // Only fetch query status if needed for display
      try {
        queryStatus = await checkApplicationQueryStatus(app.applicationId);
      } catch (_) {}
      
      // Only fetch disputes if in relevant stages
      const needsDisputeCheck = stage === 'query_raised' || stage === 'kyp_query_reply_received' || stage === 'diagnosis_approval_pending';
      if (needsDisputeCheck) {
        try {
          const { getApplicationDisputes } = await import('./disputeService');
          const disputesRes = await getApplicationDisputes(app.applicationId);
          if (disputesRes?.success && Array.isArray(disputesRes.disputes)) {
            const doctorIdStr = doctorId ? String(doctorId) : null;
            const relevant = disputesRes.disputes.filter((d) => {
              const raisedBy = d?.raisedBy || {};
              const raisedByDoctor = (doctorIdStr && String(raisedBy.userId || '') === doctorIdStr) || (String((raisedBy.department || '').toLowerCase()) === 'medical');
              if (!raisedByDoctor) return false;
              const hasResolverResponse = !!d?.resolverResponse;
              const hasHospitalCommunication = Array.isArray(d?.communications) && d.communications.some((c) => (c?.fromDepartment || '').toLowerCase() === 'hospital');
              const status = (d?.status || '').toLowerCase();
              const isActiveReply = ['raised','acknowledged','under_review','resolved'].includes(status) && status !== 'accepted';
              return (hasResolverResponse || hasHospitalCommunication) && isActiveReply;
            });
            const accepted = (disputesRes.disputes || []).filter((d) => {
              const raisedBy = d?.raisedBy || {};
              const raisedByDoctor = (doctorIdStr && String(raisedBy.userId || '') === doctorIdStr) || (String((raisedBy.department || '').toLowerCase()) === 'medical');
              if (!raisedByDoctor) return false;
              const status = (d?.status || '').toLowerCase();
              const flagAccepted = d?.accepted === true;
              const commAccepted = Array.isArray(d?.communications) && d.communications.some((c) => (c?.type || '').toLowerCase() === 'accepted');
              return flagAccepted || status === 'accepted' || commAccepted;
            });
            queryReplies = { hasHospitalReply: relevant.length > 0, replyCount: relevant.length, hasAcceptedReply: accepted.length > 0 };
          }
        } catch (_) {}
      }
      
      return { ...app, queryStatus, queryReplies };
    }));

    // For stage counts, we need to do a separate lightweight count query
    // This avoids fetching all documents just for counts
    const stageCounts = await getStageCountsOptimized(filters, doctorId);

    // Apply client-side filters only for fields that can't be indexed
    let filteredApplications = enrichedApplications;
    
    if (filters.searchTerm && filters.searchTerm.trim() !== "") {
      const searchTerm = filters.searchTerm.toLowerCase();
      filteredApplications = filteredApplications.filter(
        (app) =>
          app.applicationId?.toLowerCase().includes(searchTerm) ||
          app.patient?.name?.toLowerCase().includes(searchTerm) ||
          app.medical?.diagnosis?.toLowerCase().includes(searchTerm) ||
          app.hospitalName?.toLowerCase().includes(searchTerm) ||
          app.medical?.doctor?.name?.toLowerCase().includes(searchTerm)
      );
    }

    if (filters.dateFrom && filters.dateFrom !== "") {
      const fromDate = new Date(filters.dateFrom);
      filteredApplications = filteredApplications.filter((app) => {
        const submittedDate = app.submittedAt?.toDate
          ? app.submittedAt.toDate()
          : new Date(app.submittedAt);
        return submittedDate >= fromDate;
      });
    }

    if (filters.dateTo && filters.dateTo !== "") {
      const toDate = new Date(filters.dateTo);
      toDate.setHours(23, 59, 59, 999);
      filteredApplications = filteredApplications.filter((app) => {
        const submittedDate = app.submittedAt?.toDate
          ? app.submittedAt.toDate()
          : new Date(app.submittedAt);
        return submittedDate <= toDate;
      });
    }

    if (filters.minAmount && filters.minAmount !== "") {
      const minAmount = parseFloat(filters.minAmount);
      filteredApplications = filteredApplications.filter(
        (app) => (app.medical?.estimatedCost || 0) >= minAmount
      );
    }

    if (filters.maxAmount && filters.maxAmount !== "") {
      const maxAmount = parseFloat(filters.maxAmount);
      filteredApplications = filteredApplications.filter(
        (app) => (app.medical?.estimatedCost || 0) <= maxAmount
      );
    }

    // Server-side pagination - already limited by query
    const total = filteredApplications.length;
    const totalPages = hasMore ? page + 1 : page; // We know there's more if we got the extra doc

    return {
      success: true,
      applications: filteredApplications,
      total: filteredApplications.length,
      page,
      pageSize,
      totalPages,
      hasMore,
      stageCounts,
      requestedStage: stage,
      requestedGetAll: !!getAllApplications,
    };
  } catch (error) {
    console.error("Error getting doctor applications:", error);
    return {
      success: false,
      error: error.message,
      applications: [],
      total: 0,
    };
  }
};

// Optimized function to get stage counts without fetching all documents
const getStageCountsOptimized = async (filters = {}, doctorId = null) => {
  try {
    // For now, return estimated counts based on simple queries
    // In production, you'd want to maintain these counts in a separate document
    // or use Firestore's count() queries when available
    const stageCountsSeed = {
      all: 0,
      query_raised: 0,
      rejected_challenge: 0,
      rejected: 0,
      kyp_query_reply_received: 0,
      discharge_query_reply_received: 0,
      scrutiny_query_reply_received: 0,
      diagnosis_approval_pending: 0,
      kyp_challenged: 0,
      fal_challenged: 0,
      kyp_pending: 0,
      kyp_approved: 0,
      discharge_pending: 0,
      discharge_approved: 0,
      fal_approved: 0,
      scrutiny_pending: 0,
      scrutiny_approved: 0,
      new: 0
    };

    // For initial implementation, return seed counts
    // TODO: Implement efficient count aggregation using Firestore aggregation queries
    return stageCountsSeed;
  } catch (error) {
    console.error("Error getting stage counts:", error);
    return {
      all: 0,
      query_raised: 0,
      rejected_challenge: 0,
      rejected: 0,
      kyp_query_reply_received: 0,
      discharge_query_reply_received: 0,
      scrutiny_query_reply_received: 0,
      diagnosis_approval_pending: 0,
      kyp_challenged: 0,
      fal_challenged: 0,
      kyp_pending: 0,
      kyp_approved: 0,
      discharge_pending: 0,
      discharge_approved: 0,
      fal_approved: 0,
      scrutiny_pending: 0,
      scrutiny_approved: 0,
      new: 0
    };
  }
};

// Peek warm cache without triggering a network request.
export const peekDoctorApplicationsCache = (
  filters = {},
  page = 1,
  pageSize = 10,
  getAllApplications = false
) => {
  if (typeof window === 'undefined' || !window.__doctorAppsCache) return null;
  const stableSerialize = (value) => {
    if (value === null || typeof value !== 'object') return JSON.stringify(value);
    if (Array.isArray(value)) return `[${value.map((v) => stableSerialize(v)).join(',')}]`;
    const keys = Object.keys(value).sort();
    return `{${keys.map((k) => `${JSON.stringify(k)}:${stableSerialize(value[k])}`).join(',')}}`;
  };
  const cacheKey = `doctorApps:${stableSerialize({ filters, page, pageSize, getAllApplications })}`;
  const entry = window.__doctorAppsCache.store.get(cacheKey);
  if (!entry) return null;
  const { timestamp, data } = entry;
  const isFresh = Date.now() - timestamp < window.__doctorAppsCache.ttlMs;
  return isFresh ? data : null;
};

export const getAllApplicationsAdmin = async (
  filters = {},
  page = 1,
  pageSize = 10
) => {
  try {
    let q = collection(db, "patientApplications");

    // Apply status filter
    if (filters.status && filters.status !== "") {
      q = query(q, where("status", "==", filters.status));
    }

    // Apply priority filter
    if (filters.priority && filters.priority !== "") {
      q = query(q, where("priority", "==", filters.priority));
    }

    // Apply emergency filter
    if (filters.emergency !== "" && filters.emergency !== undefined) {
      const isEmergency = filters.emergency === "true";
      q = query(q, where("emergency", "==", isEmergency));
    }

    // Apply treatment type filter
    if (filters.treatmentType && filters.treatmentType !== "") {
      q = query(q, where("medical.treatmentType", "==", filters.treatmentType));
    }

    // Apply insurance company filter
    if (filters.insuranceCompany && filters.insuranceCompany !== "") {
      q = query(
        q,
        where("policy.insuranceCompany", "==", filters.insuranceCompany)
      );
    }

    // Apply hospital filter
    if (filters.hospitalName && filters.hospitalName !== "") {
      q = query(q, where("hospitalName", "==", filters.hospitalName));
    }

    // Order by priority and submission date (emergency first)
    q = query(q, orderBy("emergency", "desc"), orderBy("submittedAt", "desc"));

    const querySnapshot = await getDocs(q);
    let applications = [];

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      applications.push({
        id: doc.id,
        ...data,
      });
    });

    // Client-side filtering for search term
    if (filters.searchTerm && filters.searchTerm.trim() !== "") {
      const searchTerm = filters.searchTerm.toLowerCase();
      applications = applications.filter(
        (app) =>
          app.applicationId?.toLowerCase().includes(searchTerm) ||
          app.patient?.name?.toLowerCase().includes(searchTerm) ||
          app.medical?.diagnosis?.toLowerCase().includes(searchTerm) ||
          app.hospitalName?.toLowerCase().includes(searchTerm) ||
          app.medical?.doctor?.name?.toLowerCase().includes(searchTerm)
      );
    }

    // Client-side date filtering
    if (filters.dateFrom && filters.dateFrom !== "") {
      const fromDate = new Date(filters.dateFrom);
      applications = applications.filter((app) => {
        const submittedDate = app.submittedAt?.toDate
          ? app.submittedAt.toDate()
          : new Date(app.submittedAt);
        return submittedDate >= fromDate;
      });
    }

    if (filters.dateTo && filters.dateTo !== "") {
      const toDate = new Date(filters.dateTo);
      toDate.setHours(23, 59, 59, 999);
      applications = applications.filter((app) => {
        const submittedDate = app.submittedAt?.toDate
          ? app.submittedAt.toDate()
          : new Date(app.submittedAt);
        return submittedDate <= toDate;
      });
    }

    // Apply amount range filters
    if (filters.minAmount && filters.minAmount !== "") {
      const minAmount = parseFloat(filters.minAmount);
      applications = applications.filter(
        (app) => (app.medical?.estimatedCost || 0) >= minAmount
      );
    }

    if (filters.maxAmount && filters.maxAmount !== "") {
      const maxAmount = parseFloat(filters.maxAmount);
      applications = applications.filter(
        (app) => (app.medical?.estimatedCost || 0) <= maxAmount
      );
    }

    // Filter: challenged KYP reassigned to a specific team (client-side)
    if (filters.kypChallengedTo && ['policy', 'finance'].includes(filters.kypChallengedTo)) {
      applications = applications.filter((app) => {
        const mv = app?.workflow?.medicalVerification;
        if (mv?.kypHospitalAcknowledgement?.status !== 'challenged') return false;
        const reassignment = mv?.kypReassignment;
        if (!reassignment) return false;
        // Support legacy 'target' and new 'targets' array and 'both'
        if (reassignment?.target === 'both') return true;
        if (Array.isArray(reassignment?.targets)) {
          return reassignment.targets.includes(filters.kypChallengedTo);
        }
        return reassignment?.target === filters.kypChallengedTo;
      });
    }

    // Build Finance stage counts across the full (post basic-filter) result set
    const stageCountsFinance = applications.reduce((acc, app) => {
      const stage = deriveStageForFinance(app);
      acc[stage] = (acc[stage] || 0) + 1;
      acc.all = (acc.all || 0) + 1;
      return acc;
    }, {});

    // Ensure all expected Finance keys exist (so UI shows 0 instead of hiding badges)
    const financeKeys = [
      'all',
      'new',
      'financialApproved',
      'falAccepted',
      'enachCompleted',
      'scrutiny',
      'pod',
      'disbursement',
      'claimFollowUps',
      // legacy keys still used by older code paths
      'query',
      'discharge',
      'dispatch'
    ];
    financeKeys.forEach((k) => {
      if (typeof stageCountsFinance[k] !== 'number') stageCountsFinance[k] = 0;
    });

    // Build Policy stage counts across the same result set
    const stageCountsPolicy = applications.reduce((acc, app) => {
      const stage = deriveStageForPolicy(app);
      acc[stage] = (acc[stage] || 0) + 1;
      acc.all = (acc.all || 0) + 1;
      return acc;
    }, {});

    // Ensure all expected Policy keys exist for consistent badge display
    const policyKeys = ['all', 'new', 'query', 'kyp_challenge', 'kyp_counselling_pending', 'discharge_counselling_pending'];
    policyKeys.forEach((k) => {
      if (typeof stageCountsPolicy[k] !== 'number') stageCountsPolicy[k] = 0;
    });

    // Optional Finance stage filter from UI tabs
    if (filters && typeof filters._financeStage === 'string' && filters._financeStage !== '' && filters._financeStage !== 'all') {
      applications = applications.filter((app) => deriveStageForFinance(app) === filters._financeStage);
    }

    // Optional Policy stage filter from UI tabs
    if (filters && typeof filters._policyStage === 'string' && filters._policyStage !== '' && filters._policyStage !== 'all') {
      applications = applications.filter((app) => deriveStageForPolicy(app) === filters._policyStage);
    }

    // Pagination (support fetch-all mode)
    const total = applications.length;
    let effectivePage = page;
    let effectivePageSize = pageSize;
    let paginatedApplications = applications;
    let totalPages = Math.ceil(total / pageSize);

    if (filters && filters._fetchAll === true) {
      effectivePage = 1;
      effectivePageSize = total;
      totalPages = 1;
    } else {
      const startIndex = (page - 1) * pageSize;
      paginatedApplications = applications.slice(
        startIndex,
        startIndex + pageSize
      );
    }

    return {
      success: true,
      applications: paginatedApplications,
      total,
      page: effectivePage,
      pageSize: effectivePageSize,
      totalPages,
      stageCountsFinance,
      stageCountsPolicy,
    };
  } catch (error) {
    console.error("Error getting admin applications:", error);
    return {
      success: false,
      error: error.message,
      applications: [],
      total: 0,
    };
  }
};


export const getAllApplicationsLead = async (
  filters = {},
  page = 1,
  pageSize = 10,
  userId
) => {
  try {
    let q = collection(db, "patientApplications");

    q = query(q, where("leadGenerator.id", "==", userId));

    // Apply status filter
    if (filters.status && filters.status !== "") {
      q = query(q, where("status", "==", filters.status));
    }

    // Apply priority filter
    if (filters.priority && filters.priority !== "") {
      q = query(q, where("priority", "==", filters.priority));
    }

    // Apply emergency filter
    if (filters.emergency !== "" && filters.emergency !== undefined) {
      const isEmergency = filters.emergency === "true";
      q = query(q, where("emergency", "==", isEmergency));
    }

    // Apply treatment type filter
    if (filters.treatmentType && filters.treatmentType !== "") {
      q = query(q, where("medical.treatmentType", "==", filters.treatmentType));
    }

    // Apply insurance company filter
    if (filters.insuranceCompany && filters.insuranceCompany !== "") {
      q = query(
        q,
        where("policy.insuranceCompany", "==", filters.insuranceCompany)
      );
    }

    // Apply hospital filter
    if (filters.hospitalName && filters.hospitalName !== "") {
      q = query(q, where("hospitalName", "==", filters.hospitalName));
    }

    // Order by priority and submission date (emergency first)
    q = query(q, orderBy("emergency", "desc"), orderBy("submittedAt", "desc"));

    const querySnapshot = await getDocs(q);
    let applications = [];

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      applications.push({
        id: doc.id,
        ...data,
      });
    });

    // Client-side filtering for search term
    if (filters.searchTerm && filters.searchTerm.trim() !== "") {
      const searchTerm = filters.searchTerm.toLowerCase();
      applications = applications.filter(
        (app) =>
          app.applicationId?.toLowerCase().includes(searchTerm) ||
          app.patient?.name?.toLowerCase().includes(searchTerm) ||
          app.medical?.diagnosis?.toLowerCase().includes(searchTerm) ||
          app.hospitalName?.toLowerCase().includes(searchTerm) ||
          app.medical?.doctor?.name?.toLowerCase().includes(searchTerm)
      );
    }

    // Client-side date filtering
    if (filters.dateFrom && filters.dateFrom !== "") {
      const fromDate = new Date(filters.dateFrom);
      applications = applications.filter((app) => {
        const submittedDate = app.submittedAt?.toDate
          ? app.submittedAt.toDate()
          : new Date(app.submittedAt);
        return submittedDate >= fromDate;
      });
    }

    if (filters.dateTo && filters.dateTo !== "") {
      const toDate = new Date(filters.dateTo);
      toDate.setHours(23, 59, 59, 999);
      applications = applications.filter((app) => {
        const submittedDate = app.submittedAt?.toDate
          ? app.submittedAt.toDate()
          : new Date(app.submittedAt);
        return submittedDate <= toDate;
      });
    }

    // Apply amount range filters
    if (filters.minAmount && filters.minAmount !== "") {
      const minAmount = parseFloat(filters.minAmount);
      applications = applications.filter(
        (app) => (app.medical?.estimatedCost || 0) >= minAmount
      );
    }

    if (filters.maxAmount && filters.maxAmount !== "") {
      const maxAmount = parseFloat(filters.maxAmount);
      applications = applications.filter(
        (app) => (app.medical?.estimatedCost || 0) <= maxAmount
      );
    }

    // Pagination
    const total = applications.length;
    const startIndex = (page - 1) * pageSize;
    const paginatedApplications = applications.slice(
      startIndex,
      startIndex + pageSize
    );

    return {
      success: true,
      applications: paginatedApplications,
      total,
      page,
      pageSize,
      totalPages: Math.ceil(total / pageSize),
    };
  } catch (error) {
    console.error("Error getting admin applications:", error);
    return {
      success: false,
      error: error.message,
      applications: [],
      total: 0,
    };
  }
};

// Get applications reviewed by specific doctor
export const getDoctorReviewedApplications = async (
  doctorId,
  filters = {},
  page = 1,
  pageSize = 10
) => {
  try {
    let q = collection(db, "patientApplications");

    // Base filter - only applications reviewed by this doctor
    q = query(
      q,
      where("workflow.medicalVerification.verifiedBy", "==", doctorId)
    );

    // Apply status filter if provided
    if (filters.status && filters.status !== "") {
      q = query(
        q,
        where("workflow.medicalVerification.status", "==", filters.status)
      );
    }

    // Order by review date (newest first)
    q = query(q, orderBy("workflow.medicalVerification.verifiedAt", "desc"));
    
    // OPTIMIZED: Add server-side limit for pagination
    q = query(q, limit(pageSize + 1)); // Fetch one extra to check if there are more

    const querySnapshot = await getDocs(q);
    let applications = [];

    querySnapshot.forEach((doc) => {
      applications.push({
        id: doc.id,
        ...doc.data(),
      });
    });
    
    // Check if there are more pages
    const hasMore = applications.length > pageSize;
    if (hasMore) {
      applications = applications.slice(0, pageSize);
    }

    // Client-side filtering for search term (only on current page)
    if (filters.searchTerm && filters.searchTerm.trim() !== "") {
      const searchTerm = filters.searchTerm.toLowerCase();
      applications = applications.filter(
        (app) =>
          app.applicationId?.toLowerCase().includes(searchTerm) ||
          app.patient?.name?.toLowerCase().includes(searchTerm) ||
          app.medical?.diagnosis?.toLowerCase().includes(searchTerm) ||
          app.hospitalName?.toLowerCase().includes(searchTerm)
      );
    }

    // Date range filtering for review date (only on current page)
    if (filters.dateFrom && filters.dateFrom !== "") {
      const fromDate = new Date(filters.dateFrom);
      applications = applications.filter((app) => {
        const reviewDate =
          app.workflow?.medicalVerification?.verifiedAt?.toDate();
        return reviewDate && reviewDate >= fromDate;
      });
    }

    if (filters.dateTo && filters.dateTo !== "") {
      const toDate = new Date(filters.dateTo);
      toDate.setHours(23, 59, 59, 999);
      applications = applications.filter((app) => {
        const reviewDate =
          app.workflow?.medicalVerification?.verifiedAt?.toDate();
        return reviewDate && reviewDate <= toDate;
      });
    }

    // Server-side pagination - already limited
    const total = applications.length;
    const totalPages = hasMore ? page + 1 : page;

    return {
      success: true,
      applications: applications,
      total: applications.length,
      page,
      pageSize,
      totalPages,
      hasMore,
    };
  } catch (error) {
    console.error("Error getting reviewed applications:", error);
    return {
      success: false,
      error: error.message,
      applications: [],
      total: 0,
    };
  }
};

// Get single application for review
export const getPatientApplication = async (applicationId) => {
  try {
    const q = query(
      collection(db, "patientApplications"),
      where("applicationId", "==", applicationId)
    );
    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      return { success: false, error: "Application not found" };
    }

    const applicationDoc = querySnapshot.docs[0];
    const application = {
      id: applicationDoc.id,
      ...applicationDoc.data(),
    };

    return {
      success: true,
      application,
    };
  } catch (error) {
    console.error("Error getting application:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// Start application review - Begin timer and lock application
export const startApplicationReview = async (applicationId, doctorId) => {
  try {
    // Get application
    const appQuery = query(
      collection(db, "patientApplications"),
      where("applicationId", "==", applicationId)
    );
    const appSnapshot = await getDocs(appQuery);

    if (appSnapshot.empty) {
      return { success: false, error: "Application not found" };
    }

    const appDoc = appSnapshot.docs[0];
    const appData = appDoc.data();

    // Check if already under review by another doctor
    if (
      appData.workflow?.medicalReview?.status === "in_progress" &&
      appData.workflow?.medicalReview?.reviewerId !== doctorId
    ) {
      return {
        success: false,
        error: "Application is already under review by another doctor",
      };
    }

    // Start review
    const reviewStartTime = new Date();
    const appRef = doc(db, "patientApplications", appDoc.id);

    // Initialize review history if it doesn't exist
    const updateData = {
      "workflow.medicalReview.status": "in_progress",
      "workflow.medicalReview.reviewerId": doctorId,
      "workflow.medicalReview.reviewStartTime": reviewStartTime,
      "workflow.medicalReview.lastActivityTime": reviewStartTime,
      updatedAt: new Date(),
    };

    // Initialize review history if not exists
    if (!appData.workflow?.medicalReview?.reviewHistory) {
      updateData["workflow.medicalReview.reviewHistory"] = [];
    }

    await updateDoc(appRef, updateData);

    // Set up auto-timeout (15 minutes)
    setTimeout(async () => {
      try {
        const currentDoc = await getDoc(appRef);
        if (!currentDoc.exists()) return;

        const currentData = currentDoc.data();

        // Check if still in progress and no recent activity
        if (
          currentData.workflow?.medicalReview?.status === "in_progress" &&
          currentData.workflow?.medicalReview?.reviewerId === doctorId
        ) {
          const lastActivity =
            currentData.workflow?.medicalReview?.lastActivityTime?.toDate();
          const now = new Date();
          const timeDiff = now - lastActivity;

          // If more than 15 minutes of inactivity, reset
          if (timeDiff > 15 * 60 * 1000) {
            await updateDoc(appRef, {
              "workflow.medicalReview.status": "pending",
              "workflow.medicalReview.reviewerId": null,
              "workflow.medicalReview.reviewStartTime": null,
              "workflow.medicalReview.lastActivityTime": null,
              status: "medical_review_pending",
              updatedAt: new Date(),
            });
          }
        }
      } catch (error) {
        console.error("Error in auto-timeout:", error);
      }
    }, 15 * 60 * 1000); // 15 minutes

    return {
      success: true,
      message: "Review started successfully",
    };
  } catch (error) {
    console.error("Error starting review:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// Update review activity to prevent timeout
export const updateReviewActivity = async (applicationId, doctorId) => {
  try {
    const appQuery = query(
      collection(db, "patientApplications"),
      where("applicationId", "==", applicationId)
    );
    const appSnapshot = await getDocs(appQuery);

    if (appSnapshot.empty) {
      return { success: false, error: "Application not found" };
    }

    const appRef = doc(db, "patientApplications", appSnapshot.docs[0].id);

    await updateDoc(appRef, {
      "workflow.medicalReview.lastActivityTime": new Date(),
    });

    return { success: true };
  } catch (error) {
    console.error("Error updating review activity:", error);
    return { success: false, error: error.message };
  }
};

// Save internal comments for application - visible to all doctors
export const saveInternalComments = async (applicationId, doctorId, comments, doctorName) => {
  try {
    // Validate input parameters
    console.log('saveInternalComments called with:', { applicationId, doctorId, comments, doctorName });
    
    if (!applicationId || !doctorId || !comments || typeof comments !== 'string') {
      console.error('Invalid parameters:', { applicationId, doctorId, comments: typeof comments, doctorName });
      return { success: false, error: "Invalid parameters provided" };
    }

    const appQuery = query(
      collection(db, "patientApplications"),
      where("applicationId", "==", applicationId)
    );
    const appSnapshot = await getDocs(appQuery);

    if (appSnapshot.empty) {
      return { success: false, error: "Application not found" };
    }

    const appRef = doc(db, "patientApplications", appSnapshot.docs[0].id);
    const currentApp = appSnapshot.docs[0].data();

    // Get existing internal comments or initialize empty array
    const existingComments = currentApp.workflow?.medicalVerification?.internalComments || [];
    console.log('Existing comments:', existingComments);
    
    // Create new comment entry with safe values
    const newComment = {
      id: Date.now().toString(),
      doctorId: doctorId,
      doctorName: doctorName || "Unknown Doctor",
      comments: comments.trim(),
      timestamp: new Date(),
      lastModified: new Date()
    };

    console.log('New comment object:', newComment);

    // Check if doctor already has a comment, update it or add new one
    const existingCommentIndex = existingComments.findIndex(comment => comment.doctorId === doctorId);
    
    let updatedComments;
    if (existingCommentIndex >= 0) {
      // Update existing comment
      updatedComments = [...existingComments];
      updatedComments[existingCommentIndex] = {
        ...updatedComments[existingCommentIndex],
        comments: comments.trim(),
        lastModified: new Date()
      };
      console.log('Updated existing comment at index:', existingCommentIndex);
    } else {
      // Add new comment
      updatedComments = [...existingComments, newComment];
      console.log('Added new comment');
    }

    console.log('Final updated comments array:', updatedComments);

    // Ensure we don't have any undefined values in the update object
    const updateData = {
      "workflow.medicalVerification.internalComments": updatedComments,
      "workflow.medicalVerification.lastInternalCommentUpdate": new Date(),
    };

    console.log('Update data to Firestore:', updateData);

    await updateDoc(appRef, updateData);

    return { 
      success: true, 
      message: "Internal comments saved successfully",
      comments: updatedComments
    };
  } catch (error) {
    console.error("Error saving internal comments:", error);
    return { success: false, error: error.message };
  }
};

// Get internal comments for application
export const getInternalComments = async (applicationId) => {
  try {
    // Validate input
    if (!applicationId) {
      return { success: false, error: "Application ID is required" };
    }

    const appQuery = query(
      collection(db, "patientApplications"),
      where("applicationId", "==", applicationId)
    );
    const appSnapshot = await getDocs(appQuery);

    if (appSnapshot.empty) {
      return { success: false, error: "Application not found" };
    }

    const appData = appSnapshot.docs[0].data();
    const internalComments = appData.workflow?.medicalVerification?.internalComments || [];

    // Sort comments by timestamp (newest first)
    const sortedComments = internalComments.sort((a, b) => {
      const timeA = a.timestamp?.toDate?.() || new Date(a.timestamp);
      const timeB = b.timestamp?.toDate?.() || new Date(b.timestamp);
      return timeB - timeA;
    });

    return { 
      success: true, 
      comments: sortedComments
    };
  } catch (error) {
    console.error("Error getting internal comments:", error);
    return { success: false, error: error.message, comments: [] };
  }
};

// Pause application review - temporarily pause but keep assignment
export const pauseApplicationReview = async (applicationId, doctorId) => {
  try {
    const appQuery = query(
      collection(db, "patientApplications"),
      where("applicationId", "==", applicationId)
    );
    const appSnapshot = await getDocs(appQuery);

    if (appSnapshot.empty) {
      return { success: false, error: "Application not found" };
    }

    const appDoc = appSnapshot.docs[0];
    const appData = appDoc.data();
    const appRef = doc(db, "patientApplications", appDoc.id);

    // Check if this doctor is actually reviewing the application
    if (appData.workflow?.medicalReview?.reviewerId !== doctorId) {
      return {
        success: false,
        error: "You are not currently reviewing this application",
      };
    }

    // Calculate time spent in this session
    const reviewStartTime = appData.workflow?.medicalReview?.reviewStartTime?.toDate();
    const pauseTime = new Date();
    const sessionTimeMinutes = reviewStartTime 
      ? Math.round((pauseTime - reviewStartTime) / (1000 * 60)) 
      : 0;

    // Update to paused state but keep assignment for resumption
    await updateDoc(appRef, {
      "workflow.medicalReview.status": "paused",
      "workflow.medicalReview.pausedAt": pauseTime,
      "workflow.medicalReview.lastSessionTimeMinutes": sessionTimeMinutes,
      "workflow.medicalReview.lastActivityTime": pauseTime,
      updatedAt: new Date(),
    });

    // Set up auto-release timer (15 minutes)
    setTimeout(async () => {
      try {
        const currentDoc = await getDoc(appRef);
        if (!currentDoc.exists()) return;

        const currentData = currentDoc.data();

        // Check if still paused and no recent activity
        if (
          currentData.workflow?.medicalReview?.status === "paused" &&
          currentData.workflow?.medicalReview?.reviewerId === doctorId
        ) {
          const lastActivity = currentData.workflow?.medicalReview?.lastActivityTime?.toDate();
          const now = new Date();
          const timeDiff = now - lastActivity;

          // If more than 15 minutes of inactivity, release the application
          if (timeDiff > 15 * 60 * 1000) {
            // Add paused session to review history
            const pausedSession = {
              doctorId: doctorId,
              startTime: reviewStartTime,
              endTime: pauseTime,
              timeSpentMinutes: sessionTimeMinutes,
              status: "auto_released",
              timestamp: new Date()
            };

            const updateData = {
              "workflow.medicalReview.status": "pending",
              "workflow.medicalReview.reviewerId": null,
              "workflow.medicalReview.reviewStartTime": null,
              "workflow.medicalReview.pausedAt": null,
              "workflow.medicalReview.lastSessionTimeMinutes": null,
              "workflow.medicalReview.lastActivityTime": null,
              status: "medical_review_pending",
              updatedAt: new Date(),
            };

            // Add session to history
            if (!currentData.workflow?.medicalReview?.reviewHistory) {
              updateData["workflow.medicalReview.reviewHistory"] = [pausedSession];
            } else {
              updateData["workflow.medicalReview.reviewHistory"] = [
                ...currentData.workflow.medicalReview.reviewHistory,
                pausedSession
              ];
            }

            await updateDoc(appRef, updateData);
          }
        }
      } catch (error) {
        console.error("Error in auto-release timer:", error);
      }
    }, 15 * 60 * 1000); // 15 minutes

    return {
      success: true,
      message: "Review paused successfully. You have 15 minutes to resume before it's released to other doctors.",
      sessionTimeMinutes: sessionTimeMinutes
    };
  } catch (error) {
    console.error("Error pausing review:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// Resume application review
export const resumeApplicationReview = async (applicationId, doctorId) => {
  try {
    const appQuery = query(
      collection(db, "patientApplications"),
      where("applicationId", "==", applicationId)
    );
    const appSnapshot = await getDocs(appQuery);

    if (appSnapshot.empty) {
      return { success: false, error: "Application not found" };
    }

    const appDoc = appSnapshot.docs[0];
    const appData = appDoc.data();
    const appRef = doc(db, "patientApplications", appDoc.id);

    // Check if this doctor can resume the application
    if (appData.workflow?.medicalReview?.reviewerId !== doctorId) {
      return {
        success: false,
        error: "You cannot resume this review - it may have been released to other doctors",
      };
    }

    // Check if it's in paused state
    if (appData.workflow?.medicalReview?.status !== "paused") {
      return {
        success: false,
        error: "Application is not in paused state",
      };
    }

    // Resume review
    const resumeTime = new Date();

    await updateDoc(appRef, {
      "workflow.medicalReview.status": "in_progress",
      "workflow.medicalReview.reviewStartTime": resumeTime, // Reset start time for new session
      "workflow.medicalReview.lastActivityTime": resumeTime,
      "workflow.medicalReview.pausedAt": null,
      updatedAt: new Date(),
    });

    return {
      success: true,
      message: "Review resumed successfully",
    };
  } catch (error) {
    console.error("Error resuming review:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// Enhanced Generate KYP Letter with professional PDF format using react-pdf
const generateEnhancedKYPPDF = async (application, kypData) => {
  try {
    console.log("Generating comprehensive KYP PDF with react-pdf...");
    console.log("Application data:", application);
    console.log("KYP data:", kypData);
    
    // Generate PDF using react-pdf with React.createElement
    const document = React.createElement(ComprehensiveKYPDocument, { 
      application: application, 
      kypData: kypData 
    });
    
    console.log("Creating PDF blob...");
    const pdfBlob = await pdf(document).toBlob();
    
    console.log("PDF generated successfully, blob size:", pdfBlob.size);
    return pdfBlob;
  } catch (error) {
    console.error("Error generating enhanced KYP PDF with react-pdf:", error);
    console.error("Error details:", error.stack);
    
    // Fallback to a simple text-based solution if react-pdf fails
    console.log("Using fallback content generator...");
    const fallbackContent = generateFallbackKYPContent(application, kypData);
    return new Blob([fallbackContent], { type: "text/plain" });
  }
};

// Fallback content generator
const generateFallbackKYPContent = (application, kypData) => {
  const currentDate = new Date().toLocaleDateString("en-IN", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return `
KNOW YOUR POLICY (KYP) LETTER
Generated on: ${currentDate}

CASE INFORMATION:
Application ID: ${kypData.applicationDetails?.applicationId || 'N/A'}
Patient Name: ${application.patient?.name || 'N/A'}
Hospital: ${kypData.applicationDetails?.hospitalName || 'N/A'}
Diagnosis: ${kypData.applicationDetails?.diagnosis || 'N/A'}

POLICY DETAILS:
Policy Number: ${kypData.applicationDetails?.policyNumber || 'N/A'}
Insurance Company: ${kypData.applicationDetails?.insuranceCompany || 'N/A'}
Sum Insured: ₹${(kypData.applicationDetails?.sumInsured || 0).toLocaleString('en-IN')}

MEDICAL VERIFICATION:
Medical History Verified: ${kypData.medicalHistoryVerified ? 'VERIFIED' : 'PENDING'}
Documents Authentic: ${kypData.documentsAuthentic ? 'VERIFIED' : 'PENDING'}
Treatment Appropriate: ${kypData.treatmentAppropriate ? 'APPROVED' : 'UNDER REVIEW'}

AUTHORIZATION:
Authorized by: Dr. ${kypData.doctorName || 'Medical Review Specialist'}
Registration No: ${kypData.registrationNo || 'MED-001'}
Date: ${currentDate}

This is a digitally generated KYP letter.
For verification, contact the issuing organization.
  `.trim();
};

// Enhanced Generate KYP Letter - Returns data for preview (no PDF generation)
// KYP generation requires NO pending queries from ANY team (global check)
export const generateKYPLetter = async (applicationId, doctorId, kypData) => {
  try {
    console.log("Preparing KYP data for preview...");
    
    // CRITICAL: KYP generation requires NO pending queries from ANY team
    const { checkApplicationDisputeStatus } = await import('./disputeService');
    const globalQueryCheck = await checkApplicationDisputeStatus(applicationId);
    
    if (!globalQueryCheck.success) {
      return { 
        success: false, 
        error: "Error checking query status before KYP generation" 
      };
    }
    
    if (globalQueryCheck.hasActiveDisputes) {
      const teams = [...new Set(globalQueryCheck.activeDisputes.map(d => d.raisedBy?.department || 'Unknown'))];
      return {
        success: false,
        error: `Cannot generate KYP letter. There are ${globalQueryCheck.activeDisputes.length} unresolved ${globalQueryCheck.activeDisputes.length === 1 ? 'query' : 'queries'} from ${teams.join(', ')} team(s). All queries must be resolved before KYP generation.`,
        hasUnresolvedQueries: true,
        unresolvedQueries: globalQueryCheck.activeDisputes,
        queryCount: globalQueryCheck.activeDisputes.length
      };
    }
    
    // Get application data
    const appQuery = query(
      collection(db, "patientApplications"),
      where("applicationId", "==", applicationId)
    );
    const appSnapshot = await getDocs(appQuery);

    if (appSnapshot.empty) {
      return { success: false, error: "Application not found" };
    }

    const application = appSnapshot.docs[0].data();
    
    // Sanitize and enhance data
    const sanitizeValue = (value, defaultValue = '') => {
      if (value === undefined || value === null) {
        return defaultValue;
      }
      return value;
    };

    const sanitizeObject = (obj) => {
      if (obj === null || obj === undefined) {
        return {};
      }
      
      const sanitized = {};
      for (const [key, value] of Object.entries(obj)) {
        if (value === undefined || value === null) {
          sanitized[key] = '';
        } else if (typeof value === 'object' && !Array.isArray(value) && !(value instanceof Date)) {
          sanitized[key] = sanitizeObject(value);
        } else if (Array.isArray(value)) {
          sanitized[key] = value.map(item => 
            typeof item === 'object' ? sanitizeObject(item) : sanitizeValue(item)
          );
        } else {
          sanitized[key] = value;
        }
      }
      return sanitized;
    };

    // Enhanced KYP data with all required fields for preview
    const enhancedKypData = {
      ...sanitizeObject(kypData),
      leadGenerator: application.leadGenerator || kypData.leadGenerator,
      applicationDetails: {
        applicationId: sanitizeValue(applicationId),
        patientName: sanitizeValue(application.patient?.name),
        diagnosis: sanitizeValue(application.medical?.diagnosis),
        hospitalName: sanitizeValue(application.hospitalName),
        insuranceCompany: sanitizeValue(application.policy?.insuranceCompany),
        policyNumber: sanitizeValue(application.policy?.number),
        admissionDate: sanitizeValue(application.medical?.admissionDate),
        dischargeDate: sanitizeValue(application.medical?.dischargeDate, "TBD"),
        treatmentType: sanitizeValue(application.medical?.treatmentType),
        procedureName: sanitizeValue(application.medical?.procedureName, "As per diagnosis"),
        tpaName: sanitizeValue(application.policy?.tpaName, "Inhouse"),
        city: sanitizeValue(application.hospital?.city, "Not specified"),
        relationshipWithPrimary: sanitizeValue(application.patient?.relationshipWithPrimary, "Self"),
        primaryInsuredName: sanitizeValue(application.policy?.primaryInsuredName, application.patient?.name),
        sumInsured: application.policy?.coverageAmount || 0,
        cumulativeBonus: application.policy?.cumulativeBonus || 0,
        topupSI: application.policy?.topupSI || 0,
        effectiveCoverage: (application.policy?.coverageAmount || 0) + 
                          (application.policy?.cumulativeBonus || 0) + 
                          (application.policy?.topupSI || 0),
        balanceSumInsured: application.policy?.balanceSumInsured || application.policy?.coverageAmount || 0,
        intimationId: sanitizeValue(application.intimationId, `CIR/${new Date().getFullYear()}/${Math.random().toString(36).substr(2, 9)}`),
        estimatedCost: application.medical?.estimatedCost || 0,
        policyPeriod: `${application.policy?.startDate || 'N/A'} to ${application.policy?.endDate || 'N/A'}`,
        roomEligibility: kypData.roomEligibility || "Single Standard AC Room",
        roomAmountPerDay: kypData.roomAmountPerDay || 0,
        icuAmountPerDay: kypData.icuAmountPerDay || 0,
      },
      disbursementCalculation: {
        totalEstimatedCost: application.medical?.estimatedCost || 0,
        approvedPercentage: kypData.disbursementPercentage || 0,
        approvedAmount: kypData.approvedDisbursementAmount || 0,
        disbursementNotes: sanitizeValue(kypData.disbursementNotes),
      },
    };

    // Save KYP record for tracking (without file upload)
    const kypRecord = {
      applicationId,
      generatedBy: doctorId,
      generatedAt: new Date(),
      kypData: enhancedKypData,
      disbursementApproval: {
        approvedAmount: enhancedKypData.approvedDisbursementAmount || 0,
        disbursementPercentage: enhancedKypData.disbursementPercentage || 0,
        disbursementNotes: enhancedKypData.disbursementNotes || "",
        estimatedCost: application.medical?.estimatedCost || 0,
      },
      version: 3, // Updated version for preview-first approach
      status: "preview_ready",
      type: "kyp_preview_format",
    };

    await addDoc(collection(db, "kypLetters"), kypRecord);

    // Update application with KYP data
    const appRef = doc(db, "patientApplications", appSnapshot.docs[0].id);
    await updateDoc(appRef, {
      "workflow.medicalVerification.kypGenerated": true,
      "workflow.medicalVerification.kypData": enhancedKypData,
      "workflow.medicalVerification.approvedDisbursementAmount": enhancedKypData.approvedDisbursementAmount || 0,
      "workflow.medicalVerification.disbursementApproved": true,
      "workflow.medicalVerification.kypGeneratedAt": new Date(),
      updatedAt: new Date(),
    });

    // Update bucket filter - KYP generated, waiting for hospital acknowledgement
    await updateRoleBucket(appSnapshot.docs[0].id, 'doctor', 'kyp_approved');

    console.log("KYP data prepared successfully for preview");

    // Return data for preview instead of file URL
    return {
      success: true,
      previewReady: true,
      application: application,
      kypData: enhancedKypData,
      approvedDisbursementAmount: enhancedKypData.approvedDisbursementAmount || 0,
      message: "KYP letter ready for preview"
    };
  } catch (error) {
    console.error("Error preparing KYP letter for preview:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// Enhanced helper function for fallback content
const generateEnhancedKYPContent = (application, kypData) => {
  const currentDate = new Date().toLocaleDateString("en-IN", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return `
KNOW YOUR POLICY (KYP)

Case ID: ${kypData.applicationDetails?.applicationId || ''}
Policy No: ${kypData.applicationDetails?.policyNumber || ''}
TPA Name: ${kypData.applicationDetails?.tpaName || 'Inhouse'}
Hospital Name: ${kypData.applicationDetails?.hospitalName || ''}
Provisional Diagnosis: ${kypData.applicationDetails?.diagnosis || ''}

Provisional Date of Admission: ${kypData.applicationDetails?.admissionDate || ''}

First Inception Date: ${application.policy?.inceptionDate || 'N/A'}
Effective Date: ${application.policy?.effectiveDate || 'N/A'}
Expiry Date: ${application.policy?.expiryDate || 'N/A'}
City: ${kypData.applicationDetails?.city || ''}
Proposed Treatment type: ${kypData.applicationDetails?.treatmentType || ''}
Tentative Date of Discharge: ${kypData.applicationDetails?.dischargeDate || 'TBD'}

Policy Type: ${application.policy?.policyType || 'Retail'}
Insurance Company Name: ${kypData.applicationDetails?.insuranceCompany || ''}
Is the policy Ported?: No
Procedure Name: ${kypData.applicationDetails?.procedureName || ''}

Corporate Name: ${application.policy?.corporateName || 'Retail'}
Intimation ID: ${kypData.applicationDetails?.intimationId || ''}

PRIMARY INSURED NAME: ${kypData.applicationDetails?.primaryInsuredName || ''}
Sum Insured(SI): ₹${(kypData.applicationDetails?.sumInsured || 0).toLocaleString('en-IN')}
Cumulative Bonus: ₹${(kypData.applicationDetails?.cumulativeBonus || 0).toLocaleString('en-IN')}
Topup SI: ₹${(kypData.applicationDetails?.topupSI || 0).toLocaleString('en-IN')}
EFFECTIVE COVERAGE: ₹${(kypData.applicationDetails?.effectiveCoverage || 0).toLocaleString('en-IN')}

INSURED NAME: ${application.patient?.name || ''}
Pre Hospitalisation: N/A
Post Hospitalisation: N/A
Waiting Periods: 
- 30 Days
- Specific: 2 Years  
- PED: 4 Years

RELATIONSHIP WITH PRIMARY BENEFICIARY: ${kypData.applicationDetails?.relationshipWithPrimary || 'Self'}
Eligible Room: ${kypData.roomEligibility || 'Single Standard AC Room'}
ICU/ICCU: As per actual
Ambulance cover: N/A
Ayush Treatment: N/A
Hospital Daily Cash: N/A

INSURED NAME: ${application.patient?.name || ''}
HEALTH CHECK UP: N/A
Co-Pay/deductible: ${kypData.coPay || '10%'}
Sub-Limit: ${kypData.subLimit || 'No update'}
Balance Sum Insured: ₹${(kypData.applicationDetails?.balanceSumInsured || 0).toLocaleString('en-IN')}

Initial Remarks:
KYP authorised basis available information in the documents shared by the hospital. Submit bill, summary and all discharge documents at the time of discharge.

ROOM ELIGIBILITY AS MENTIONED ABOVE. IF THE PATIENT/INSURED OCCUPIES ROOM BEYOND HIS/ENTITLED CATEGORY OR LIMIT, THEN, ALL THE ROOM ASSOCIATED CHARGES WILL BE PROPORTIONATELY RESTRICTED IN ACCORDANCE TO THE ROOM ELIGIBILITY.

DISBURSEMENT APPROVED: ₹${(kypData.approvedDisbursementAmount || 0).toLocaleString('en-IN')} (${kypData.disbursementPercentage || 0}% of estimated cost)

Medical Review Comments: ${kypData.clinicalNotes || 'Standard medical protocols followed.'}

Waiting Periods: ${kypData.waitingPeriod || '30 Days'} general, ${kypData.specificWaiting || '2 Years'} specific diseases, ${kypData.pedWaiting || '4 Years'} PED

This KYP is valid for ${kypData.validityPeriod || '15 days'} from date of issue.

Generated by: Dr. ${kypData.doctorName || 'Medical Review Specialist'}
Registration No: ${kypData.registrationNo || 'MED-001'}
Date: ${currentDate}

---
This is a digitally generated KYP letter by SamHealth Medical Review System.
Generated on: ${currentDate}
Verification Code: KYP-${Date.now().toString().slice(-8)}
---
  `.trim();
};

// Complete medical review
export const completeMedicalReview = async (
  applicationId,
  doctorId,
  reviewData
) => {
  try {
    // If approving the application, check for unresolved queries first
    if (reviewData.status === "approved") {
      const canProceed = await canApplicationProceed(applicationId, 'medical');
      
      if (!canProceed.success) {
        return {
          success: false,
          error: "Error validating application status",
          details: canProceed.error
        };
      }

      if (!canProceed.canProceed) {
        return {
          success: false,
          error: "Cannot approve application - there are unresolved queries that must be addressed first",
          reason: canProceed.reason,
          unresolvedQueries: canProceed.unresolvedQueries,
          queryCount: canProceed.queryCount
        };
      }
    }

    const appQuery = query(
      collection(db, "patientApplications"),
      where("applicationId", "==", applicationId)
    );
    const appSnapshot = await getDocs(appQuery);

    if (appSnapshot.empty) {
      return { success: false, error: "Application not found" };
    }

    const appDoc = appSnapshot.docs[0];
    const appData = appDoc.data();
    const appRef = doc(db, "patientApplications", appDoc.id);

    // Calculate review time
    const reviewStartTime =
      appData.workflow?.medicalReview?.reviewStartTime?.toDate();
    const reviewEndTime = new Date();
    const reviewTimeMinutes = reviewStartTime
      ? Math.round((reviewEndTime - reviewStartTime) / (1000 * 60))
      : 0;

    // Add this completed session to review history
    const reviewSession = {
      doctorId: doctorId,
      startTime: reviewStartTime,
      endTime: reviewEndTime,
      timeSpentMinutes: reviewTimeMinutes,
      status: "completed",
      reviewDecision: reviewData.status,
      timestamp: new Date()
    };

    // Update application with review results
    const updateData = {
      "workflow.medicalVerification.status": reviewData.status, // approved, rejected, pending_info
      "workflow.medicalVerification.verifiedBy": doctorId,
      "workflow.medicalVerification.verifiedAt": new Date(),
      "workflow.medicalVerification.comments": reviewData.comments || "",
      "workflow.medicalVerification.reviewTimeMinutes": reviewTimeMinutes,
      "workflow.medicalReview.status": "completed",
      "workflow.medicalReview.reviewerId": null,
      "workflow.medicalReview.reviewStartTime": null,
      "workflow.medicalReview.lastActivityTime": null,
      updatedAt: new Date(),
    };

    // Add completed review session to history
    if (!appData.workflow?.medicalReview?.reviewHistory) {
      updateData["workflow.medicalReview.reviewHistory"] = [reviewSession];
    } else {
      updateData["workflow.medicalReview.reviewHistory"] = [
        ...appData.workflow.medicalReview.reviewHistory,
        reviewSession
      ];
    }

    // Update main status based on review result
    if (reviewData.status === "approved") {
      updateData.status = "medical_approved";
    } else if (reviewData.status === "rejected") {
      updateData.status = "medical_rejected";
    } else if (reviewData.status === "pending_info") {
      updateData.status = "pending_documents";
    }

    // Add KYP data if provided (with disbursement amount)
    if (reviewData.kypData) {
      updateData["workflow.medicalVerification.kypData"] = reviewData.kypData;
      updateData["workflow.medicalVerification.approvedDisbursementAmount"] =
        reviewData.kypData.approvedDisbursementAmount || 0;
    }

    // Add discharge review data if provided (with uploaded files)
    if (reviewData.dischargeReview) {
      updateData["workflow.medicalVerification.dischargeReview"] =
        reviewData.dischargeReview;
      updateData[
        "workflow.medicalVerification.dischargeReviewCompleted"
      ] = true;
      updateData["workflow.medicalVerification.finalApprovedAmount"] =
        reviewData.dischargeReview.totals?.totalEligible || 0;
    }

    await updateDoc(appRef, updateData);

    // If diagnosis got approved here, email CSSG
    if (updateData.status === 'medical_approved') {
      (async () => {
        try {
          const subject = `Diagnosis Approved: ${applicationId}`;
          const html = `<!DOCTYPE html><html><body style="font-family:Arial,Helvetica,sans-serif;line-height:1.5;color:#0f172a;">
            <h2 style="color:#0f766e;margin:0 0 12px;">Diagnosis Approved</h2>
            <p style="margin:0 0 8px;">Application <strong>${applicationId}</strong> has been <em>medically approved</em>.</p>
            <p style="margin:8px 0 0;font-size:12px;color:#64748b;">This is an automated notification.</p>
          </body></html>`;
          await sendEmail({ to: 'cssg@samhealth.co.in', subject, html });
        } catch (e) {
          console.warn('Non-blocking email failed (completeMedicalReview):', e?.message || e);
        }
      })();
    }

    return {
      success: true,
      message: "Medical review completed successfully",
    };
  } catch (error) {
    console.error("Error completing medical review:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// Create clarification request (Discussion/Chat functionality)
export const createClarificationRequest = async (
  applicationId,
  doctorId,
  questions
) => {
  try {
    const clarificationData = {
      applicationId,
      requestedBy: doctorId,
      requestedAt: new Date(),
      status: "pending", // pending, answered, resolved
      type: "medical_clarification",
      questions: questions.map((q, index) => ({
        id: `q_${Date.now()}_${index}`,
        question: q.question,
        required: q.required || false,
        answerType: q.answerType || "text", // text, file, both
        description: q.description || "",
        answer: null,
        answerFiles: [],
        answeredAt: null,
        answeredBy: null,
      })),
    };

    // Add to clarifications collection
    const clarificationRef = await addDoc(
      collection(db, "clarifications"),
      clarificationData
    );

    // Update application status
    const appQuery = query(
      collection(db, "patientApplications"),
      where("applicationId", "==", applicationId)
    );
    const appSnapshot = await getDocs(appQuery);

    if (!appSnapshot.empty) {
      const appRef = doc(db, "patientApplications", appSnapshot.docs[0].id);
      await updateDoc(appRef, {
        status: "pending_clarification",
        "workflow.medicalVerification.status": "pending_info",
        "workflow.medicalVerification.clarificationRequestId":
          clarificationRef.id,
        updatedAt: new Date(),
      });
    }

    return {
      success: true,
      clarificationId: clarificationRef.id,
      message: "Clarification request sent successfully",
    };
  } catch (error) {
    console.error("Error creating clarification request:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// Get clarification requests for application
export const getClarificationRequests = async (applicationId) => {
  try {
    const q = query(
      collection(db, "clarifications"),
      where("applicationId", "==", applicationId),
      orderBy("requestedAt", "desc")
    );

    const querySnapshot = await getDocs(q);
    const clarifications = [];

    querySnapshot.forEach((doc) => {
      clarifications.push({
        id: doc.id,
        ...doc.data(),
      });
    });

    return {
      success: true,
      clarifications,
    };
  } catch (error) {
    console.error("Error getting clarification requests:", error);
    return {
      success: false,
      error: error.message,
      clarifications: [],
    };
  }
};

// Enhanced Process discharge review with file uploads
export const processDischargeReview = async (
  applicationId,
  doctorId,
  dischargeData
) => {
  try {
    // Validate discharge items
    if (!dischargeData.items || dischargeData.items.length === 0) {
      return { success: false, error: "No discharge items provided" };
    }

    // Calculate totals
    let totalBilled = 0;
    let totalEligible = 0;

    const processedItems = dischargeData.items.map((item) => {
      const billedAmount = parseFloat(item.billedAmount) || 0;
      const eligibleAmount = parseFloat(item.eligibleAmount) || 0;

      if (item.approved) {
        totalBilled += billedAmount;
        totalEligible += eligibleAmount;
      }

      return {
        ...item,
        billedAmount,
        eligibleAmount,
        variance: billedAmount - eligibleAmount,
        variancePercentage:
          billedAmount > 0
            ? (((billedAmount - eligibleAmount) / billedAmount) * 100).toFixed(
                2
              )
            : 0,
      };
    });

    const dischargeReview = {
      items: processedItems,
      totals: {
        totalBilled,
        totalEligible,
        totalVariance: totalBilled - totalEligible,
        eligibilityPercentage:
          totalBilled > 0
            ? ((totalEligible / totalBilled) * 100).toFixed(2)
            : 0,
        finalApprovedAmount: totalEligible,
      },
      doctorComments: dischargeData.comments || "",
      reviewedBy: doctorId,
      reviewedAt: new Date(),
      recommendation: dischargeData.recommendation || "approve", // approve, reject, modify
      modificationReason: dischargeData.modificationReason || "",
      uploadedFiles: dischargeData.uploadedFiles || [], // Include uploaded files
    };

    // Update application with enhanced discharge review
    const appQuery = query(
      collection(db, "patientApplications"),
      where("applicationId", "==", applicationId)
    );
    const appSnapshot = await getDocs(appQuery);

    if (appSnapshot.empty) {
      return { success: false, error: "Application not found" };
    }

    const appRef = doc(db, "patientApplications", appSnapshot.docs[0].id);
    await updateDoc(appRef, {
      "workflow.medicalVerification.dischargeReview": dischargeReview,
      "workflow.medicalVerification.dischargeReviewCompleted": true,
      "workflow.medicalVerification.finalApprovedAmount": totalEligible,
      "workflow.medicalVerification.dischargeFiles":
        dischargeData.uploadedFiles || [],
      updatedAt: new Date(),
    });

    return {
      success: true,
      dischargeReview,
      message: "Discharge review completed successfully",
    };
  } catch (error) {
    console.error("Error processing discharge review:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// Submit for final approval
export const submitForFinalApproval = async (
  applicationId,
  doctorId,
  finalData
) => {
  try {
    const appQuery = query(
      collection(db, "patientApplications"),
      where("applicationId", "==", applicationId)
    );
    const appSnapshot = await getDocs(appQuery);

    if (appSnapshot.empty) {
      return { success: false, error: "Application not found" };
    }

    const appRef = doc(db, "patientApplications", appSnapshot.docs[0].id);

    await updateDoc(appRef, {
      "workflow.medicalVerification.status": "approved",
      "workflow.medicalVerification.finalComments": finalData.comments || "",
      "workflow.medicalVerification.recommendedAmount":
        finalData.recommendedAmount || 0,
      "workflow.medicalVerification.submittedForFinalApproval": true,
      "workflow.medicalVerification.submittedAt": new Date(),
      status: "pending_final_approval",
      updatedAt: new Date(),
    });

    return {
      success: true,
      message: "Application submitted for final approval",
    };
  } catch (error) {
    console.error("Error submitting for final approval:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// Upload document during review
export const uploadReviewDocument = async (
  applicationId,
  file,
  documentType,
  uploadedBy
) => {
  try {
    const fileName = `${documentType}_${Date.now()}_${file.name}`;
    const storageRef = ref(
      storage,
      `review-documents/${applicationId}/${fileName}`
    );

    const snapshot = await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(snapshot.ref);

    const documentData = {
      url: downloadURL,
      fileName: file.name,
      originalName: file.name,
      size: file.size,
      type: documentType,
      uploadedAt: new Date(),
      uploadedBy: uploadedBy,
      description: "", // Will be updated by user
    };

    return {
      success: true,
      document: documentData,
    };
  } catch (error) {
    console.error("Error uploading review document:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// Get discharge summary data
export const getDischargeSummary = async (applicationId) => {
  try {
    const q = query(
      collection(db, "dischargeSummaries"),
      where("applicationId", "==", applicationId)
    );

    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      return {
        success: true,
        dischargeSummary: null,
      };
    }

    const dischargeSummary = querySnapshot.docs[0].data();

    return {
      success: true,
      dischargeSummary: {
        id: querySnapshot.docs[0].id,
        ...dischargeSummary,
      },
    };
  } catch (error) {
    console.error("Error getting discharge summary:", error);
    return {
      success: false,
      error: error.message,
      dischargeSummary: null,
    };
  }
};
// Add discharge items during review
export const addDischargeItem = async (applicationId, doctorId, itemData) => {
  try {
    const dischargeItem = {
      applicationId,
      addedBy: doctorId,
      addedAt: new Date(),
      ...itemData,
      id: Date.now().toString(),
    };

    // Add to discharge items collection
    await addDoc(collection(db, "dischargeItems"), dischargeItem);

    return {
      success: true,
      item: dischargeItem,
      message: "Discharge item added successfully",
    };
  } catch (error) {
    console.error("Error adding discharge item:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// Get discharge items for application
export const getDischargeItems = async (applicationId) => {
  try {
    const q = query(
      collection(db, "dischargeItems"),
      where("applicationId", "==", applicationId),
      orderBy("addedAt", "asc")
    );

    const querySnapshot = await getDocs(q);
    const items = [];

    querySnapshot.forEach((doc) => {
      items.push({
        id: doc.id,
        ...doc.data(),
      });
    });

    return {
      success: true,
      items,
    };
  } catch (error) {
    console.error("Error getting discharge items:", error);
    return {
      success: false,
      error: error.message,
      items: [],
    };
  }
};

// Update discharge item
export const updateDischargeItem = async (itemId, updateData) => {
  try {
    const itemRef = doc(db, "dischargeItems", itemId);
    await updateDoc(itemRef, {
      ...updateData,
      updatedAt: new Date(),
    });

    return {
      success: true,
      message: "Discharge item updated successfully",
    };
  } catch (error) {
    console.error("Error updating discharge item:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// Delete discharge item
export const deleteDischargeItem = async (itemId) => {
  try {
    await deleteDoc(doc(db, "dischargeItems", itemId));

    return {
      success: true,
      message: "Discharge item deleted successfully",
    };
  } catch (error) {
    console.error("Error deleting discharge item:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// Get doctor performance metrics
export const getDoctorPerformanceMetrics = async (
  doctorId,
  dateRange = null
) => {
  try {
    let q = collection(db, "patientApplications");
    q = query(
      q,
      where("workflow.medicalVerification.verifiedBy", "==", doctorId)
    );

    if (dateRange && dateRange.start && dateRange.end) {
      q = query(
        q,
        where(
          "workflow.medicalVerification.verifiedAt",
          ">=",
          Timestamp.fromDate(new Date(dateRange.start))
        ),
        where(
          "workflow.medicalVerification.verifiedAt",
          "<=",
          Timestamp.fromDate(new Date(dateRange.end))
        )
      );
    }

    const querySnapshot = await getDocs(q);

    const metrics = {
      totalReviewed: 0,
      approved: 0,
      rejected: 0,
      pendingInfo: 0,
      averageReviewTime: 0,
      totalReviewTime: 0,
      emergencyReviews: 0,
      complexCases: 0,
      feedbackScore: 0,
      totalAmountProcessed: 0,
      avgDailyReviews: 0,
      approvedForProcessCount: 0,
    };

    let totalReviewTime = 0;
    let totalAmount = 0;
    const reviewDates = new Set();

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      metrics.totalReviewed++;

      const reviewStatus = data.workflow?.medicalVerification?.status;
      switch (reviewStatus) {
        case "approved":
          metrics.approved++;
          break;
        case "rejected":
          metrics.rejected++;
          break;
        case "pending_info":
          metrics.pendingInfo++;
          break;
      }

      if (data.workflow?.medicalVerification?.approvedForProcess) {
        metrics.approvedForProcessCount++;
      }

      if (data.emergency) {
        metrics.emergencyReviews++;
      }

      if (
        data.priority === "urgent" ||
        data.medical?.treatmentType === "surgical"
      ) {
        metrics.complexCases++;
      }

      const reviewTime = data.workflow?.medicalVerification?.reviewTimeMinutes;
      if (reviewTime) {
        totalReviewTime += reviewTime;
      }

      const amount =
        data.workflow?.medicalVerification?.finalApprovedAmount ||
        data.medical?.estimatedCost ||
        0;
      totalAmount += amount;

      // Track unique review dates
      const reviewDate =
        data.workflow?.medicalVerification?.verifiedAt?.toDate();
      if (reviewDate) {
        reviewDates.add(reviewDate.toDateString());
      }
    });

    metrics.averageReviewTime =
      metrics.totalReviewed > 0
        ? Math.round(totalReviewTime / metrics.totalReviewed)
        : 0;
    metrics.totalReviewTime = totalReviewTime;
    metrics.totalAmountProcessed = totalAmount;

    // Calculate approval rate as feedback score
    metrics.feedbackScore =
      metrics.totalReviewed > 0
        ? Math.round((metrics.approved / metrics.totalReviewed) * 100)
        : 0;

    // Calculate average daily reviews
    metrics.avgDailyReviews =
      reviewDates.size > 0
        ? Math.round(metrics.totalReviewed / reviewDates.size)
        : 0;

    return {
      success: true,
      metrics,
    };
  } catch (error) {
    console.error("Error getting doctor performance metrics:", error);
    return {
      success: false,
      error: error.message,
      metrics: null,
    };
  }
};

// Real-time listener for application updates during review
export const subscribeToApplicationUpdates = (applicationId, callback) => {
  const q = query(
    collection(db, "patientApplications"),
    where("applicationId", "==", applicationId)
  );

  return onSnapshot(q, (snapshot) => {
    if (!snapshot.empty) {
      const application = {
        id: snapshot.docs[0].id,
        ...snapshot.docs[0].data(),
      };
      callback(application);
    }
  });
};

// Get discussion/chat messages for clarification
export const getClarificationMessages = async (clarificationId) => {
  try {
    const q = query(
      collection(db, "clarificationMessages"),
      where("clarificationId", "==", clarificationId),
      orderBy("createdAt", "asc")
    );

    const querySnapshot = await getDocs(q);
    const messages = [];

    querySnapshot.forEach((doc) => {
      messages.push({
        id: doc.id,
        ...doc.data(),
      });
    });

    return {
      success: true,
      messages,
    };
  } catch (error) {
    console.error("Error getting clarification messages:", error);
    return {
      success: false,
      error: error.message,
      messages: [],
    };
  }
};

// Send message in clarification discussion
export const sendClarificationMessage = async (
  clarificationId,
  senderId,
  messageData
) => {
  try {
    const message = {
      clarificationId,
      senderId,
      senderRole: messageData.senderRole || "doctor",
      content: messageData.content,
      messageType: messageData.messageType || "text", // text, file, form_response
      attachments: messageData.attachments || [],
      createdAt: new Date(),
      readBy: [senderId],
    };

    // Add message to collection
    const messageRef = await addDoc(
      collection(db, "clarificationMessages"),
      message
    );

    // Update clarification last activity
    const clarificationRef = doc(db, "clarifications", clarificationId);
    await updateDoc(clarificationRef, {
      lastMessageAt: new Date(),
      lastMessageBy: senderId,
    });

    return {
      success: true,
      messageId: messageRef.id,
      message: "Message sent successfully",
    };
  } catch (error) {
    console.error("Error sending clarification message:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// Answer clarification question
export const answerClarificationQuestion = async (
  clarificationId,
  questionId,
  answerData,
  answeredBy
) => {
  try {
    const clarificationRef = doc(db, "clarifications", clarificationId);
    const clarificationDoc = await getDoc(clarificationRef);

    if (!clarificationDoc.exists()) {
      return { success: false, error: "Clarification not found" };
    }

    const clarificationData = clarificationDoc.data();
    const updatedQuestions = clarificationData.questions.map((q) => {
      if (q.id === questionId) {
        return {
          ...q,
          answer: answerData.answer,
          answerFiles: answerData.files || [],
          answeredAt: new Date(),
          answeredBy: answeredBy,
        };
      }
      return q;
    });

    // Check if all required questions are answered
    const allRequiredAnswered = updatedQuestions
      .filter((q) => q.required)
      .every((q) => q.answer || q.answerFiles?.length > 0);

    const updateData = {
      questions: updatedQuestions,
      updatedAt: new Date(),
    };

    if (allRequiredAnswered) {
      updateData.status = "answered";
      updateData.answeredAt = new Date();
    }

    await updateDoc(clarificationRef, updateData);

    return {
      success: true,
      message: "Question answered successfully",
    };
  } catch (error) {
    console.error("Error answering clarification question:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// Enhanced Get application discussions for unified chat interface with QnA support
export const getApplicationDiscussions = async (applicationId) => {
  try {
    // Get discussions
    const discussionsQuery = query(
      collection(db, "discussions"),
      where("applicationId", "==", applicationId),
      orderBy("createdAt", "desc")
    );

    const discussionsSnapshot = await getDocs(discussionsQuery);
    const discussions = [];

    // For each discussion, get its messages
    for (const discussionDoc of discussionsSnapshot.docs) {
      const discussionData = discussionDoc.data();

      // Get messages for this discussion
      const messagesQuery = query(
        collection(db, "discussionMessages"),
        where("discussionId", "==", discussionDoc.id),
        orderBy("createdAt", "asc")
      );

      const messagesSnapshot = await getDocs(messagesQuery);
      const messages = [];

      messagesSnapshot.forEach((messageDoc) => {
        messages.push({
          id: messageDoc.id,
          ...messageDoc.data(),
        });
      });

      discussions.push({
        id: discussionDoc.id,
        ...discussionData,
        messages: messages,
      });
    }

    return {
      success: true,
      discussions,
    };
  } catch (error) {
    console.error("Error getting application discussions:", error);
    return {
      success: false,
      error: error.message,
      discussions: [],
    };
  }
};

// Enhanced Send discussion message with QnA support
export const sendDiscussionMessage = async (applicationId, messageData) => {
  try {
    // Create discussion if this is a new conversation
    let discussionId = messageData.discussionId;

    if (!discussionId) {
      // Create new discussion
      const discussionData = {
        applicationId,
        subject:
          messageData.subject ||
          getSubjectForMessageType(messageData.messageType),
        description:
          messageData.description ||
          getDescriptionForMessageType(messageData.messageType),
        createdBy: messageData.sender,
        createdAt: new Date(),
        participantRoles: ["Doctor", "Hospital"],
        status: "active",
        messageCount: 0,
        messageType: messageData.messageType || "text",
      };

      const discussionRef = await addDoc(
        collection(db, "discussions"),
        discussionData
      );
      discussionId = discussionRef.id;
    }

    // Add message to discussion
    const message = {
      discussionId,
      applicationId,
      message: messageData.message,
      sender: messageData.sender,
      senderName: messageData.senderName,
      senderRole: messageData.senderRole,
      messageType: messageData.messageType || "text",
      qnaQuestions: messageData.qnaQuestions || null, // Support for Q&A questions
      attachments: messageData.attachments || [],
      replyTo: messageData.replyTo || null,
      readBy: messageData.readBy || [messageData.sender],
      createdAt: new Date(),
    };

    const messageRef = await addDoc(
      collection(db, "discussionMessages"),
      message
    );

    // Update discussion with latest message info
    const discussionRef = doc(db, "discussions", discussionId);
    const currentDiscussion = await getDoc(discussionRef);
    const currentMessageCount = currentDiscussion.exists()
      ? currentDiscussion.data().messageCount || 0
      : 0;

    await updateDoc(discussionRef, {
      lastMessage: messageData.message,
      lastMessageAt: new Date(),
      lastMessageBy: messageData.sender,
      messageCount: currentMessageCount + 1,
    });

    // If this is a clarification request or QnA, update application status
    if (
      messageData.messageType === "clarification_request" ||
      messageData.messageType === "qna"
    ) {
      const appQuery = query(
        collection(db, "patientApplications"),
        where("applicationId", "==", applicationId)
      );
      const appSnapshot = await getDocs(appQuery);

      if (!appSnapshot.empty) {
        const appRef = doc(db, "patientApplications", appSnapshot.docs[0].id);
        await updateDoc(appRef, {
          status: "pending_clarification",
          "workflow.medicalVerification.status": "pending_info",
          "workflow.medicalVerification.clarificationRequestId": messageRef.id,
          updatedAt: new Date(),
        });
      }
    }

    return {
      success: true,
      messageId: messageRef.id,
      discussionId: discussionId,
    };
  } catch (error) {
    console.error("Error sending discussion message:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// Enhanced Mark messages as read
export const markMessagesAsRead = async (applicationId, userId) => {
  try {
    // Get all discussions for this application
    const discussionsQuery = query(
      collection(db, "discussions"),
      where("applicationId", "==", applicationId)
    );
    const discussionsSnapshot = await getDocs(discussionsQuery);

    // For each discussion, get messages and mark as read
    const updatePromises = [];

    for (const discussionDoc of discussionsSnapshot.docs) {
      const messagesQuery = query(
        collection(db, "discussionMessages"),
        where("discussionId", "==", discussionDoc.id),
        where("sender", "!=", userId) // Only mark messages not sent by current user
      );

      const messagesSnapshot = await getDocs(messagesQuery);

      messagesSnapshot.forEach((messageDoc) => {
        const messageData = messageDoc.data();
        if (!messageData.readBy?.includes(userId)) {
          const updatedReadBy = [...(messageData.readBy || []), userId];
          updatePromises.push(
            updateDoc(doc(db, "discussionMessages", messageDoc.id), {
              readBy: updatedReadBy,
            })
          );
        }
      });
    }

    await Promise.all(updatePromises);

    return {
      success: true,
      message: "Messages marked as read",
    };
  } catch (error) {
    console.error("Error marking messages as read:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// Enhanced Upload document for discussion
export const uploadDiscussionDocument = async (
  applicationId,
  file,
  metadata
) => {
  try {
    const fileName = `discussion_${Date.now()}_${file.name}`;
    const storageRef = ref(
      storage,
      `discussion-documents/${applicationId}/${fileName}`
    );

    const snapshot = await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(snapshot.ref);

    const documentData = {
      url: downloadURL,
      fileName: file.name,
      originalName: file.name,
      size: file.size,
      type: file.type,
      applicationId: applicationId,
      discussionId: metadata.discussionId,
      messageId: metadata.messageId,
      uploadedAt: new Date(),
      uploadedBy: metadata.uploadedBy,
      uploaderName: metadata.uploaderName,
      description: metadata.description || "",
    };

    // Save document record
    const docRef = await addDoc(
      collection(db, "discussionDocuments"),
      documentData
    );

    return {
      success: true,
      document: { ...documentData, id: docRef.id },
    };
  } catch (error) {
    console.error("Error uploading discussion document:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// Submit question answer for QnA
export const submitQuestionAnswer = async (applicationId, answerData) => {
  try {
    const { 
      questionId, 
      messageId, 
      answerText, 
      attachments, 
      respondentId, 
      respondentName, 
      respondentRole, 
      timestamp 
    } = answerData;

    // Get all discussions for this application
    const discussionsResult = await getApplicationDiscussions(applicationId);
    if (!discussionsResult.success) {
      throw new Error('Failed to load discussions');
    }

    // Find the message with the question
    let targetDiscussion = null;
    let targetMessage = null;

    for (const discussion of discussionsResult.discussions) {
      const message = discussion.messages?.find(msg => msg.id === messageId);
      if (message) {
        targetDiscussion = discussion;
        targetMessage = message;
        break;
      }
    }

    if (!targetMessage || !targetDiscussion) {
      throw new Error('Message not found');
    }

    // Update the specific question with the new answer
    const updatedQuestions = targetMessage.qnaQuestions.map(question => {
      if (question.id === questionId) {
        const newAnswer = {
          answerText,
          attachments: attachments || [],
          respondentId,
          respondentName,
          respondentRole,
          timestamp
        };
        
        // Add to existing answers or create new answers array
        const existingAnswers = question.answers || [];
        
        // Check if user already answered and update, or add new answer
        const existingAnswerIndex = existingAnswers.findIndex(
          answer => answer.respondentId === respondentId
        );
        
        if (existingAnswerIndex >= 0) {
          existingAnswers[existingAnswerIndex] = newAnswer;
        } else {
          existingAnswers.push(newAnswer);
        }
        
        return {
          ...question,
          answers: existingAnswers
        };
      }
      return question;
    });

    // Update the message with new questions
    const updatedMessages = targetDiscussion.messages.map(message => {
      if (message.id === messageId) {
        return {
          ...message,
          qnaQuestions: updatedQuestions
        };
      }
      return message;
    });

    // Update the discussion in Firestore
    const discussionRef = doc(db, 'discussions', targetDiscussion.id);
    await updateDoc(discussionRef, {
      messages: updatedMessages,
      lastUpdated: timestamp
    });

    // Also update the main application document to trigger real-time updates
    const appQuery = query(
      collection(db, "patientApplications"),
      where("applicationId", "==", applicationId)
    );
    const appSnapshot = await getDocs(appQuery);

    if (!appSnapshot.empty) {
      const appRef = doc(db, "patientApplications", appSnapshot.docs[0].id);
      await updateDoc(appRef, {
        lastActivity: timestamp,
        'workflow.lastUpdate': timestamp
      });
    }

    return { success: true };
  } catch (error) {
    console.error('Error submitting question answer:', error);
    return { success: false, error: error.message };
  }
};

// Get list of hospitals for filter
export const getHospitalsForFilter = async () => {
  try {
    const q = query(
      collection(db, "hospitals"),
      where("status", "==", "approved")
    );

    const querySnapshot = await getDocs(q);
    const hospitals = [];

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      hospitals.push({
        id: doc.id,
        name: data.hospitalName || data.name,
        city: data.address?.city || "",
      });
    });

    return {
      success: true,
      hospitals,
    };
  } catch (error) {
    console.error("Error getting hospitals:", error);
    return {
      success: false,
      error: error.message,
      hospitals: [],
    };
  }
};

// Get insurance companies for filter
export const getInsuranceCompaniesForFilter = async () => {
  try {
    // Get unique insurance companies from applications
    const q = query(collection(db, "patientApplications"));
    const querySnapshot = await getDocs(q);
    const companies = new Set();

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      if (data.policy?.insuranceCompany) {
        companies.add(data.policy.insuranceCompany);
      }
    });

    return {
      success: true,
      companies: Array.from(companies).sort(),
    };
  } catch (error) {
    console.error("Error getting insurance companies:", error);
    return {
      success: false,
      error: error.message,
      companies: [
        "HDFC ERGO",
        "ICICI Lombard",
        "Bajaj Allianz",
        "Star Health",
        "Care Health",
        "Niva Bupa",
        "Aditya Birla",
        "Future Generali",
        "Cholamandalam",
        "Oriental Insurance",
      ],
    };
  }
};

// Helper functions for message types
const getSubjectForMessageType = (messageType) => {
  switch (messageType) {
    case "qna":
      return "Q&A Form - Medical Clarification";
    case "clarification_request":
      return "Medical Clarification Request";
    case "file":
      return "Document Submission";
    default:
      return "Medical Discussion";
  }
};

const getDescriptionForMessageType = (messageType) => {
  switch (messageType) {
    case "qna":
      return "Doctor has sent a Q&A form requiring responses";
    case "clarification_request":
      return "Doctor has requested clarification on medical documents";
    case "file":
      return "Document has been shared for review";
    default:
      return "Discussion regarding medical review";
  }
};

// Quit/Abandon review - Release application for other doctors to pick up
export const quitApplicationReview = async (applicationId, doctorId) => {
  try {
    // Get application
    const appQuery = query(
      collection(db, "patientApplications"),
      where("applicationId", "==", applicationId)
    );
    const appSnapshot = await getDocs(appQuery);

    if (appSnapshot.empty) {
      return { success: false, error: "Application not found" };
    }

    const appDoc = appSnapshot.docs[0];
    const appData = appDoc.data();

    // Check if this doctor is actually reviewing the application
    if (appData.workflow?.medicalReview?.reviewerId !== doctorId) {
      return {
        success: false,
        error: "You are not currently reviewing this application",
      };
    }

    // Calculate total review time spent
    const reviewStartTime = appData.workflow?.medicalReview?.reviewStartTime?.toDate();
    const reviewEndTime = new Date();
    const reviewTimeSpent = reviewStartTime 
      ? Math.round((reviewEndTime - reviewStartTime) / (1000 * 60)) // in minutes
      : 0;

    // Add this session to review history
    const reviewSession = {
      doctorId: doctorId,
      startTime: reviewStartTime,
      endTime: reviewEndTime,
      timeSpentMinutes: reviewTimeSpent,
      status: "abandoned",
      timestamp: new Date()
    };

    const appRef = doc(db, "patientApplications", appDoc.id);

    // Update the application to release it
    const updateData = {
      "workflow.medicalReview.status": "pending",
      "workflow.medicalReview.reviewerId": null,
      "workflow.medicalReview.reviewStartTime": null,
      "workflow.medicalReview.lastActivityTime": null,
      status: "medical_review_pending",
      updatedAt: new Date(),
    };

    // Add review session to history
    if (!appData.workflow.medicalReview.reviewHistory) {
      updateData["workflow.medicalReview.reviewHistory"] = [reviewSession];
    } else {
      updateData["workflow.medicalReview.reviewHistory"] = [
        ...appData.workflow.medicalReview.reviewHistory,
        reviewSession
      ];
    }

    await updateDoc(appRef, updateData);

    return {
      success: true,
      message: "Review abandoned successfully. Application is now available for other doctors.",
      timeSpent: reviewTimeSpent
    };
  } catch (error) {
    console.error("Error quitting review:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// Check if application has unresolved queries that would put it on hold
// options.department: filter queries by department (e.g., 'medical', 'policy', 'financial')
export const checkApplicationQueryStatus = async (applicationId, options = {}) => {
  try {
    // Import checkApplicationDisputeStatus from disputeService
    const { checkApplicationDisputeStatus } = await import('./disputeService');
    
    const result = await checkApplicationDisputeStatus(applicationId, options);
    
    if (!result.success) {
      return {
        success: false,
        error: result.error,
        hasUnresolvedQueries: false,
        canProceed: false
      };
    }
    
    return {
      success: true,
      hasUnresolvedQueries: result.hasActiveDisputes,
      unresolvedQueries: result.activeDisputes,
      canProceed: result.canProceed,
      queryCount: result.activeDisputes?.length || 0
    };
  } catch (error) {
    console.error("Error checking application query status:", error);
    return {
      success: false,
      error: error.message,
      hasUnresolvedQueries: false,
      canProceed: false
    };
  }
};

// Get applications that are on hold due to unresolved queries
export const getApplicationsOnHold = async (
  filters = {},
  page = 1,
  pageSize = 10
) => {
  try {
    // OPTIMIZED: Get applications with server-side limit
    let q = query(
      collection(db, "patientApplications"),
      where("status", "==", "dispute_pending"),
      orderBy("updatedAt", "desc"),
      limit(pageSize + 1) // Fetch one extra to check for more pages
    );

    const querySnapshot = await getDocs(q);
    let applications = [];

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      applications.push({
        id: doc.id,
        ...data,
      });
    });
    
    // Check if there are more pages
    const hasMore = applications.length > pageSize;
    if (hasMore) {
      applications = applications.slice(0, pageSize);
    }

    // OPTIMIZED: Only enrich applications that will be displayed (current page)
    for (let app of applications) {
      try {
        const queryStatus = await checkApplicationQueryStatus(app.applicationId);
        app.queryStatus = queryStatus;
      } catch (error) {
        console.error(`Error getting query status for ${app.applicationId}:`, error);
        app.queryStatus = {
          hasUnresolvedQueries: false,
          unresolvedQueries: [],
          canProceed: false,
          queryCount: 0
        };
      }
    }

    // Client-side filtering for search term (only on current page)
    if (filters.searchTerm && filters.searchTerm.trim() !== "") {
      const searchTerm = filters.searchTerm.toLowerCase();
      applications = applications.filter(
        (app) =>
          app.applicationId?.toLowerCase().includes(searchTerm) ||
          app.patient?.name?.toLowerCase().includes(searchTerm) ||
          app.medical?.diagnosis?.toLowerCase().includes(searchTerm) ||
          app.hospitalName?.toLowerCase().includes(searchTerm)
      );
    }

    // Apply filters similar to other application getters
    if (filters.priority && filters.priority !== "") {
      applications = applications.filter(app => app.priority === filters.priority);
    }

    if (filters.emergency !== "" && filters.emergency !== undefined) {
      const isEmergency = filters.emergency === "true";
      applications = applications.filter(app => app.emergency === isEmergency);
    }

    if (filters.hospitalName && filters.hospitalName !== "") {
      applications = applications.filter(app => app.hospitalName === filters.hospitalName);
    }

    if (filters.insuranceCompany && filters.insuranceCompany !== "") {
      applications = applications.filter(app => app.policy?.insuranceCompany === filters.insuranceCompany);
    }

    // Date filtering
    if (filters.dateFrom && filters.dateFrom !== "") {
      const fromDate = new Date(filters.dateFrom);
      applications = applications.filter((app) => {
        const submittedDate = app.submittedAt?.toDate
          ? app.submittedAt.toDate()
          : new Date(app.submittedAt);
        return submittedDate >= fromDate;
      });
    }

    if (filters.dateTo && filters.dateTo !== "") {
      const toDate = new Date(filters.dateTo);
      toDate.setHours(23, 59, 59, 999);
      applications = applications.filter((app) => {
        const submittedDate = app.submittedAt?.toDate
          ? app.submittedAt.toDate()
          : new Date(app.submittedAt);
        return submittedDate <= toDate;
      });
    }

    // Server-side pagination - already limited
    const total = applications.length;
    const totalPages = hasMore ? page + 1 : page;

    return {
      success: true,
      applications: applications,
      total: applications.length,
      page,
      pageSize,
      totalPages,
      hasMore,
    };
  } catch (error) {
    console.error("Error getting applications on hold:", error);
    return {
      success: false,
      error: error.message,
      applications: [],
      total: 0,
    };
  }
};

// Enhanced function to check if application can proceed to next phase
// For medical team: only check queries raised BY medical team (department: 'medical' or 'doctor')
export const canApplicationProceed = async (applicationId, currentPhase = 'medical') => {
  try {
    // Check for unresolved queries raised by medical team only
    const queryStatus = await checkApplicationQueryStatus(applicationId, { department: 'medical' });
    
    if (!queryStatus.success) {
      return {
        success: false,
        canProceed: false,
        reason: "Error checking query status",
        error: queryStatus.error
      };
    }

    if (queryStatus.hasUnresolvedQueries) {
      return {
        success: true,
        canProceed: false,
        reason: "Application is on hold due to unresolved queries raised by medical team",
        unresolvedQueries: queryStatus.unresolvedQueries,
        queryCount: queryStatus.queryCount,
        phase: currentPhase
      };
    }

    return {
      success: true,
      canProceed: true,
      reason: "No blocking queries found from medical team",
      phase: currentPhase
    };
  } catch (error) {
    console.error("Error checking if application can proceed:", error);
    return {
      success: false,
      canProceed: false,
      reason: "Error during validation",
      error: error.message
    };
  }
};

// Function to restore applications that might be stuck after dispute resolution
export const restoreApplicationAfterDisputeResolution = async (applicationId) => {
  try {
    const appQuery = query(
      collection(db, "patientApplications"),
      where("applicationId", "==", applicationId)
    );
    const appSnapshot = await getDocs(appQuery);

    if (appSnapshot.empty) {
      return { success: false, error: "Application not found" };
    }

    const appDoc = appSnapshot.docs[0];
    const appData = appDoc.data();
    
    // Check if this application has resolved disputes but incorrect status
    if (appData.disputeStatus === 'resolved' && appData.status === 'dispute_pending') {
      const appRef = doc(db, "patientApplications", appDoc.id);
      
      // Determine correct status based on workflow state, preserving approvals
      let correctStatus = appData.status || 'submitted';
      const finApproved = (appData.workflow?.financialVerification?.status === 'approved')
        || appData.status === 'financial_approved'
        || appData.status === 'approved';

      if (finApproved) {
        correctStatus = appData.status === 'approved' ? 'approved' : 'financial_approved';
      } else if (appData.workflow?.medicalVerification?.status === 'approved') {
        correctStatus = 'medical_approved';
      } else if (appData.workflow?.policyVerification?.status === 'pending') {
        correctStatus = 'policy_review_pending';
      } else if (appData.workflow?.financialVerification?.status === 'pending') {
        correctStatus = 'financial_review_pending';
      } else if (appData.workflow?.medicalVerification?.status === 'pending') {
        correctStatus = 'submitted';
      }
      
      await updateDoc(appRef, {
        status: correctStatus,
        updatedAt: new Date(),
        restoredFromDispute: true,
        restoredAt: new Date()
      });
      
      return {
        success: true,
        message: `Application status restored from ${appData.status} to ${correctStatus}`,
        previousStatus: appData.status,
        newStatus: correctStatus
      };
    }
    
    return {
      success: true,
      message: "Application status is already correct",
      status: appData.status
    };
  } catch (error) {
    console.error("Error restoring application after dispute resolution:", error);
    return {
      success: false,
      error: error.message
    };
  }
};

// Function to find and fix applications stuck in dispute_pending with resolved disputes
export const findAndFixStuckApplications = async () => {
  try {
    // Find applications that are stuck in dispute_pending status
    const stuckQuery = query(
      collection(db, "patientApplications"),
      where("status", "==", "dispute_pending")
    );
    
    const stuckSnapshot = await getDocs(stuckQuery);
    const fixedApplications = [];
    const stillOnHold = [];
    
    for (const appDoc of stuckSnapshot.docs) {
      const appData = appDoc.data();
      
      // Check if this application actually has unresolved disputes
      const queryStatus = await checkApplicationQueryStatus(appData.applicationId);
      
      if (queryStatus.success && !queryStatus.hasUnresolvedQueries) {
        // This application should not be on hold anymore, fix it
        const fixResult = await restoreApplicationAfterDisputeResolution(appData.applicationId);
        if (fixResult.success) {
          fixedApplications.push({
            applicationId: appData.applicationId,
            previousStatus: fixResult.previousStatus,
            newStatus: fixResult.newStatus
          });
        }
      } else if (queryStatus.hasUnresolvedQueries) {
        stillOnHold.push({
          applicationId: appData.applicationId,
          queryCount: queryStatus.queryCount,
          queries: queryStatus.unresolvedQueries
        });
      }
    }
    
    return {
      success: true,
      summary: {
        totalStuck: stuckSnapshot.size,
        fixed: fixedApplications.length,
        stillOnHold: stillOnHold.length
      },
      fixedApplications,
      stillOnHold
    };
  } catch (error) {
    console.error("Error finding and fixing stuck applications:", error);
    return {
      success: false,
      error: error.message,
      summary: { totalStuck: 0, fixed: 0, stillOnHold: 0 }
    };
  }
};

// Update medical data (diagnosis, ICD codes, treatments) for an application
export const updateMedicalData = async (applicationId, medicalData, doctorId) => {
  try {
    const appQuery = query(
      collection(db, "patientApplications"),
      where("applicationId", "==", applicationId)
    );
    const appSnapshot = await getDocs(appQuery);

    if (appSnapshot.empty) {
      return { success: false, error: "Application not found" };
    }

    const appRef = doc(db, "patientApplications", appSnapshot.docs[0].id);

    await updateDoc(appRef, {
      medical: medicalData,
      "workflow.medicalReview.lastActivityTime": new Date(),
      lastModified: new Date(),
      lastModifiedBy: doctorId
    });

    return { success: true };
  } catch (error) {
    console.error("Error updating medical data:", error);
    return { success: false, error: error.message };
  }
};

// Approve or reject a single dispatch document for dispatch
export const setDispatchApprovalForDocument = async (applicationId, documentId, {
  approved,
  remarks = '',
  doctorId,
  doctorName = ''
}) => {
  try {
    const appRes = await getApplication(applicationId);
    if (!appRes.success) return appRes;
    const app = appRes.application;
    const appRef = doc(db, 'patientApplications', app.id);

    // Update in dispatchDocuments if present
    let targetFound = false;
    const updatedDispatchDocs = Array.isArray(app.dispatchDocuments)
      ? app.dispatchDocuments.map((d) => {
          if (d.id === documentId) {
            targetFound = true;
            return {
              ...d,
              dispatchStatus: approved ? 'approved' : 'rejected',
              dispatchReviewedBy: doctorId,
              dispatchReviewerName: doctorName,
              dispatchReviewedAt: new Date(),
              dispatchRemarks: remarks || ''
            };
          }
          return d;
        })
      : [];

    // Also support approvals on dischargeDocuments (scrutiny uploads) by id
    const updatedDischargeDocs = Array.isArray(app.dischargeDocuments)
      ? app.dischargeDocuments.map((d) => {
          if (d.id === documentId) {
            targetFound = true;
            return {
              ...d,
              dispatchStatus: approved ? 'approved' : 'rejected',
              dispatchReviewedBy: doctorId,
              dispatchReviewerName: doctorName,
              dispatchReviewedAt: new Date(),
              dispatchRemarks: remarks || ''
            };
          }
          return d;
        })
      : [];

    if (!targetFound) {
      return { success: false, error: 'Document not found in dispatch or discharge documents' };
    }

    const updatePayload = { updatedAt: new Date() };
    if (Array.isArray(app.dispatchDocuments)) updatePayload.dispatchDocuments = updatedDispatchDocs;
    if (Array.isArray(app.dischargeDocuments)) updatePayload.dischargeDocuments = updatedDischargeDocs;
    await updateDoc(appRef, updatePayload);
    return { success: true };
  } catch (error) {
    console.error('Error updating dispatch approval:', error);
    return { success: false, error: error.message };
  }
};

// Get approved dispatch documents for merge/download
export const getApprovedDispatchDocuments = async (applicationId) => {
  try {
    const res = await getApplication(applicationId);
    if (!res.success) return res;
    const dispatchApproved = (res.application.dispatchDocuments || []).filter((d) => d.dispatchStatus === 'approved');
    const dischargeApproved = (res.application.dischargeDocuments || []).filter((d) => d.dispatchStatus === 'approved');
    const docs = [...dischargeApproved, ...dispatchApproved];
    return { success: true, documents: docs };
  } catch (e) {
    console.error('Error fetching approved dispatch documents:', e);
    return { success: false, error: e.message, documents: [] };
  }
};

// Set overall approval to start dispatch after doctor scrutinizes documents
export const setDispatchStartApproval = async (
  applicationId,
  { approved, remarks = '', doctorId, doctorName = '' }
) => {
  try {
    const appRes = await getApplication(applicationId);
    if (!appRes.success) return appRes;
    const appRef = doc(db, 'patientApplications', appRes.application.id);

    const payload = {
      status: approved ? 'approved' : 'rejected',
      remarks: remarks || '',
      by: doctorId || null,
      byName: doctorName || null,
      at: new Date(),
    };

    await updateDoc(appRef, {
      'workflow.dischargeSettlement.dispatchClearance': payload,
      updatedAt: new Date(),
    });

    return { success: true };
  } catch (error) {
    console.error('Error setting dispatch start approval:', error);
    return { success: false, error: error.message };
  }
};

// Record doctor's response to a hospital challenge on a sanction letter (e.g., Final Approval Letter)
export const respondToSanctionChallenge = async (applicationId, letterId, { decision, comment = '', doctorId, doctorName = '' }) => {
  try {
    if (!['accept_revision', 'not_accept'].includes(decision)) {
      return { success: false, error: 'Invalid decision' };
    }

    // Update the sanction document with doctor's response
    const sanctionRef = doc(db, 'sanctions', letterId);
    await updateDoc(sanctionRef, {
      doctorResponse: {
        decision,
        comment: comment || '',
        by: doctorId || null,
        byName: doctorName || null,
        at: new Date(),
      },
      updatedAt: new Date(),
    });

    // Optionally mirror a lightweight acknowledgement on application workflow for quick checks
    try {
      const appQuery = query(
        collection(db, 'patientApplications'),
        where('applicationId', '==', applicationId)
      );
      const appSnapshot = await getDocs(appQuery);
      if (!appSnapshot.empty) {
        const appRef = doc(db, 'patientApplications', appSnapshot.docs[0].id);
        await updateDoc(appRef, {
          [`workflow.acknowledgements.${letterId}.doctorResponse`]: {
            decision,
            comment: comment || '',
            at: new Date(),
          },
          updatedAt: new Date(),
        });
      }
    } catch (_) {
      // Best-effort, ignore if fails
    }

    return { success: true };
  } catch (error) {
    console.error('Error responding to sanction challenge:', error);
    return { success: false, error: error.message };
  }
};

// Approve or reject a sanction letter (e.g., Final Approval Letter). On approve, publish quicklink for hospital visibility.
export const setSanctionApproval = async (applicationId, letterId, { status, reason = '', doctorId, doctorName = '' }) => {
  try {
    if (!['approved', 'rejected'].includes(status)) {
      return { success: false, error: 'Invalid status' };
    }

    const sanctionRef = doc(db, 'sanctions', letterId);
    // Read sanction to get URL
    const sanctionSnap = await getDoc(sanctionRef);
    if (!sanctionSnap.exists()) {
      return { success: false, error: 'Sanction letter not found' };
    }
    const sanction = sanctionSnap.data();

    await updateDoc(sanctionRef, {
      doctorApproval: {
        status,
        reason: reason || '',
        by: doctorId || null,
        byName: doctorName || null,
        at: new Date(),
      },
      updatedAt: new Date(),
    });

    if (status === 'approved' && sanction?.type === 'approval' && sanction?.url) {
      // Publish quick link for the approval letter on the application document
      const appQuery = query(
        collection(db, 'patientApplications'),
        where('applicationId', '==', applicationId)
      );
      const appSnapshot = await getDocs(appQuery);
      if (!appSnapshot.empty) {
        const appRef = doc(db, 'patientApplications', appSnapshot.docs[0].id);
        await updateDoc(appRef, {
          'workflow.dischargeSettlement.finalApprovalLetterUrl': sanction.url,
          'workflow.dischargeSettlement.finalApprovalLetterId': letterId,
          updatedAt: new Date(),
        });

        // Fire-and-forget: Email when FAL is approved/published
        (async () => {
          try {
            const subject = `FAL Generated: ${applicationId}`;
            const html = `<!DOCTYPE html><html><body style=\"font-family:Arial,Helvetica,sans-serif;line-height:1.5;color:#0f172a;\">\n<h2 style=\"color:#0f766e;margin:0 0 12px;\">Final Approval Letter Generated</h2>\n<p style=\"margin:0 0 8px;\">A Final Approval Letter has been generated for application <strong>${applicationId}</strong>.</p>\n<p style=\"margin:8px 0 0;font-size:12px;color:#64748b;\">This is an automated notification.</p>\n</body></html>`;
            await sendEmail({ to: 'cssg@samhealth.co.in', subject, html });
          } catch (e) {
            console.warn('Non-blocking email failed (setSanctionApproval:FAL):', e?.message || e);
          }
        })();
      }
    }

    return { success: true };
  } catch (error) {
    console.error('Error setting sanction approval:', error);
    return { success: false, error: error.message };
  }
};

// Revoke a previously approved/published Final Approval Letter (FAL)
// This will: mark the sanction doctorApproval as 'revoked' with reason, and remove the quick link from application
export const revokeFalPublication = async (applicationId, { reason = '', doctorId, doctorName = '' } = {}) => {
  try {
    // Find application by applicationId to fetch stored FAL linkage
    const appQuery = query(
      collection(db, 'patientApplications'),
      where('applicationId', '==', applicationId)
    );
    const appSnapshot = await getDocs(appQuery);
    if (appSnapshot.empty) {
      return { success: false, error: 'Application not found' };
    }
    const appDoc = appSnapshot.docs[0];
    const appRef = doc(db, 'patientApplications', appDoc.id);
    const appData = appDoc.data();

    const letterId = appData?.workflow?.dischargeSettlement?.finalApprovalLetterId;
    const letterUrl = appData?.workflow?.dischargeSettlement?.finalApprovalLetterUrl;
    if (!letterId || !letterUrl) {
      return { success: false, error: 'No published FAL found to revoke' };
    }

    // Update sanction doctorApproval to 'revoked'
    const sanctionRef = doc(db, 'sanctions', letterId);
    const sanctionSnap = await getDoc(sanctionRef);
    if (sanctionSnap.exists()) {
      await updateDoc(sanctionRef, {
        doctorApproval: {
          status: 'revoked',
          reason: reason || '',
          by: doctorId || null,
          byName: doctorName || null,
          at: new Date(),
        },
        updatedAt: new Date(),
      });
    }

    // Remove quick link from application so hospital can no longer access the published URL
    await updateDoc(appRef, {
      'workflow.dischargeSettlement.finalApprovalLetterUrl': null,
      'workflow.dischargeSettlement.finalApprovalLetterId': null,
      updatedAt: new Date(),
    });

    return { success: true };
  } catch (error) {
    console.error('Error revoking FAL publication:', error);
    return { success: false, error: error.message };
  }
};

// Set or update discharge settlement comments (used in Final Approval Letter notes)
export const setDischargeSettlementComments = async (applicationId, comments) => {
  try {
    const appQuery = query(
      collection(db, 'patientApplications'),
      where('applicationId', '==', applicationId)
    );
    const appSnapshot = await getDocs(appQuery);
    if (appSnapshot.empty) {
      return { success: false, error: 'Application not found' };
    }
    const appRef = doc(db, 'patientApplications', appSnapshot.docs[0].id);
    await updateDoc(appRef, {
      'workflow.dischargeSettlement.comments': comments || '',
      updatedAt: new Date(),
    });
    return { success: true };
  } catch (error) {
    console.error('Error updating discharge settlement comments:', error);
    return { success: false, error: error.message };
  }
};

// Save discharge review as draft (autosave or manual)
export const saveDischargeDraft = async (applicationId, doctorId, draftData = {}) => {
  try {
    // Helpers to sanitize payload for Firestore (no undefined allowed)
    const normalizeNumber = (val) => {
      if (val === '' || val === undefined || val === null) return null;
      const n = Number(val);
      return Number.isFinite(n) ? n : null;
    };
    const cleanObject = (value) => {
      if (Array.isArray(value)) return value.map(cleanObject);
      if (value && typeof value === 'object' && !(value instanceof Date) && !(value instanceof File) && !(value instanceof Blob)) {
        const out = {};
        Object.keys(value).forEach((k) => {
          const v = cleanObject(value[k]);
          if (v !== undefined) out[k] = v;
        });
        return out;
      }
      // Convert explicit undefined to null so Firestore accepts the field
      return value === undefined ? null : value;
    };

    // Compute light totals if items present
    let totalBilled = 0;
    let totalEligible = 0;
    const rawItems = Array.isArray(draftData.items) ? draftData.items : [];
    // Sanitize item entries to avoid undefined/NaN
    const items = rawItems.map((it) => ({
      ...it,
      unitRate: normalizeNumber(it.unitRate),
      eligibleUnitRate: normalizeNumber(it.eligibleUnitRate),
      quantity: normalizeNumber(it.quantity),
      billedAmount: normalizeNumber(it.billedAmount) ?? 0,
      eligibleAmount: normalizeNumber(it.eligibleAmount) ?? 0,
      approved: it.approved === false ? false : true,
    }));

    items.forEach((it) => {
      const billed = Number(it.billedAmount ?? 0) || 0;
      const eligible = Number(it.eligibleAmount ?? 0) || 0;
      if (it.approved !== false) {
        totalBilled += billed;
        totalEligible += eligible;
      }
    });

    const payload = {
      applicationId,
      status: 'draft',
      items,
      doctorComments: draftData.comments || '',
      uploadedFiles: draftData.uploadedFiles || [],
      // CRITICAL FIX: Save FAL overrides and manual adjustments so other doctors can see them
      falOverrides: draftData.falOverrides ? cleanObject(draftData.falOverrides) : null,
      falManualAdjustments: draftData.falManualAdjustments ? cleanObject(draftData.falManualAdjustments) : null,
      falComputedPreview: draftData.falComputedPreview ? cleanObject(draftData.falComputedPreview) : null,
      totals: {
        totalBilled,
        totalEligible,
        totalVariance: totalBilled - totalEligible,
        eligibilityPercentage: totalBilled > 0 ? ((totalEligible / totalBilled) * 100).toFixed(2) : 0,
      },
      updatedBy: doctorId || null,
      updatedAt: new Date(),
      lastAutoSaveAt: draftData.autoSaved ? new Date() : null,
      autoSaved: !!draftData.autoSaved,
    };

    const cleanedPayload = cleanObject(payload);

    // Upsert a discharge summary doc for this application
    const q = query(collection(db, 'dischargeSummaries'), where('applicationId', '==', applicationId));
    const snap = await getDocs(q);
    if (snap.empty) {
      await addDoc(collection(db, 'dischargeSummaries'), cleanedPayload);
    } else {
      const ref = doc(db, 'dischargeSummaries', snap.docs[0].id);
      await updateDoc(ref, cleanedPayload);
    }

    return { success: true };
  } catch (error) {
    console.error('Error saving discharge draft:', error);
    return { success: false, error: error.message };
  }
};

// Reject application with reason
export const rejectApplication = async (applicationId, doctorId, { reason, doctorName }) => {
  try {
    // Resolve real Firestore document by external applicationId (not the same as doc id)
    const { success, ref, error } = await getApplicationDocRef(applicationId);
    if (!success) {
      return { success: false, error: error || 'Application not found' };
    }

    const now = new Date();
    const updateData = {
      status: 'rejected',
      'workflow.medicalReview.status': 'rejected',
      'workflow.medicalReview.reviewerId': doctorId,
      'workflow.medicalReview.rejectedAt': now,
      'workflow.medicalReview.rejectedBy': doctorName,
      'workflow.medicalReview.rejectionReason': reason,
      'workflow.medicalReview.completedAt': now,
      updatedAt: now,
      // Maintain a central statusHistory block similar to updateApplicationStatus helper
      [`statusHistory.rejected`]: {
        updatedBy: doctorId || null,
        updatedByName: doctorName || null,
        updatedAt: now,
        comments: reason || '',
        source: 'doctor_reject'
      }
    };

    await updateDoc(ref, updateData);
    return { success: true };
  } catch (error) {
    console.error('Error rejecting application:', error);
    return { success: false, error: error.message };
  }
};

// Mark medical review flow as completed (used when hospital accepts the FAL)
export const markMedicalReviewCompleted = async (applicationId, {
  doctorId = null,
  doctorName = ''
} = {}) => {
  try {
    // Find application doc by applicationId field for consistency across codebase
    const appQuery = query(
      collection(db, 'patientApplications'),
      where('applicationId', '==', applicationId)
    );
    const appSnapshot = await getDocs(appQuery);
    if (appSnapshot.empty) {
      return { success: false, error: 'Application not found' };
    }
    const appRef = doc(db, 'patientApplications', appSnapshot.docs[0].id);

    await updateDoc(appRef, {
      'workflow.medicalReview.status': 'completed',
      'workflow.medicalReview.completedAt': new Date(),
      // Don't override reviewer if not provided; just record last updater names optionally
      ...(doctorId ? { 'workflow.medicalReview.lastUpdatedBy': doctorId } : {}),
      ...(doctorName ? { 'workflow.medicalReview.lastUpdatedByName': doctorName } : {}),
      updatedAt: new Date(),
    });

    return { success: true };
  } catch (error) {
    console.error('Error marking medical review completed:', error);
    return { success: false, error: error.message };
  }
};

// Helper to derive application stage for Policy dashboard bifurcation
// Stages: 'new', 'query', 'kyp_challenge', 'kyp_counselling_pending', 'discharge_counselling_pending'
const deriveStageForPolicy = (application) => {
  const w = application?.workflow || {};
  const mv = w.medicalVerification || {};
  const pv = w.policyVerification || {};
  const ds = w.dischargeSettlement || {};

  // 1) Query: disputes or policy clarification pending
  if (
    application?.status === 'dispute_pending' ||
    application?.status === 'pending_policy_clarification' ||
    pv?.status === 'pending_info'
  ) {
    return 'query';
  }

  // 2) KYP challenged by hospital
  const kypAckStatus = mv?.kypHospitalAcknowledgement?.status || mv?.kypAck || mv?.kypStatus;
  if (kypAckStatus === 'challenged') {
    return 'kyp_challenge';
  }

  // 3) Discharge counselling pending (post-approval / discharge started) and not completed
  const dc = pv?.dischargeCounselling;
  const dischargeCounsellingPending = (!dc || ['pending', 'scheduled', 'in-progress'].includes(dc?.status)) && (
    application?.dischargeInitiated || !!ds?.status || pv?.status === 'approved' || application?.status === 'approved' || application?.status === 'policy_approved'
  );
  if (dischargeCounsellingPending) {
    return 'discharge_counselling_pending';
  }

  // 4) KYP initial counselling pending (pre-discharge) and not completed
  const kic = pv?.kypInitialCounselling;
  const kypCounsellingPending = (!kic || ['pending', 'scheduled', 'in-progress'].includes(kic?.status)) && (
    pv?.status === 'approved' || application?.status === 'policy_approved' || application?.status === 'policy_review_pending' || application?.status === 'medical_approved'
  );
  if (kypCounsellingPending) {
    return 'kyp_counselling_pending';
  }

  // 5) New (default)
  return 'new';
};

// Save computed discharge settlement (from FAL computation engine)
// This function intentionally does not generate PDFs; it only persists computed numbers and breakdowns.
export const saveComputedDischargeSettlement = async (
  applicationId,
  computed,
  meta = {}
) => {
  try {
    const appQuery = query(
      collection(db, "patientApplications"),
      where("applicationId", "==", applicationId)
    );
    const appSnapshot = await getDocs(appQuery);
    if (appSnapshot.empty) {
      return { success: false, error: "Application not found" };
    }
    const appRef = doc(db, "patientApplications", appSnapshot.docs[0].id);

    // Normalize payload and keep backward compatibility with existing ds fields
    const dsUpdate = {
      status: "computed", // marker before final approval/publish
      itemsBreakdown: computed?.items || [],
      totals: computed?.totals || {},
      deductions: {
        nonAdmissibles: computed?.totals?.nonAdmissibles || 0,
        proportionate: computed?.totals?.proportionate || 0,
        sublimits: computed?.totals?.sublimits || 0,
        deductible: computed?.totals?.deductible || 0,
        copay: computed?.totals?.copay || 0,
      },
      adjustments: Array.isArray(meta.manualAdjustments) ? meta.manualAdjustments : (computed?.breakdown?.find?.(b => b.key === 'manual_adjustments')?.meta || []),
      finalSettlementAmount: computed?.totals?.finalSettlement || 0,
      overrideMeta: computed?.overridesMeta || {},
      version: computed?.version || 1,
      updatedAt: new Date(),
      updatedBy: meta?.by || null,
    };

    await updateDoc(appRef, {
      'workflow.dischargeSettlement': {
        ...(appSnapshot.docs[0].data()?.workflow?.dischargeSettlement || {}),
        ...dsUpdate,
      },
      updatedAt: new Date(),
    });

    return { success: true };
  } catch (error) {
    console.error("Error saving computed discharge settlement:", error);
    return { success: false, error: error.message };
  }
};

// Persist doctor's approval for the computed discharge settlement so UI can remain approved after refresh
export const setDischargeSettlementApproval = async (
  applicationId,
  { approved = true, by = null, byName = '', notes = '' } = {}
) => {
  try {
    const appQuery = query(
      collection(db, 'patientApplications'),
      where('applicationId', '==', applicationId)
    );
    const appSnapshot = await getDocs(appQuery);
    if (appSnapshot.empty) {
      return { success: false, error: 'Application not found' };
    }

    const appRef = doc(db, 'patientApplications', appSnapshot.docs[0].id);
    const now = new Date();
    await updateDoc(appRef, {
      'workflow.dischargeSettlement.calculationApproved': !!approved,
      'workflow.dischargeSettlement.calculationApprovedAt': now,
      'workflow.dischargeSettlement.calculationApprovedBy': by || null,
      'workflow.dischargeSettlement.calculationApprovedByName': byName || null,
      ...(notes ? { 'workflow.dischargeSettlement.calculationApprovalNotes': notes } : {}),
      // Optional progression marker
      'workflow.dischargeSettlement.status': approved ? 'approved_by_doctor' : 'computed',
      updatedAt: now,
    });

    return { success: true };
  } catch (error) {
    console.error('Error setting discharge settlement approval:', error);
    return { success: false, error: error.message };
  }
};